/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

export interface AccessRequestDto {
    'id'?: string;
    'userId'?: string;
    'userName'?: string;
    'userEmail'?: string;
    'status'?: AccessRequestDtoStatusEnum;
    'requestedAt'?: string;
    'businessEntityId'?: string;
    'businessEntityName'?: string;
}

export const AccessRequestDtoStatusEnum = {
    Pending: 'PENDING',
    Approved: 'APPROVED',
    Rejected: 'REJECTED',
    Revoked: 'REVOKED',
    Cancelled: 'CANCELLED',
} as const;

export type AccessRequestDtoStatusEnum = typeof AccessRequestDtoStatusEnum[keyof typeof AccessRequestDtoStatusEnum];

export interface AddAdditionalFileRequestDto {
    'fileName': string;
}
export interface AddAdditionalFileResponseDto {
    'campaignId'?: string;
    'uploadUrl'?: string;
}
export interface AddCreativesResponseDto {
    'campaignId'?: string;
    'creatives'?: Array<CreativeUploadDto>;
}
export interface AddPicturesResponseDto {
    'outdoorId'?: string;
    'uploadUrls'?: Array<ImageDto>;
}
export interface AddressDto {
    'countryCode'?: string;
    'firstLine'?: string;
    'city'?: string;
    'state'?: string;
    'postCode'?: string;
}
export interface AdminSectionCountDto {
    'type'?: AdminSectionCountDtoTypeEnum;
    'count'?: number;
    'ids'?: Array<string>;
}

export const AdminSectionCountDtoTypeEnum = {
    ProofOfCompany: 'PROOF_OF_COMPANY',
    AdCreatives: 'AD_CREATIVES',
    ProofOfAds: 'PROOF_OF_ADS',
    MissingProofOfAds: 'MISSING_PROOF_OF_ADS',
    TransferRequestedPayments: 'TRANSFER_REQUESTED_PAYMENTS',
    AccessRequests: 'ACCESS_REQUESTS',
    UnpaidInstallments: 'UNPAID_INSTALLMENTS',
} as const;

export type AdminSectionCountDtoTypeEnum = typeof AdminSectionCountDtoTypeEnum[keyof typeof AdminSectionCountDtoTypeEnum];

export interface AdvertiserConfirmationDto {
    'decision': AdvertiserConfirmationDtoDecisionEnum;
}

export const AdvertiserConfirmationDtoDecisionEnum = {
    Confirm: 'CONFIRM',
    Cancel: 'CANCEL',
} as const;

export type AdvertiserConfirmationDtoDecisionEnum = typeof AdvertiserConfirmationDtoDecisionEnum[keyof typeof AdvertiserConfirmationDtoDecisionEnum];

export interface AdvertiserDto {
    'id'?: string;
    'name'?: string;
    'vatNumber'?: string;
    'remainingFreeCommissions'?: number;
}
export interface AdvertiserOverviewDto {
    'id'?: string;
    'name'?: string;
    'vatNumber'?: string;
    'activeOutdoors'?: number;
    'activeCampaigns'?: number;
    'spendings'?: Array<ValueInCurrencyDto>;
    'proofOfCompanyUrl'?: string;
}
export interface BankDetailsDto {
    'iban': string;
    'swiftCode': string;
}
export interface BusinessDetailsDto {
    'id'?: string;
    'name'?: string;
}
export interface BusinessEntityCampaignAggregationDto {
    'businessEntityId'?: string;
    'status'?: BusinessEntityCampaignAggregationDtoStatusEnum;
    'numberOfCampaigns'?: number;
}

export const BusinessEntityCampaignAggregationDtoStatusEnum = {
    Pending: 'PENDING',
    AwaitingPayment: 'AWAITING_PAYMENT',
    Confirming: 'CONFIRMING',
    AwaitingConfirmation: 'AWAITING_CONFIRMATION',
    Ready: 'READY',
    Running: 'RUNNING',
    Completed: 'COMPLETED',
    Cancelled: 'CANCELLED',
    Unavailable: 'UNAVAILABLE',
} as const;

export type BusinessEntityCampaignAggregationDtoStatusEnum = typeof BusinessEntityCampaignAggregationDtoStatusEnum[keyof typeof BusinessEntityCampaignAggregationDtoStatusEnum];

export interface BusinessEntityDto {
    'id'?: string;
    'name'?: string;
    'vatNumber'?: string;
    'iban'?: string;
    'swiftCode'?: string;
    'type'?: BusinessEntityDtoTypeEnum;
    'verified'?: boolean;
    'countryDto'?: CountryDto;
    'currencyDto'?: CurrencyDto;
    'email'?: string;
    'verificationStatus'?: BusinessEntityDtoVerificationStatusEnum;
    'preferredCurrency'?: string;
    'portugalType'?: BusinessEntityDtoPortugalTypeEnum;
    'address'?: AddressDto;
    'remainingFreeCommissions'?: number;
    'proofOfCompanyUrl'?: string;
}

export const BusinessEntityDtoTypeEnum = {
    PlacementProvider: 'PLACEMENT_PROVIDER',
    Advertiser: 'ADVERTISER',
} as const;

export type BusinessEntityDtoTypeEnum = typeof BusinessEntityDtoTypeEnum[keyof typeof BusinessEntityDtoTypeEnum];
export const BusinessEntityDtoVerificationStatusEnum = {
    Pending: 'PENDING',
    Validating: 'VALIDATING',
    Valid: 'VALID',
} as const;

export type BusinessEntityDtoVerificationStatusEnum = typeof BusinessEntityDtoVerificationStatusEnum[keyof typeof BusinessEntityDtoVerificationStatusEnum];
export const BusinessEntityDtoPortugalTypeEnum = {
    Continent: 'CONTINENT',
    Azores: 'AZORES',
    Madeira: 'MADEIRA',
} as const;

export type BusinessEntityDtoPortugalTypeEnum = typeof BusinessEntityDtoPortugalTypeEnum[keyof typeof BusinessEntityDtoPortugalTypeEnum];

export interface BusinessInvitationDto {
    'id'?: string;
    'email'?: string;
    'invitedAt'?: string;
    'businessEntityId'?: string;
    'businessEntityName'?: string;
}
export interface BusinessProofDto {
    'businessEntityId'?: string;
    'name'?: string;
    'fileId'?: string;
    'url'?: string;
}
export interface CampaignApprovalsDto {
    'campaignId'?: string;
    'campaignName'?: string;
    'advertiserName'?: string;
    'confirmationDeadline'?: string;
    'campaignOutdoors'?: Array<CampaignOutdoorApprovalDto>;
}
export interface CampaignInvoiceRequestDto {
    'fileName': string;
}
export interface CampaignMessageDto {
    'id'?: string;
    'campaignId'?: string;
    'fromUser'?: UserDetailsDto;
    'fromBusinessEntity'?: BusinessDetailsDto;
    'toBusinessEntity'?: BusinessDetailsDto;
    'text'?: string;
    'sentAt'?: string;
}
export interface CampaignMessageProjectionDto {
    'businessEntity'?: BusinessDetailsDto;
    'sentAt'?: string;
}
export interface CampaignOutdoorApprovalDto {
    'campaignOutdoorId'?: string;
    'outdoorId'?: string;
    'outdoorName'?: string;
    'startDate'?: string;
    'endDate'?: string;
    'value'?: number;
    'currency'?: string;
    'feedbackStatus'?: CampaignOutdoorApprovalDtoFeedbackStatusEnum;
}

export const CampaignOutdoorApprovalDtoFeedbackStatusEnum = {
    Confirming: 'CONFIRMING',
    Approved: 'APPROVED',
    Unavailable: 'UNAVAILABLE',
    Expired: 'EXPIRED',
} as const;

export type CampaignOutdoorApprovalDtoFeedbackStatusEnum = typeof CampaignOutdoorApprovalDtoFeedbackStatusEnum[keyof typeof CampaignOutdoorApprovalDtoFeedbackStatusEnum];

export interface CampaignOutdoorCostDto {
    'campaignOutdoorSnapshotId'?: string;
    'campaignOutdoorId'?: string;
    'outdoorId'?: string;
    'outdoorName'?: string;
    'dailyValueWithCommission'?: number;
    'dailyValueWithCommissionAndDiscount'?: number;
    'totalAdsValueWithVat'?: number;
    'actualCommission'?: number;
    'vatValue'?: number;
    'vatPercentage'?: number;
    'numberOfDaysBooked'?: number;
    'productionCost'?: number;
    'totalCost'?: number;
    'discount'?: number;
    'currencyCode'?: string;
}
export interface CampaignOutdoorDto {
    'id'?: string;
    'name'?: string;
    'campaignId'?: string;
    'outdoorId'?: string;
    'startDate'?: string;
    'endDate'?: string;
    'status'?: CampaignOutdoorDtoStatusEnum;
    'imageRatio'?: number;
    'longitude'?: number;
    'latitude'?: number;
    'proofOfImageId'?: string;
    'proofImageUrl'?: string;
    'imageUrl'?: string;
    'proofOfAdStatus'?: CampaignOutdoorDtoProofOfAdStatusEnum;
    'feedbackStatus'?: CampaignOutdoorDtoFeedbackStatusEnum;
}

export const CampaignOutdoorDtoStatusEnum = {
    Pending: 'PENDING',
    Verifying: 'VERIFYING',
    ForManualApproval: 'FOR_MANUAL_APPROVAL',
    Approved: 'APPROVED',
    Rejected: 'REJECTED',
    Refunded: 'REFUNDED',
    Cancelled: 'CANCELLED',
} as const;

export type CampaignOutdoorDtoStatusEnum = typeof CampaignOutdoorDtoStatusEnum[keyof typeof CampaignOutdoorDtoStatusEnum];
export const CampaignOutdoorDtoProofOfAdStatusEnum = {
    Pending: 'PENDING',
    Valid: 'VALID',
    ManualValidation: 'MANUAL_VALIDATION',
    Invalid: 'INVALID',
} as const;

export type CampaignOutdoorDtoProofOfAdStatusEnum = typeof CampaignOutdoorDtoProofOfAdStatusEnum[keyof typeof CampaignOutdoorDtoProofOfAdStatusEnum];
export const CampaignOutdoorDtoFeedbackStatusEnum = {
    Confirming: 'CONFIRMING',
    Approved: 'APPROVED',
    Unavailable: 'UNAVAILABLE',
    Expired: 'EXPIRED',
} as const;

export type CampaignOutdoorDtoFeedbackStatusEnum = typeof CampaignOutdoorDtoFeedbackStatusEnum[keyof typeof CampaignOutdoorDtoFeedbackStatusEnum];

export interface CampaignOutdoorFeedbackDto {
    'campaignOutdoorId': string;
    'outdoorId': string;
    'status': CampaignOutdoorFeedbackDtoStatusEnum;
    'blockedTimeRange'?: TimeRangeDto;
}

export const CampaignOutdoorFeedbackDtoStatusEnum = {
    Confirming: 'CONFIRMING',
    Approved: 'APPROVED',
    Unavailable: 'UNAVAILABLE',
    Expired: 'EXPIRED',
} as const;

export type CampaignOutdoorFeedbackDtoStatusEnum = typeof CampaignOutdoorFeedbackDtoStatusEnum[keyof typeof CampaignOutdoorFeedbackDtoStatusEnum];

export interface CampaignOutdoorProjectionDto {
    'campaignOutdoorId'?: string;
    'startDate'?: string;
    'endDate'?: string;
    'blockedDate'?: boolean;
}
export interface CampaignOutdoorProofDto {
    'campaignOutdoorId'?: string;
    'uploadUrl'?: string;
}
export interface CampaignOutdoorRefundDto {
    'campaignOutdoorId': string;
    'numberOfDays'?: number;
}
export interface CampaignPaymentDto {
    'campaignId'?: string;
    'isPaid'?: boolean;
    'campaignStatus'?: CampaignPaymentDtoCampaignStatusEnum;
}

export const CampaignPaymentDtoCampaignStatusEnum = {
    Pending: 'PENDING',
    AwaitingPayment: 'AWAITING_PAYMENT',
    Confirming: 'CONFIRMING',
    AwaitingConfirmation: 'AWAITING_CONFIRMATION',
    Cancelled: 'CANCELLED',
    Ready: 'READY',
    Running: 'RUNNING',
    Completed: 'COMPLETED',
    Unavailable: 'UNAVAILABLE',
} as const;

export type CampaignPaymentDtoCampaignStatusEnum = typeof CampaignPaymentDtoCampaignStatusEnum[keyof typeof CampaignPaymentDtoCampaignStatusEnum];

export interface CampaignProjectionDto {
    'campaignId'?: string;
    'campaignName'?: string;
    'startDate'?: string;
    'endDate'?: string;
    'imageUrl'?: string;
    'status'?: CampaignProjectionDtoStatusEnum;
    'verificationStatus'?: CampaignProjectionDtoVerificationStatusEnum;
}

export const CampaignProjectionDtoStatusEnum = {
    Pending: 'PENDING',
    AwaitingPayment: 'AWAITING_PAYMENT',
    Confirming: 'CONFIRMING',
    AwaitingConfirmation: 'AWAITING_CONFIRMATION',
    Ready: 'READY',
    Running: 'RUNNING',
    Completed: 'COMPLETED',
    Cancelled: 'CANCELLED',
    Unavailable: 'UNAVAILABLE',
} as const;

export type CampaignProjectionDtoStatusEnum = typeof CampaignProjectionDtoStatusEnum[keyof typeof CampaignProjectionDtoStatusEnum];
export const CampaignProjectionDtoVerificationStatusEnum = {
    Pending: 'PENDING',
    Partial: 'PARTIAL',
    Verified: 'VERIFIED',
} as const;

export type CampaignProjectionDtoVerificationStatusEnum = typeof CampaignProjectionDtoVerificationStatusEnum[keyof typeof CampaignProjectionDtoVerificationStatusEnum];

export interface CampaignRefundsDto {
    'refunds': Array<CampaignOutdoorRefundDto>;
}
export interface CampaignResponseDto {
    'id'?: string;
    'type'?: CampaignResponseDtoTypeEnum;
    'name'?: string;
    'advertiserId'?: string;
    'placementProviderId'?: string;
    'notes'?: string;
    'campaignStatus'?: CampaignResponseDtoCampaignStatusEnum;
    'campaignOutdoors'?: Array<CampaignOutdoorDto>;
    'advertiserPaymentStatus'?: CampaignResponseDtoAdvertiserPaymentStatusEnum;
    'creatives'?: Array<CreativeResponseDto>;
    'details'?: string;
    'requiredImageRatios'?: Array<number>;
    'instructions'?: string;
    'createdAt'?: string;
    'placementProviderInvoices'?: Array<PlacementProviderInvoiceDto>;
    'additionalFiles'?: Array<UploadedFileDto>;
    'outdoorsByCreativeRatio'?: { [key: string]: Array<OutdoorProjectionDto>; };
    'valueForPlacementProviderInCurrency'?: number;
    'vatValueForPlacementProviderInCurrency'?: number;
    'currency'?: string;
    'placementProviderCampaignOutdoorCosts'?: Array<PlacementProviderCampaignOutdoorCostDto>;
    'acceptedTermsAndConditions'?: boolean;
    'paymentPlan'?: CampaignResponseDtoPaymentPlanEnum;
    'numberOfInstallments'?: number;
    'confirmationDeadline'?: string;
    'advertiserConfirmationDeadline'?: string;
    'paymentBreakdown'?: Array<PaymentBreakdownDto>;
}

export const CampaignResponseDtoTypeEnum = {
    Scapow: 'SCAPOW',
    Offline: 'OFFLINE',
} as const;

export type CampaignResponseDtoTypeEnum = typeof CampaignResponseDtoTypeEnum[keyof typeof CampaignResponseDtoTypeEnum];
export const CampaignResponseDtoCampaignStatusEnum = {
    Pending: 'PENDING',
    AwaitingPayment: 'AWAITING_PAYMENT',
    Confirming: 'CONFIRMING',
    AwaitingConfirmation: 'AWAITING_CONFIRMATION',
    Cancelled: 'CANCELLED',
    Ready: 'READY',
    Running: 'RUNNING',
    Completed: 'COMPLETED',
    Unavailable: 'UNAVAILABLE',
} as const;

export type CampaignResponseDtoCampaignStatusEnum = typeof CampaignResponseDtoCampaignStatusEnum[keyof typeof CampaignResponseDtoCampaignStatusEnum];
export const CampaignResponseDtoAdvertiserPaymentStatusEnum = {
    Pending: 'PENDING',
    ValidatingPayment: 'VALIDATING_PAYMENT',
    ManualValidation: 'MANUAL_VALIDATION',
    TransferRequested: 'TRANSFER_REQUESTED',
    Paid: 'PAID',
    Cancelled: 'CANCELLED',
    PartiallyRefunded: 'PARTIALLY_REFUNDED',
    FullyRefunded: 'FULLY_REFUNDED',
    Failed: 'FAILED',
} as const;

export type CampaignResponseDtoAdvertiserPaymentStatusEnum = typeof CampaignResponseDtoAdvertiserPaymentStatusEnum[keyof typeof CampaignResponseDtoAdvertiserPaymentStatusEnum];
export const CampaignResponseDtoPaymentPlanEnum = {
    Total: 'TOTAL',
    Monthly: 'MONTHLY',
    Trimonthly: 'TRIMONTHLY',
} as const;

export type CampaignResponseDtoPaymentPlanEnum = typeof CampaignResponseDtoPaymentPlanEnum[keyof typeof CampaignResponseDtoPaymentPlanEnum];

export interface CampaignSearchProjectionDto {
    'campaignId'?: string;
    'campaignName'?: string;
    'campaignStatus'?: CampaignSearchProjectionDtoCampaignStatusEnum;
    'startDate'?: string;
    'endDate'?: string;
    'numberOfOutdoors'?: number;
    'creativeUrl'?: string;
}

export const CampaignSearchProjectionDtoCampaignStatusEnum = {
    Pending: 'PENDING',
    AwaitingPayment: 'AWAITING_PAYMENT',
    Confirming: 'CONFIRMING',
    AwaitingConfirmation: 'AWAITING_CONFIRMATION',
    Ready: 'READY',
    Running: 'RUNNING',
    Completed: 'COMPLETED',
    Cancelled: 'CANCELLED',
    Unavailable: 'UNAVAILABLE',
} as const;

export type CampaignSearchProjectionDtoCampaignStatusEnum = typeof CampaignSearchProjectionDtoCampaignStatusEnum[keyof typeof CampaignSearchProjectionDtoCampaignStatusEnum];

export interface CheckoutSessionDto {
    'id'?: string;
    'url'?: string;
    'clientSecret'?: string;
    'step'?: CheckoutSessionDtoStepEnum;
}

export const CheckoutSessionDtoStepEnum = {
    DirectDebitMandate: 'DIRECT_DEBIT_MANDATE',
    CardPayment: 'CARD_PAYMENT',
} as const;

export type CheckoutSessionDtoStepEnum = typeof CheckoutSessionDtoStepEnum[keyof typeof CheckoutSessionDtoStepEnum];

export interface CommissionsDto {
    'placementProviderPercentage'?: number;
    'advertiserPercentage'?: number;
}
export interface CountryDto {
    'id'?: string;
    'name'?: string;
}
export interface CreateBusinessEntityRequestDto {
    'name': string;
    'vatNumber': string;
    'email'?: string;
    'companyProofFileName': string;
    'type': CreateBusinessEntityRequestDtoTypeEnum;
    'countryId': string;
    'currencyId'?: string;
    'iban': string;
    'swiftCode': string;
    'portugalType'?: CreateBusinessEntityRequestDtoPortugalTypeEnum;
    'firstLine': string;
    'city': string;
    'state'?: string;
    'postCode': string;
}

export const CreateBusinessEntityRequestDtoTypeEnum = {
    PlacementProvider: 'PLACEMENT_PROVIDER',
    Advertiser: 'ADVERTISER',
} as const;

export type CreateBusinessEntityRequestDtoTypeEnum = typeof CreateBusinessEntityRequestDtoTypeEnum[keyof typeof CreateBusinessEntityRequestDtoTypeEnum];
export const CreateBusinessEntityRequestDtoPortugalTypeEnum = {
    Continent: 'CONTINENT',
    Azores: 'AZORES',
    Madeira: 'MADEIRA',
} as const;

export type CreateBusinessEntityRequestDtoPortugalTypeEnum = typeof CreateBusinessEntityRequestDtoPortugalTypeEnum[keyof typeof CreateBusinessEntityRequestDtoPortugalTypeEnum];

export interface CreateBusinessEntityResponseDto {
    'id'?: string;
    'name'?: string;
    'email'?: string;
    'vatNumber'?: string;
    'proofOfCompanyUploadUrl'?: string;
    'iban'?: string;
    'swiftCode'?: string;
}
export interface CreateCampaignMessageDto {
    'toBusinessEntityId'?: string;
    'message'?: string;
}
export interface CreateOutdoorSlotRequestDto {
    'outdoorId': string;
    'startDate': string;
    'endDate': string;
}
export interface CreateUserRequest {
    'email': string;
    'password': string;
    'firstName': string;
    'lastName': string;
}
export interface CreativeRequestDto {
    'fileName': string;
    'ratio': number;
}
export interface CreativeResponseDto {
    'id'?: string;
    'imageUrl'?: string;
    'previewUrl'?: string;
    'ratio'?: number;
    'status'?: CreativeResponseDtoStatusEnum;
}

export const CreativeResponseDtoStatusEnum = {
    Pending: 'PENDING',
    Valid: 'VALID',
    ManualValidation: 'MANUAL_VALIDATION',
    Invalid: 'INVALID',
} as const;

export type CreativeResponseDtoStatusEnum = typeof CreativeResponseDtoStatusEnum[keyof typeof CreativeResponseDtoStatusEnum];

export interface CreativeUploadDto {
    'creativeId'?: string;
    'uploadUrl'?: string;
    'previewUploadUrl'?: string;
}
export interface CurrencyDto {
    'id'?: string;
    'name'?: string;
}
export interface DailyPlatformRevenueDto {
    'date'?: string;
    'valueInCurrency'?: number;
    'revenueInCurrency'?: number;
    'vatValue'?: number;
    'stripeFeesValue'?: number;
}
export interface DebtProjectionDto {
    'debtId'?: string;
    'campaignId'?: string;
    'campaignName'?: string;
    'currentValueInDebt'?: number;
    'currency'?: string;
    'status'?: DebtProjectionDtoStatusEnum;
}

export const DebtProjectionDtoStatusEnum = {
    Outstanding: 'OUTSTANDING',
    Settled: 'SETTLED',
} as const;

export type DebtProjectionDtoStatusEnum = typeof DebtProjectionDtoStatusEnum[keyof typeof DebtProjectionDtoStatusEnum];

export interface DiscountDto {
    'id'?: string;
    'percentage'?: number;
    'moreThanNumberOfDays'?: number;
}
export interface FiltersDto {
    'language'?: FiltersDtoLanguageEnum;
    'translations'?: Array<TranslationDto>;
}

export const FiltersDtoLanguageEnum = {
    Pt: 'PT',
    En: 'EN',
    Es: 'ES',
    Fr: 'FR',
    It: 'IT',
    Cn: 'CN',
    Jp: 'JP',
} as const;

export type FiltersDtoLanguageEnum = typeof FiltersDtoLanguageEnum[keyof typeof FiltersDtoLanguageEnum];

export interface FreeCommissionsDto {
    'businessEntityId'?: string;
    'remainingFreeCommissions'?: number;
}
export interface FreeCommissionsRequestDto {
    'remainingFreeCommissions': number;
}
export interface ImageDto {
    'id'?: string;
    'url'?: string;
}
export interface InfoEmailDto {
    'from': string;
    'name': string;
    'subject': string;
    'body': string;
}
export interface InvoiceProjectionDto {
    'id'?: string;
    'url'?: string;
    'campaignId'?: string;
    'campaignName'?: string;
    'createdAt'?: string;
    'amount'?: number;
    'currency'?: string;
    'placementProviderInvoices'?: Array<PlacementProviderInvoiceDto>;
    'type'?: InvoiceProjectionDtoTypeEnum;
}

export const InvoiceProjectionDtoTypeEnum = {
    Invoice: 'INVOICE',
    CreditNote: 'CREDIT_NOTE',
} as const;

export type InvoiceProjectionDtoTypeEnum = typeof InvoiceProjectionDtoTypeEnum[keyof typeof InvoiceProjectionDtoTypeEnum];

export interface LoginRequestDto {
    'email'?: string;
    'password': string;
}
export interface OfflineCampaignOutdoorDto {
    'id'?: string;
    'outdoorId'?: string;
    'outdoorName'?: string;
    'startDate'?: string;
    'endDate'?: string;
}
export interface OfflineCampaignResponseDto {
    'id'?: string;
    'type'?: OfflineCampaignResponseDtoTypeEnum;
    'placementProviderId'?: string;
    'name'?: string;
    'details'?: string;
    'notes'?: string;
    'instructions'?: string;
    'status'?: OfflineCampaignResponseDtoStatusEnum;
    'createdAt'?: string;
    'campaignOutdoors'?: Array<OfflineCampaignOutdoorDto>;
    'creatives'?: Array<CreativeResponseDto>;
    'additionalFiles'?: Array<UploadedFileDto>;
}

export const OfflineCampaignResponseDtoTypeEnum = {
    Scapow: 'SCAPOW',
    Offline: 'OFFLINE',
} as const;

export type OfflineCampaignResponseDtoTypeEnum = typeof OfflineCampaignResponseDtoTypeEnum[keyof typeof OfflineCampaignResponseDtoTypeEnum];
export const OfflineCampaignResponseDtoStatusEnum = {
    Pending: 'PENDING',
    AwaitingPayment: 'AWAITING_PAYMENT',
    Confirming: 'CONFIRMING',
    AwaitingConfirmation: 'AWAITING_CONFIRMATION',
    Cancelled: 'CANCELLED',
    Ready: 'READY',
    Running: 'RUNNING',
    Completed: 'COMPLETED',
    Unavailable: 'UNAVAILABLE',
} as const;

export type OfflineCampaignResponseDtoStatusEnum = typeof OfflineCampaignResponseDtoStatusEnum[keyof typeof OfflineCampaignResponseDtoStatusEnum];

export interface OutdoorAcceptingCampaignsDto {
    'outdoorIds': Set<string>;
    'acceptingCampaigns'?: boolean;
}
export interface OutdoorBlockedDatesDto {
    'outdoorId'?: string;
    'startDate'?: string;
    'endDate'?: string;
}
export interface OutdoorDailyStateDto {
    'date'?: string;
    'hasCampaignsStarting'?: boolean;
    'hasCampaignsFinishing'?: boolean;
    'hasCampaignsRunning'?: boolean;
    'hasBlockedDates'?: boolean;
}
export interface OutdoorDimensionsDto {
    'width': number;
    'height': number;
}
export interface OutdoorDiscountDto {
    'moreThanNumberOfDays'?: number;
    'percentage'?: number;
}
export interface OutdoorProjectionDto {
    'id'?: string;
    'latitude'?: number;
    'longitude'?: number;
    'name'?: string;
    'description'?: string;
    'valuePerDay'?: number;
    'widthInMetres'?: number;
    'heightInMetres'?: number;
    'distanceToPointInMetres'?: number;
    'imageUrl'?: string;
    'minimumNoticeInDays'?: number;
    'minimumDays'?: number;
    'containsDiscounts'?: boolean;
    'currencyCode'?: string;
    'instantBooking'?: boolean;
    'fullMonthRequired'?: boolean;
    'startAtMonthFirstDay'?: boolean;
}
export interface OutdoorResponseDto {
    'id'?: string;
    'latitude'?: number;
    'longitude'?: number;
    'name'?: string;
    'description'?: string;
    'valuePerDay'?: number;
    'discounts'?: Array<DiscountDto>;
    'widthInMetres'?: number;
    'heightInMetres'?: number;
    'requiredCreativeAspectRatio'?: number;
    'locationImages'?: Array<ImageDto>;
    'blockedTimes'?: Array<TimeRangeDto>;
    'acceptingNewCampaigns'?: boolean;
    'attributeIds'?: Array<number>;
    'productionCost'?: number;
    'minimumDays'?: number;
    'minimumDaysNotice'?: number;
    'bleedInMetres'?: number;
    'illuminated'?: boolean;
    'instantBooking'?: boolean;
    'fullMonthRequired'?: boolean;
    'startAtMonthFirstDay'?: boolean;
    'currency'?: CurrencyDto;
}
export interface OutdoorWithCampaignOutdoorDto {
    'outdoor'?: OutdoorProjectionDto;
    'campaignOutdoor'?: CampaignOutdoorProjectionDto;
}
export interface OutdoorsCsvUploadUrlDto {
    'businessEntityId'?: string;
    'uploadUrl'?: string;
}
export interface OverdueInstallmentDto {
    'id'?: string;
    'advertiserId'?: string;
    'advertiserName'?: string;
    'email'?: string;
    'campaignId'?: string;
    'campaignName'?: string;
    'installmentNumber'?: number;
    'totalInstallments'?: number;
    'valueInCurrency'?: number;
    'currency'?: string;
    'dueDate'?: string;
    'status'?: OverdueInstallmentDtoStatusEnum;
    'unseen'?: boolean;
}

export const OverdueInstallmentDtoStatusEnum = {
    Scheduled: 'SCHEDULED',
    Processing: 'PROCESSING',
    Paid: 'PAID',
    Failed: 'FAILED',
    Cancelled: 'CANCELLED',
} as const;

export type OverdueInstallmentDtoStatusEnum = typeof OverdueInstallmentDtoStatusEnum[keyof typeof OverdueInstallmentDtoStatusEnum];

export interface Pageable {
    'page'?: number;
    'size'?: number;
    'sort'?: Array<string>;
}
export interface PagedAccessRequestResponse {
    'requests'?: Array<AccessRequestDto>;
    'page'?: number;
    'size'?: number;
    'totalElements'?: number;
}
export interface PagedAdvertisersOverviewDto {
    'content'?: Array<AdvertiserOverviewDto>;
    'size'?: number;
    'page'?: number;
    'total'?: number;
}
export interface PagedBusinessEntitiesDto {
    'businessEntities'?: Array<BusinessEntityDto>;
    'page'?: number;
    'size'?: number;
    'totalElements'?: number;
}
export interface PagedBusinessInvitations {
    'email'?: string;
    'invitations'?: Array<BusinessInvitationDto>;
    'page'?: number;
    'size'?: number;
    'totalElements'?: number;
}
export interface PagedBusinessInvitationsDto {
    'invites'?: Array<BusinessInvitationDto>;
    'page'?: number;
    'size'?: number;
    'totalElements'?: number;
}
export interface PagedBusinessProofDtos {
    'proofs'?: Array<BusinessProofDto>;
    'page'?: number;
    'size'?: number;
    'totalElements'?: number;
}
export interface PagedCampaignApprovalsDto {
    'campaigns'?: Array<CampaignApprovalsDto>;
    'page'?: number;
    'size'?: number;
    'totalElements'?: number;
}
export interface PagedCampaignMessageProjectionsDto {
    'messages'?: Array<CampaignMessageProjectionDto>;
    'page'?: number;
    'size'?: number;
    'totalElements'?: number;
}
export interface PagedCampaignOutdoorDtos {
    'campaignOutdoors'?: Array<CampaignOutdoorDto>;
    'page'?: number;
    'size'?: number;
    'totalElements'?: number;
}
export interface PagedCampaignProjectionsDto {
    'campaigns'?: Array<CampaignProjectionDto>;
    'page'?: number;
    'size'?: number;
    'totalElements'?: number;
}
export interface PagedCampaignSearchProjectionsDto {
    'campaigns'?: Array<CampaignSearchProjectionDto>;
    'page'?: number;
    'size'?: number;
    'totalElements'?: number;
}
export interface PagedCampaignsDto {
    'campaigns'?: Array<CampaignResponseDto>;
    'page'?: number;
    'size'?: number;
    'totalElements'?: number;
}
export interface PagedInvoicesDto {
    'businessEntityId'?: string;
    'invoices'?: Array<InvoiceProjectionDto>;
    'page'?: number;
    'size'?: number;
    'totalElements'?: number;
}
export interface PagedOfflineCampaignsDto {
    'campaigns'?: Array<OfflineCampaignResponseDto>;
    'page'?: number;
    'size'?: number;
    'totalElements'?: number;
}
export interface PagedOutdoorDtos {
    'outdoors'?: Array<OutdoorResponseDto>;
    'page'?: number;
    'size'?: number;
    'totalElements'?: number;
}
export interface PagedOutdoorsWithCampaignOutdoorDto {
    'outdoors'?: Array<OutdoorWithCampaignOutdoorDto>;
    'page'?: number;
    'size'?: number;
    'totalElements'?: number;
}
export interface PagedOverdueInstallmentsDto {
    'content'?: Array<OverdueInstallmentDto>;
    'size'?: number;
    'page'?: number;
    'total'?: number;
}
export interface PagedPaymentsResponse {
    'payments'?: Array<PaymentDataDto>;
    'page'?: number;
    'size'?: number;
    'totalElements'?: number;
}
export interface PagedPlacementProviderDebtsDto {
    'placementProviders'?: Array<PlacementProviderDebtsDto>;
    'page'?: number;
    'size'?: number;
    'totalElements'?: number;
}
export interface PagedPlacementProviderOverviewDto {
    'content'?: Array<PlacementProviderOverviewDto>;
    'size'?: number;
    'page'?: number;
    'total'?: number;
}
export interface PagedProofOfAdsProjectionsDto {
    'proofs'?: Array<ProofOfAdProjectionDto>;
    'page'?: number;
    'size'?: number;
    'totalElements'?: number;
}
export interface PagedUploadedAdProjectionDtos {
    'ads'?: Array<UploadedAdProjectionDto>;
    'page'?: number;
    'size'?: number;
    'totalElements'?: number;
}
export interface PagedUsersDto {
    'users'?: Array<UserResponseDto>;
    'page'?: number;
    'size'?: number;
    'totalElements'?: number;
}
export interface PaymentBreakdownDto {
    'installmentNumber'?: number;
    'billingMonth'?: string;
    'adsValue'?: number;
    'productionValue'?: number;
    'total'?: number;
    'currency'?: string;
    'status'?: PaymentBreakdownDtoStatusEnum;
    'expectedDate'?: string;
    'paidAt'?: string;
}

export const PaymentBreakdownDtoStatusEnum = {
    Expected: 'EXPECTED',
    Processing: 'PROCESSING',
    Paid: 'PAID',
    Failed: 'FAILED',
    Cancelled: 'CANCELLED',
} as const;

export type PaymentBreakdownDtoStatusEnum = typeof PaymentBreakdownDtoStatusEnum[keyof typeof PaymentBreakdownDtoStatusEnum];

export interface PaymentDataDto {
    'id'?: string;
    'businessEntityId'?: string;
    'businessEntityName'?: string;
    'campaignId'?: string;
    'campaignName'?: string;
    'paymentType'?: PaymentDataDtoPaymentTypeEnum;
    'status'?: PaymentDataDtoStatusEnum;
    'value'?: number;
    'currency'?: string;
    'paidAt'?: string;
    'lastCheckedAt'?: string;
    'transferId'?: number;
}

export const PaymentDataDtoPaymentTypeEnum = {
    BuyingAds: 'BUYING_ADS',
    SellingAds: 'SELLING_ADS',
    RefundBuyingPart: 'REFUND_BUYING_PART',
    RefundSellingPart: 'REFUND_SELLING_PART',
    PlacementProviderDebt: 'PLACEMENT_PROVIDER_DEBT',
    PlacementProviderCancellationFee: 'PLACEMENT_PROVIDER_CANCELLATION_FEE',
} as const;

export type PaymentDataDtoPaymentTypeEnum = typeof PaymentDataDtoPaymentTypeEnum[keyof typeof PaymentDataDtoPaymentTypeEnum];
export const PaymentDataDtoStatusEnum = {
    Pending: 'PENDING',
    ValidatingPayment: 'VALIDATING_PAYMENT',
    ManualValidation: 'MANUAL_VALIDATION',
    TransferRequested: 'TRANSFER_REQUESTED',
    Paid: 'PAID',
    Cancelled: 'CANCELLED',
    PartiallyRefunded: 'PARTIALLY_REFUNDED',
    FullyRefunded: 'FULLY_REFUNDED',
    Failed: 'FAILED',
} as const;

export type PaymentDataDtoStatusEnum = typeof PaymentDataDtoStatusEnum[keyof typeof PaymentDataDtoStatusEnum];

export interface PayoutBreakdownDto {
    'installmentNumber'?: number;
    'billingMonth'?: string;
    'totalAdValue'?: number;
    'vat'?: number;
    'productionCost'?: number;
    'commission'?: number;
    'commissionVat'?: number;
    'total'?: number;
    'currency'?: string;
    'status'?: PayoutBreakdownDtoStatusEnum;
    'expectedDate'?: string;
    'paidAt'?: string;
}

export const PayoutBreakdownDtoStatusEnum = {
    Expected: 'EXPECTED',
    Processing: 'PROCESSING',
    Paid: 'PAID',
    Failed: 'FAILED',
    Cancelled: 'CANCELLED',
} as const;

export type PayoutBreakdownDtoStatusEnum = typeof PayoutBreakdownDtoStatusEnum[keyof typeof PayoutBreakdownDtoStatusEnum];

export interface PlacementProviderCampaignEarningsDto {
    'campaignId'?: string;
    'currencyCode'?: string;
    'earningsInCampaignByCurrency'?: number;
    'vat'?: number;
    'paymentStatus'?: PlacementProviderCampaignEarningsDtoPaymentStatusEnum;
    'payoutBreakdown'?: Array<PayoutBreakdownDto>;
}

export const PlacementProviderCampaignEarningsDtoPaymentStatusEnum = {
    Pending: 'PENDING',
    ValidatingPayment: 'VALIDATING_PAYMENT',
    ManualValidation: 'MANUAL_VALIDATION',
    TransferRequested: 'TRANSFER_REQUESTED',
    Paid: 'PAID',
    Cancelled: 'CANCELLED',
    PartiallyRefunded: 'PARTIALLY_REFUNDED',
    FullyRefunded: 'FULLY_REFUNDED',
    Failed: 'FAILED',
} as const;

export type PlacementProviderCampaignEarningsDtoPaymentStatusEnum = typeof PlacementProviderCampaignEarningsDtoPaymentStatusEnum[keyof typeof PlacementProviderCampaignEarningsDtoPaymentStatusEnum];

export interface PlacementProviderCampaignOutdoorCostDto {
    'outdoorId'?: string;
    'outdoorName'?: string;
    'earningsInCurrency'?: number;
    'totalValueWithVat'?: number;
    'numberOfDaysBooked'?: number;
    'productionCost'?: number;
    'vatValue'?: number;
    'vatPercentage'?: number;
}
export interface PlacementProviderDebtsDto {
    'placementProviderId'?: string;
    'placementProviderName'?: string;
    'debts'?: Array<DebtProjectionDto>;
}
export interface PlacementProviderInvoiceDto {
    'placementProviderId'?: string;
    'placementProviderName'?: string;
    'invoiceUrl'?: string;
}
export interface PlacementProviderOverviewDto {
    'id'?: string;
    'name'?: string;
    'vatNumber'?: string;
    'activeOutdoors'?: number;
    'activeCampaigns'?: number;
    'earnings'?: Array<ValueInCurrencyDto>;
    'proofOfCompanyUrl'?: string;
}
export interface PlacementProviderResponseDto {
    'id'?: string;
    'name'?: string;
    'vatNumber'?: string;
    'remainingFreeCommissions'?: number;
}
export interface PlatformRevenueDto {
    'totalCommissionInCurrency'?: number;
    'totalRevenueInCurrency'?: number;
    'totalVatInCurrency'?: number;
    'totalStripeFeesInCurrency'?: number;
    'currencyCode'?: string;
    'currencyName'?: string;
    'dailyRevenue'?: Array<DailyPlatformRevenueDto>;
}
export interface ProofOfAdDto {
    'fileId'?: string;
    'campaignOutdoorId'?: string;
    'adUrl'?: string;
    'outdoorUrls'?: Array<string>;
    'startDate'?: string;
    'status'?: ProofOfAdDtoStatusEnum;
    'latitude'?: number;
    'longitude'?: number;
}

export const ProofOfAdDtoStatusEnum = {
    Pending: 'PENDING',
    Valid: 'VALID',
    ManualValidation: 'MANUAL_VALIDATION',
    Invalid: 'INVALID',
} as const;

export type ProofOfAdDtoStatusEnum = typeof ProofOfAdDtoStatusEnum[keyof typeof ProofOfAdDtoStatusEnum];

export interface ProofOfAdProjectionDto {
    'campaignId'?: string;
    'campaignName'?: string;
    'placementProviderId'?: string;
    'placementProviderName'?: string;
    'fileId'?: string;
    'url'?: string;
    'campaignStartDate'?: string;
    'latitude'?: number;
    'longitude'?: number;
}
export interface ProofOfPaymentDto {
    'campaignId'?: string;
    'uploadUrl'?: string;
}
export interface RefreshTokenRequest {
    'refreshToken'?: string;
}
export interface RequestResetPasswordDto {
    'email'?: string;
}
export interface ResetPasswordDto {
    'password': string;
}
export interface SearchCampaignsDto {
    'startDate'?: string;
    'endDate'?: string;
    'placementProviderIds'?: Set<string>;
    'advertiserIds'?: Set<string>;
    'paymentStatus'?: SearchCampaignsDtoPaymentStatusEnum;
    'campaignStatuses'?: Set<SearchCampaignsDtoCampaignStatusesEnum>;
    'name'?: string;
    'types'?: Set<SearchCampaignsDtoTypesEnum>;
}

export const SearchCampaignsDtoPaymentStatusEnum = {
    Pending: 'PENDING',
    ValidatingPayment: 'VALIDATING_PAYMENT',
    ManualValidation: 'MANUAL_VALIDATION',
    TransferRequested: 'TRANSFER_REQUESTED',
    Paid: 'PAID',
    Cancelled: 'CANCELLED',
    PartiallyRefunded: 'PARTIALLY_REFUNDED',
    FullyRefunded: 'FULLY_REFUNDED',
    Failed: 'FAILED',
} as const;

export type SearchCampaignsDtoPaymentStatusEnum = typeof SearchCampaignsDtoPaymentStatusEnum[keyof typeof SearchCampaignsDtoPaymentStatusEnum];
export const SearchCampaignsDtoCampaignStatusesEnum = {
    Pending: 'PENDING',
    AwaitingPayment: 'AWAITING_PAYMENT',
    Confirming: 'CONFIRMING',
    AwaitingConfirmation: 'AWAITING_CONFIRMATION',
    Ready: 'READY',
    Running: 'RUNNING',
    Completed: 'COMPLETED',
    Cancelled: 'CANCELLED',
    Unavailable: 'UNAVAILABLE',
} as const;

export type SearchCampaignsDtoCampaignStatusesEnum = typeof SearchCampaignsDtoCampaignStatusesEnum[keyof typeof SearchCampaignsDtoCampaignStatusesEnum];
export const SearchCampaignsDtoTypesEnum = {
    Scapow: 'SCAPOW',
    Offline: 'OFFLINE',
} as const;

export type SearchCampaignsDtoTypesEnum = typeof SearchCampaignsDtoTypesEnum[keyof typeof SearchCampaignsDtoTypesEnum];

export interface SearchOutdoorRequestDto {
    'longitude'?: number;
    'latitude'?: number;
    'startDate'?: string;
    'endDate'?: string;
    'radiusInMeters'?: number;
    'providerName'?: string;
    'minWidth'?: number;
    'maxWidth'?: number;
    'minPrice'?: number;
    'maxPrice'?: number;
    'attributeIds'?: Set<number>;
    'minHeight'?: number;
    'maxHeight'?: number;
    'withDiscounts'?: boolean;
    'illuminated'?: boolean;
    'instantBooking'?: boolean;
}
export interface SearchPlacementProviderOutdoorsDto {
    'name'?: string;
    'dimensions'?: Array<OutdoorDimensionsDto>;
    'availableFrom'?: string;
    'availableTo'?: string;
}
export interface SectionViewDto {
    'type'?: SectionViewDtoTypeEnum;
    'newCount'?: number;
    'campaignIds'?: Array<string>;
}

export const SectionViewDtoTypeEnum = {
    ReadyCampaigns: 'READY_CAMPAIGNS',
    RunningCampaigns: 'RUNNING_CAMPAIGNS',
    VerifiedCampaignOutdoor: 'VERIFIED_CAMPAIGN_OUTDOOR',
    MessagesReceived: 'MESSAGES_RECEIVED',
} as const;

export type SectionViewDtoTypeEnum = typeof SectionViewDtoTypeEnum[keyof typeof SectionViewDtoTypeEnum];

export interface SettlePlacementProviderDebtRequestDto {
    'amount': number;
    'fileName': string;
}
export interface SettlePlacementProviderDebtUploadUrlDto {
    'placementProviderId'?: string;
    'uploadUrl'?: string;
}
export interface Sort {
    'sort'?: Array<string>;
}
export interface SubscribedEventsDto {
    'url'?: string;
}
export interface TimeRangeDto {
    'startDate'?: string;
    'endDate'?: string;
}
export interface TokenDto {
    'accessToken'?: string;
    'refreshToken'?: string;
}
export interface TranslationDto {
    'id'?: number;
    'label'?: string;
}
export interface UpdateBusinessEntityRequestDto {
    'name': string;
    'vatNumber': string;
    'email'?: string;
    'countryId': string;
    'currencyId'?: string;
    'iban': string;
    'swiftCode': string;
    'portugalType'?: UpdateBusinessEntityRequestDtoPortugalTypeEnum;
    'firstLine': string;
    'city': string;
    'state'?: string;
    'postCode': string;
}

export const UpdateBusinessEntityRequestDtoPortugalTypeEnum = {
    Continent: 'CONTINENT',
    Azores: 'AZORES',
    Madeira: 'MADEIRA',
} as const;

export type UpdateBusinessEntityRequestDtoPortugalTypeEnum = typeof UpdateBusinessEntityRequestDtoPortugalTypeEnum[keyof typeof UpdateBusinessEntityRequestDtoPortugalTypeEnum];

export interface UpdateCampaignOutdoorDatesRequestDto {
    'startDate': string;
    'endDate': string;
}
export interface UpdateInstructionsDto {
    'instructions'?: string;
}
export interface UpdateProofFileResponseDto {
    'businessEntityId'?: string;
    'proofOfCompanyUploadUrl'?: string;
}
export interface UpdateUserRequest {
    'name': string;
    'existingPassword'?: string;
    'newPassword'?: string;
    'receiveEmails'?: boolean;
}
export interface UpdatedCampaignOutdoorsDto {
    'campaignId'?: string;
    'status'?: UpdatedCampaignOutdoorsDtoStatusEnum;
    'flaggedCampaignOutdoorIds'?: Set<string>;
}

export const UpdatedCampaignOutdoorsDtoStatusEnum = {
    Final: 'FINAL',
    Updated: 'UPDATED',
    Flagged: 'FLAGGED',
    Outdated: 'OUTDATED',
} as const;

export type UpdatedCampaignOutdoorsDtoStatusEnum = typeof UpdatedCampaignOutdoorsDtoStatusEnum[keyof typeof UpdatedCampaignOutdoorsDtoStatusEnum];

export interface UploadOfInvoiceDto {
    'campaignId'?: string;
    'uploadUrl'?: string;
}
export interface UploadedAdProjectionDto {
    'campaignId'?: string;
    'advertiserId'?: string;
    'fileId'?: string;
    'campaignName'?: string;
    'advertiserName'?: string;
    'startDate'?: string;
    'url'?: string;
}
export interface UploadedFileDto {
    'id'?: string;
    'url'?: string;
    'status'?: UploadedFileDtoStatusEnum;
}

export const UploadedFileDtoStatusEnum = {
    Pending: 'PENDING',
    Valid: 'VALID',
    ManualValidation: 'MANUAL_VALIDATION',
    Invalid: 'INVALID',
} as const;

export type UploadedFileDtoStatusEnum = typeof UploadedFileDtoStatusEnum[keyof typeof UploadedFileDtoStatusEnum];

export interface UserDetailsDto {
    'id'?: string;
    'name'?: string;
}
export interface UserResponseDto {
    'id'?: string;
    'email'?: string;
    'name'?: string;
    'status'?: UserResponseDtoStatusEnum;
    'businessEntityId'?: string;
    'registerDate'?: string;
    'receiveEmails'?: boolean;
}

export const UserResponseDtoStatusEnum = {
    Pending: 'PENDING',
    Verified: 'VERIFIED',
} as const;

export type UserResponseDtoStatusEnum = typeof UserResponseDtoStatusEnum[keyof typeof UserResponseDtoStatusEnum];

export interface ValueInCurrencyDto {
    'value'?: number;
    'currencyId'?: string;
}
export interface VerificationRequest {
    'email': string;
}
export interface WriteCampaignRequestDto {
    'creativeFileNames'?: Array<string>;
    'outdoorIds'?: Set<string>;
    'details'?: string;
    'name'?: string;
    'attributeIds'?: Set<number>;
    'instructions'?: string;
    'acceptedTermsAndConditions'?: boolean;
    'paymentPlan'?: WriteCampaignRequestDtoPaymentPlanEnum;
}

export const WriteCampaignRequestDtoPaymentPlanEnum = {
    Total: 'TOTAL',
    Monthly: 'MONTHLY',
    Trimonthly: 'TRIMONTHLY',
} as const;

export type WriteCampaignRequestDtoPaymentPlanEnum = typeof WriteCampaignRequestDtoPaymentPlanEnum[keyof typeof WriteCampaignRequestDtoPaymentPlanEnum];

export interface WriteCampaignResponseDto {
    'campaignId'?: string;
    'advertiserId'?: string;
    'creativeUploads'?: Array<CreativeUploadDto>;
    'outdoorIds'?: Set<string>;
    'startDate'?: string;
    'endDate'?: string;
    'status'?: WriteCampaignResponseDtoStatusEnum;
    'details'?: string;
    'instructions'?: string;
    'acceptedTermsAndConditions'?: boolean;
    'paymentPlan'?: WriteCampaignResponseDtoPaymentPlanEnum;
}

export const WriteCampaignResponseDtoStatusEnum = {
    Pending: 'PENDING',
    AwaitingPayment: 'AWAITING_PAYMENT',
    Confirming: 'CONFIRMING',
    AwaitingConfirmation: 'AWAITING_CONFIRMATION',
    Cancelled: 'CANCELLED',
    Ready: 'READY',
    Running: 'RUNNING',
    Completed: 'COMPLETED',
    Unavailable: 'UNAVAILABLE',
} as const;

export type WriteCampaignResponseDtoStatusEnum = typeof WriteCampaignResponseDtoStatusEnum[keyof typeof WriteCampaignResponseDtoStatusEnum];
export const WriteCampaignResponseDtoPaymentPlanEnum = {
    Total: 'TOTAL',
    Monthly: 'MONTHLY',
    Trimonthly: 'TRIMONTHLY',
} as const;

export type WriteCampaignResponseDtoPaymentPlanEnum = typeof WriteCampaignResponseDtoPaymentPlanEnum[keyof typeof WriteCampaignResponseDtoPaymentPlanEnum];

export interface WriteOfflineCampaignRequestDto {
    'name': string;
    'details'?: string;
    'notes'?: string;
    'instructions'?: string;
}
export interface WriteOutdoorRequestDto {
    'latitude': number;
    'longitude': number;
    'name'?: string;
    'description'?: string;
    'valuePerDay'?: number;
    'currencyCode': string;
    'discounts'?: Array<DiscountDto>;
    'widthInMetres'?: number;
    'heightInMetres'?: number;
    'locationImagesFileNames'?: Array<string>;
    'attributeIds'?: Set<number>;
    'productionCost'?: number;
    'minimumNoticeInDays'?: number;
    'minimumDays'?: number;
    'blockedDates'?: Array<TimeRangeDto>;
    'bleedInMetres'?: number;
    'illuminated'?: boolean;
    'instantBooking'?: boolean;
    'fullMonthRequired'?: boolean;
    'startAtMonthFirstDay'?: boolean;
}
export interface WriteOutdoorResponseDto {
    'id'?: string;
    'latitude'?: number;
    'longitude'?: number;
    'name'?: string;
    'description'?: string;
    'valuePerDayInCurrency'?: number;
    'discounts'?: Array<DiscountDto>;
    'widthInMetres'?: number;
    'heightInMetres'?: number;
    'requiredCreativeAspectRatio'?: number;
    'attributeIds'?: Array<number>;
    'productionCost'?: number;
    'minimumNoticeInDays'?: number;
    'minimumDays'?: number;
    'blockedDates'?: Array<TimeRangeDto>;
    'bleedInMetres'?: number;
    'illuminated'?: boolean;
    'instantBooking'?: boolean;
    'fullMonthRequired'?: boolean;
    'startAtMonthFirstDay'?: boolean;
}

/**
 * AdminControllerApi - axios parameter creator
 */
export const AdminControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * To approve an unverified File
         * @param {string} fileId 
         * @param {ApproveFileByIdTypeEnum} type 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveFileById: async (fileId: string, type: ApproveFileByIdTypeEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('approveFileById', 'fileId', fileId)
            // verify required parameter 'type' is not null or undefined
            assertParamExists('approveFileById', 'type', type)
            const localVarPath = `/api/v1/admin/files/{fileId}/{type}/approve`
                .replace('{fileId}', encodeURIComponent(String(fileId)))
                .replace('{type}', encodeURIComponent(String(type)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Approve Pending request to Business Entity
         * @param {string} accessRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approvePendingAccessRequest: async (accessRequestId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accessRequestId' is not null or undefined
            assertParamExists('approvePendingAccessRequest', 'accessRequestId', accessRequestId)
            const localVarPath = `/api/v1/admin/access-requests/{accessRequestId}/approve`
                .replace('{accessRequestId}', encodeURIComponent(String(accessRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search for Campaigns
         * @param {Pageable} pageable 
         * @param {SearchCampaignsDto} searchCampaignsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignsSearch: async (pageable: Pageable, searchCampaignsDto: SearchCampaignsDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pageable' is not null or undefined
            assertParamExists('campaignsSearch', 'pageable', pageable)
            // verify required parameter 'searchCampaignsDto' is not null or undefined
            assertParamExists('campaignsSearch', 'searchCampaignsDto', searchCampaignsDto)
            const localVarPath = `/api/v1/admin/campaigns/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (pageable !== undefined) {
                for (const [key, value] of Object.entries(pageable)) {
                    localVarQueryParameter[key] = value;
                }
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(searchCampaignsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Check on Transfer Requested Payment by Transfer ID
         * @param {number} transferId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkPaymentByTransferId: async (transferId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'transferId' is not null or undefined
            assertParamExists('checkPaymentByTransferId', 'transferId', transferId)
            const localVarPath = `/api/v1/admin/payments/transfer-requested/{transferId}/check`
                .replace('{transferId}', encodeURIComponent(String(transferId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search for Advertisers
         * @param {Pageable} page 
         * @param {string} [name] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdvertisers: async (page: Pageable, name?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('getAdvertisers', 'page', page)
            const localVarPath = `/api/v1/admin/advertisers/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (page !== undefined) {
                for (const [key, value] of Object.entries(page)) {
                    localVarQueryParameter[key] = value;
                }
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get Advertisers paged Overview
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {Pageable} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdvertisersOverview: async (startDate: string, endDate: string, page: Pageable, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('getAdvertisersOverview', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('getAdvertisersOverview', 'endDate', endDate)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('getAdvertisersOverview', 'page', page)
            const localVarPath = `/api/v1/admin/advertisers/overview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString().substring(0,10) :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString().substring(0,10) :
                    endDate;
            }

            if (page !== undefined) {
                for (const [key, value] of Object.entries(page)) {
                    localVarQueryParameter[key] = value;
                }
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get an upload SAS URL for a CSV file of Outdoors to bulk-import for a Placement Provider. Once the file finishes uploading, its rows are imported asynchronously (see BlobCreatedHandler.handleOutdoorsCsvUploaded)
         * @param {string} businessEntityId 
         * @param {string} fileName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOutdoorsCsvUploadUrl: async (businessEntityId: string, fileName: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessEntityId' is not null or undefined
            assertParamExists('getOutdoorsCsvUploadUrl', 'businessEntityId', businessEntityId)
            // verify required parameter 'fileName' is not null or undefined
            assertParamExists('getOutdoorsCsvUploadUrl', 'fileName', fileName)
            const localVarPath = `/api/v1/admin/business-entities/{businessEntityId}/outdoors/csv-upload-url`
                .replace('{businessEntityId}', encodeURIComponent(String(businessEntityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (fileName !== undefined) {
                localVarQueryParameter['fileName'] = fileName;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get paged installments still not paid 6 days after their due date (the debit\'s confirmation window), by due date
         * @param {Pageable} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOverdueInstallments: async (page: Pageable, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('getOverdueInstallments', 'page', page)
            const localVarPath = `/api/v1/admin/installments/overdue`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                for (const [key, value] of Object.entries(page)) {
                    localVarQueryParameter[key] = value;
                }
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * To get a paged list of Placement Provider Debts, grouped by Placement Provider
         * @param {Pageable} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPagedDebts: async (page: Pageable, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('getPagedDebts', 'page', page)
            const localVarPath = `/api/v1/admin/placement-providers/debts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                for (const [key, value] of Object.entries(page)) {
                    localVarQueryParameter[key] = value;
                }
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get payments by status
         * @param {GetPaymentsByStatusStatusEnum} status 
         * @param {Pageable} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentsByStatus: async (status: GetPaymentsByStatusStatusEnum, page: Pageable, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'status' is not null or undefined
            assertParamExists('getPaymentsByStatus', 'status', status)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('getPaymentsByStatus', 'page', page)
            const localVarPath = `/api/v1/admin/payments/{status}`
                .replace('{status}', encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                for (const [key, value] of Object.entries(page)) {
                    localVarQueryParameter[key] = value;
                }
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Pending requests to Business Entities
         * @param {Pageable} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPendingAccessRequests: async (page: Pageable, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('getPendingAccessRequests', 'page', page)
            const localVarPath = `/api/v1/admin/access-requests/pending`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                for (const [key, value] of Object.entries(page)) {
                    localVarQueryParameter[key] = value;
                }
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Manual Verification of Ads
         * @param {Pageable} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPendingAds: async (page: Pageable, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('getPendingAds', 'page', page)
            const localVarPath = `/api/v1/admin/manual-verifications/ads`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                for (const [key, value] of Object.entries(page)) {
                    localVarQueryParameter[key] = value;
                }
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Manual Verification of Business proofs
         * @param {Pageable} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPendingBusinessProofs: async (page: Pageable, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('getPendingBusinessProofs', 'page', page)
            const localVarPath = `/api/v1/admin/manual-verifications/business-proofs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                for (const [key, value] of Object.entries(page)) {
                    localVarQueryParameter[key] = value;
                }
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get pending payments
         * @param {Pageable} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPendingPayments: async (page: Pageable, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('getPendingPayments', 'page', page)
            const localVarPath = `/api/v1/admin/payments/pending`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                for (const [key, value] of Object.entries(page)) {
                    localVarQueryParameter[key] = value;
                }
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Manual Verification of Proof of Ads
         * @param {Pageable} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPendingProofOfAds: async (page: Pageable, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('getPendingProofOfAds', 'page', page)
            const localVarPath = `/api/v1/admin/manual-verifications/proof-of-ads`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                for (const [key, value] of Object.entries(page)) {
                    localVarQueryParameter[key] = value;
                }
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search for Placement Providers
         * @param {Pageable} page 
         * @param {string} [name] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlacementProviders: async (page: Pageable, name?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('getPlacementProviders', 'page', page)
            const localVarPath = `/api/v1/admin/placement-providers/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (page !== undefined) {
                for (const [key, value] of Object.entries(page)) {
                    localVarQueryParameter[key] = value;
                }
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get Placement Providers paged Overview
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {Pageable} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlacementProvidersOverview: async (startDate: string, endDate: string, page: Pageable, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('getPlacementProvidersOverview', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('getPlacementProvidersOverview', 'endDate', endDate)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('getPlacementProvidersOverview', 'page', page)
            const localVarPath = `/api/v1/admin/placement-providers/overview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString().substring(0,10) :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString().substring(0,10) :
                    endDate;
            }

            if (page !== undefined) {
                for (const [key, value] of Object.entries(page)) {
                    localVarQueryParameter[key] = value;
                }
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get platform revenue by currency and day within a date range: net revenue (commission) and VAT from all Invoices created in the range (both Advertiser and Placement Provider), plus gross revenue - the ad value Advertisers actually paid us, from PAID BUYING_ADS Payments received in the range
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlatformRevenue: async (startDate: string, endDate: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('getPlatformRevenue', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('getPlatformRevenue', 'endDate', endDate)
            const localVarPath = `/api/v1/admin/revenue`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString().substring(0,10) :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString().substring(0,10) :
                    endDate;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get live backlog counts and ids for every Admin validation queue (proof of company, ad creatives, proof of ads, missing proof of ads, transfer-requested payments, pending access requests)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSectionCounts: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/section-views`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get paged TRANSFER_REQUESTED Payments, awaiting Wise transfer confirmation
         * @param {Pageable} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransferRequestedPayments: async (page: Pageable, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('getTransferRequestedPayments', 'page', page)
            const localVarPath = `/api/v1/admin/payments/transfer-requested`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                for (const [key, value] of Object.entries(page)) {
                    localVarQueryParameter[key] = value;
                }
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * To get Ads that haven\'t been verified yet
         * @param {Pageable} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnverifiedAds: async (page: Pageable, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('getUnverifiedAds', 'page', page)
            const localVarPath = `/api/v1/admin/unverified-ads`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                for (const [key, value] of Object.entries(page)) {
                    localVarQueryParameter[key] = value;
                }
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * To mark a payment as Done
         * @param {string} paymentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markPaymentAsDone: async (paymentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'paymentId' is not null or undefined
            assertParamExists('markPaymentAsDone', 'paymentId', paymentId)
            const localVarPath = `/api/v1/admin/payments/{paymentId}`
                .replace('{paymentId}', encodeURIComponent(String(paymentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * To refund an Advertiser, on a Campaign, by Outdoor ID\'s and number of days to refund on each
         * @param {string} campaignId 
         * @param {CampaignRefundsDto} campaignRefundsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refundByOutdoorIdsInCampaign: async (campaignId: string, campaignRefundsDto: CampaignRefundsDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'campaignId' is not null or undefined
            assertParamExists('refundByOutdoorIdsInCampaign', 'campaignId', campaignId)
            // verify required parameter 'campaignRefundsDto' is not null or undefined
            assertParamExists('refundByOutdoorIdsInCampaign', 'campaignRefundsDto', campaignRefundsDto)
            const localVarPath = `/api/v1/admin/campaigns/{campaignId}/refunds-by-outdoors`
                .replace('{campaignId}', encodeURIComponent(String(campaignId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(campaignRefundsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * To reject an unverified File
         * @param {string} fileId 
         * @param {RejectFileByIdTypeEnum} type 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectFileById: async (fileId: string, type: RejectFileByIdTypeEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('rejectFileById', 'fileId', fileId)
            // verify required parameter 'type' is not null or undefined
            assertParamExists('rejectFileById', 'type', type)
            const localVarPath = `/api/v1/admin/files/{fileId}/{type}/reject`
                .replace('{fileId}', encodeURIComponent(String(fileId)))
                .replace('{type}', encodeURIComponent(String(type)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Reject Pending request to Business Entity
         * @param {string} accessRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectPendingAccessRequest: async (accessRequestId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accessRequestId' is not null or undefined
            assertParamExists('rejectPendingAccessRequest', 'accessRequestId', accessRequestId)
            const localVarPath = `/api/v1/admin/access-requests/{accessRequestId}/reject`
                .replace('{accessRequestId}', encodeURIComponent(String(accessRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Set how many commission-free sales a Business Entity (Advertiser or Placement Provider) has left. While positive, its sales carry no platform commission (nor VAT on it) and no commission invoice; one is used per paid Campaign.
         * @param {string} businessEntityId 
         * @param {FreeCommissionsRequestDto} freeCommissionsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setFreeCommissions: async (businessEntityId: string, freeCommissionsRequestDto: FreeCommissionsRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessEntityId' is not null or undefined
            assertParamExists('setFreeCommissions', 'businessEntityId', businessEntityId)
            // verify required parameter 'freeCommissionsRequestDto' is not null or undefined
            assertParamExists('setFreeCommissions', 'freeCommissionsRequestDto', freeCommissionsRequestDto)
            const localVarPath = `/api/v1/admin/business-entities/{businessEntityId}/free-commissions`
                .replace('{businessEntityId}', encodeURIComponent(String(businessEntityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(freeCommissionsRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * To get a SAS upload URL for the document evidencing a manual settlement of a Placement Provider\'s outstanding Debt
         * @param {string} placementProviderId 
         * @param {SettlePlacementProviderDebtRequestDto} settlePlacementProviderDebtRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        settlePlacementProviderDebt: async (placementProviderId: string, settlePlacementProviderDebtRequestDto: SettlePlacementProviderDebtRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'placementProviderId' is not null or undefined
            assertParamExists('settlePlacementProviderDebt', 'placementProviderId', placementProviderId)
            // verify required parameter 'settlePlacementProviderDebtRequestDto' is not null or undefined
            assertParamExists('settlePlacementProviderDebt', 'settlePlacementProviderDebtRequestDto', settlePlacementProviderDebtRequestDto)
            const localVarPath = `/api/v1/admin/placement-providers/{placementProviderId}/debts/settle`
                .replace('{placementProviderId}', encodeURIComponent(String(placementProviderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(settlePlacementProviderDebtRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminControllerApi - functional programming interface
 */
export const AdminControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * To approve an unverified File
         * @param {string} fileId 
         * @param {ApproveFileByIdTypeEnum} type 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async approveFileById(fileId: string, type: ApproveFileByIdTypeEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UploadedFileDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.approveFileById(fileId, type, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.approveFileById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Approve Pending request to Business Entity
         * @param {string} accessRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async approvePendingAccessRequest(accessRequestId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccessRequestDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.approvePendingAccessRequest(accessRequestId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.approvePendingAccessRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search for Campaigns
         * @param {Pageable} pageable 
         * @param {SearchCampaignsDto} searchCampaignsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async campaignsSearch(pageable: Pageable, searchCampaignsDto: SearchCampaignsDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedCampaignsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.campaignsSearch(pageable, searchCampaignsDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.campaignsSearch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Check on Transfer Requested Payment by Transfer ID
         * @param {number} transferId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkPaymentByTransferId(transferId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkPaymentByTransferId(transferId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.checkPaymentByTransferId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search for Advertisers
         * @param {Pageable} page 
         * @param {string} [name] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdvertisers(page: Pageable, name?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AdvertiserDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdvertisers(page, name, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.getAdvertisers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get Advertisers paged Overview
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {Pageable} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdvertisersOverview(startDate: string, endDate: string, page: Pageable, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedAdvertisersOverviewDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdvertisersOverview(startDate, endDate, page, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.getAdvertisersOverview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get an upload SAS URL for a CSV file of Outdoors to bulk-import for a Placement Provider. Once the file finishes uploading, its rows are imported asynchronously (see BlobCreatedHandler.handleOutdoorsCsvUploaded)
         * @param {string} businessEntityId 
         * @param {string} fileName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOutdoorsCsvUploadUrl(businessEntityId: string, fileName: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutdoorsCsvUploadUrlDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOutdoorsCsvUploadUrl(businessEntityId, fileName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.getOutdoorsCsvUploadUrl']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get paged installments still not paid 6 days after their due date (the debit\'s confirmation window), by due date
         * @param {Pageable} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOverdueInstallments(page: Pageable, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedOverdueInstallmentsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOverdueInstallments(page, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.getOverdueInstallments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * To get a paged list of Placement Provider Debts, grouped by Placement Provider
         * @param {Pageable} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPagedDebts(page: Pageable, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedPlacementProviderDebtsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPagedDebts(page, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.getPagedDebts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get payments by status
         * @param {GetPaymentsByStatusStatusEnum} status 
         * @param {Pageable} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPaymentsByStatus(status: GetPaymentsByStatusStatusEnum, page: Pageable, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedPaymentsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPaymentsByStatus(status, page, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.getPaymentsByStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Pending requests to Business Entities
         * @param {Pageable} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPendingAccessRequests(page: Pageable, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedAccessRequestResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPendingAccessRequests(page, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.getPendingAccessRequests']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Manual Verification of Ads
         * @param {Pageable} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPendingAds(page: Pageable, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedUploadedAdProjectionDtos>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPendingAds(page, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.getPendingAds']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Manual Verification of Business proofs
         * @param {Pageable} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPendingBusinessProofs(page: Pageable, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedBusinessProofDtos>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPendingBusinessProofs(page, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.getPendingBusinessProofs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get pending payments
         * @param {Pageable} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPendingPayments(page: Pageable, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PaymentDataDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPendingPayments(page, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.getPendingPayments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Manual Verification of Proof of Ads
         * @param {Pageable} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPendingProofOfAds(page: Pageable, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedProofOfAdsProjectionsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPendingProofOfAds(page, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.getPendingProofOfAds']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search for Placement Providers
         * @param {Pageable} page 
         * @param {string} [name] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPlacementProviders(page: Pageable, name?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PlacementProviderResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPlacementProviders(page, name, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.getPlacementProviders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get Placement Providers paged Overview
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {Pageable} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPlacementProvidersOverview(startDate: string, endDate: string, page: Pageable, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedPlacementProviderOverviewDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPlacementProvidersOverview(startDate, endDate, page, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.getPlacementProvidersOverview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get platform revenue by currency and day within a date range: net revenue (commission) and VAT from all Invoices created in the range (both Advertiser and Placement Provider), plus gross revenue - the ad value Advertisers actually paid us, from PAID BUYING_ADS Payments received in the range
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPlatformRevenue(startDate: string, endDate: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PlatformRevenueDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPlatformRevenue(startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.getPlatformRevenue']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get live backlog counts and ids for every Admin validation queue (proof of company, ad creatives, proof of ads, missing proof of ads, transfer-requested payments, pending access requests)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSectionCounts(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AdminSectionCountDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSectionCounts(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.getSectionCounts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get paged TRANSFER_REQUESTED Payments, awaiting Wise transfer confirmation
         * @param {Pageable} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTransferRequestedPayments(page: Pageable, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedPaymentsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTransferRequestedPayments(page, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.getTransferRequestedPayments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * To get Ads that haven\'t been verified yet
         * @param {Pageable} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUnverifiedAds(page: Pageable, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProofOfAdDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUnverifiedAds(page, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.getUnverifiedAds']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * To mark a payment as Done
         * @param {string} paymentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markPaymentAsDone(paymentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaymentDataDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markPaymentAsDone(paymentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.markPaymentAsDone']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * To refund an Advertiser, on a Campaign, by Outdoor ID\'s and number of days to refund on each
         * @param {string} campaignId 
         * @param {CampaignRefundsDto} campaignRefundsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async refundByOutdoorIdsInCampaign(campaignId: string, campaignRefundsDto: CampaignRefundsDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CampaignResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.refundByOutdoorIdsInCampaign(campaignId, campaignRefundsDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.refundByOutdoorIdsInCampaign']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * To reject an unverified File
         * @param {string} fileId 
         * @param {RejectFileByIdTypeEnum} type 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rejectFileById(fileId: string, type: RejectFileByIdTypeEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UploadedFileDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rejectFileById(fileId, type, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.rejectFileById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Reject Pending request to Business Entity
         * @param {string} accessRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rejectPendingAccessRequest(accessRequestId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccessRequestDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rejectPendingAccessRequest(accessRequestId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.rejectPendingAccessRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Set how many commission-free sales a Business Entity (Advertiser or Placement Provider) has left. While positive, its sales carry no platform commission (nor VAT on it) and no commission invoice; one is used per paid Campaign.
         * @param {string} businessEntityId 
         * @param {FreeCommissionsRequestDto} freeCommissionsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setFreeCommissions(businessEntityId: string, freeCommissionsRequestDto: FreeCommissionsRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FreeCommissionsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setFreeCommissions(businessEntityId, freeCommissionsRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.setFreeCommissions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * To get a SAS upload URL for the document evidencing a manual settlement of a Placement Provider\'s outstanding Debt
         * @param {string} placementProviderId 
         * @param {SettlePlacementProviderDebtRequestDto} settlePlacementProviderDebtRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async settlePlacementProviderDebt(placementProviderId: string, settlePlacementProviderDebtRequestDto: SettlePlacementProviderDebtRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SettlePlacementProviderDebtUploadUrlDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.settlePlacementProviderDebt(placementProviderId, settlePlacementProviderDebtRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminControllerApi.settlePlacementProviderDebt']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminControllerApi - factory interface
 */
export const AdminControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminControllerApiFp(configuration)
    return {
        /**
         * To approve an unverified File
         * @param {string} fileId 
         * @param {ApproveFileByIdTypeEnum} type 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveFileById(fileId: string, type: ApproveFileByIdTypeEnum, options?: RawAxiosRequestConfig): AxiosPromise<UploadedFileDto> {
            return localVarFp.approveFileById(fileId, type, options).then((request) => request(axios, basePath));
        },
        /**
         * Approve Pending request to Business Entity
         * @param {string} accessRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approvePendingAccessRequest(accessRequestId: string, options?: RawAxiosRequestConfig): AxiosPromise<AccessRequestDto> {
            return localVarFp.approvePendingAccessRequest(accessRequestId, options).then((request) => request(axios, basePath));
        },
        /**
         * Search for Campaigns
         * @param {Pageable} pageable 
         * @param {SearchCampaignsDto} searchCampaignsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignsSearch(pageable: Pageable, searchCampaignsDto: SearchCampaignsDto, options?: RawAxiosRequestConfig): AxiosPromise<PagedCampaignsDto> {
            return localVarFp.campaignsSearch(pageable, searchCampaignsDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Check on Transfer Requested Payment by Transfer ID
         * @param {number} transferId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkPaymentByTransferId(transferId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.checkPaymentByTransferId(transferId, options).then((request) => request(axios, basePath));
        },
        /**
         * Search for Advertisers
         * @param {Pageable} page 
         * @param {string} [name] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdvertisers(page: Pageable, name?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<AdvertiserDto>> {
            return localVarFp.getAdvertisers(page, name, options).then((request) => request(axios, basePath));
        },
        /**
         * Get Advertisers paged Overview
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {Pageable} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdvertisersOverview(startDate: string, endDate: string, page: Pageable, options?: RawAxiosRequestConfig): AxiosPromise<PagedAdvertisersOverviewDto> {
            return localVarFp.getAdvertisersOverview(startDate, endDate, page, options).then((request) => request(axios, basePath));
        },
        /**
         * Get an upload SAS URL for a CSV file of Outdoors to bulk-import for a Placement Provider. Once the file finishes uploading, its rows are imported asynchronously (see BlobCreatedHandler.handleOutdoorsCsvUploaded)
         * @param {string} businessEntityId 
         * @param {string} fileName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOutdoorsCsvUploadUrl(businessEntityId: string, fileName: string, options?: RawAxiosRequestConfig): AxiosPromise<OutdoorsCsvUploadUrlDto> {
            return localVarFp.getOutdoorsCsvUploadUrl(businessEntityId, fileName, options).then((request) => request(axios, basePath));
        },
        /**
         * Get paged installments still not paid 6 days after their due date (the debit\'s confirmation window), by due date
         * @param {Pageable} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOverdueInstallments(page: Pageable, options?: RawAxiosRequestConfig): AxiosPromise<PagedOverdueInstallmentsDto> {
            return localVarFp.getOverdueInstallments(page, options).then((request) => request(axios, basePath));
        },
        /**
         * To get a paged list of Placement Provider Debts, grouped by Placement Provider
         * @param {Pageable} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPagedDebts(page: Pageable, options?: RawAxiosRequestConfig): AxiosPromise<PagedPlacementProviderDebtsDto> {
            return localVarFp.getPagedDebts(page, options).then((request) => request(axios, basePath));
        },
        /**
         * Get payments by status
         * @param {GetPaymentsByStatusStatusEnum} status 
         * @param {Pageable} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentsByStatus(status: GetPaymentsByStatusStatusEnum, page: Pageable, options?: RawAxiosRequestConfig): AxiosPromise<PagedPaymentsResponse> {
            return localVarFp.getPaymentsByStatus(status, page, options).then((request) => request(axios, basePath));
        },
        /**
         * Pending requests to Business Entities
         * @param {Pageable} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPendingAccessRequests(page: Pageable, options?: RawAxiosRequestConfig): AxiosPromise<PagedAccessRequestResponse> {
            return localVarFp.getPendingAccessRequests(page, options).then((request) => request(axios, basePath));
        },
        /**
         * Manual Verification of Ads
         * @param {Pageable} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPendingAds(page: Pageable, options?: RawAxiosRequestConfig): AxiosPromise<PagedUploadedAdProjectionDtos> {
            return localVarFp.getPendingAds(page, options).then((request) => request(axios, basePath));
        },
        /**
         * Manual Verification of Business proofs
         * @param {Pageable} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPendingBusinessProofs(page: Pageable, options?: RawAxiosRequestConfig): AxiosPromise<PagedBusinessProofDtos> {
            return localVarFp.getPendingBusinessProofs(page, options).then((request) => request(axios, basePath));
        },
        /**
         * Get pending payments
         * @param {Pageable} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPendingPayments(page: Pageable, options?: RawAxiosRequestConfig): AxiosPromise<Array<PaymentDataDto>> {
            return localVarFp.getPendingPayments(page, options).then((request) => request(axios, basePath));
        },
        /**
         * Manual Verification of Proof of Ads
         * @param {Pageable} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPendingProofOfAds(page: Pageable, options?: RawAxiosRequestConfig): AxiosPromise<PagedProofOfAdsProjectionsDto> {
            return localVarFp.getPendingProofOfAds(page, options).then((request) => request(axios, basePath));
        },
        /**
         * Search for Placement Providers
         * @param {Pageable} page 
         * @param {string} [name] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlacementProviders(page: Pageable, name?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<PlacementProviderResponseDto>> {
            return localVarFp.getPlacementProviders(page, name, options).then((request) => request(axios, basePath));
        },
        /**
         * Get Placement Providers paged Overview
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {Pageable} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlacementProvidersOverview(startDate: string, endDate: string, page: Pageable, options?: RawAxiosRequestConfig): AxiosPromise<PagedPlacementProviderOverviewDto> {
            return localVarFp.getPlacementProvidersOverview(startDate, endDate, page, options).then((request) => request(axios, basePath));
        },
        /**
         * Get platform revenue by currency and day within a date range: net revenue (commission) and VAT from all Invoices created in the range (both Advertiser and Placement Provider), plus gross revenue - the ad value Advertisers actually paid us, from PAID BUYING_ADS Payments received in the range
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlatformRevenue(startDate: string, endDate: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<PlatformRevenueDto>> {
            return localVarFp.getPlatformRevenue(startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * Get live backlog counts and ids for every Admin validation queue (proof of company, ad creatives, proof of ads, missing proof of ads, transfer-requested payments, pending access requests)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSectionCounts(options?: RawAxiosRequestConfig): AxiosPromise<Array<AdminSectionCountDto>> {
            return localVarFp.getSectionCounts(options).then((request) => request(axios, basePath));
        },
        /**
         * Get paged TRANSFER_REQUESTED Payments, awaiting Wise transfer confirmation
         * @param {Pageable} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransferRequestedPayments(page: Pageable, options?: RawAxiosRequestConfig): AxiosPromise<PagedPaymentsResponse> {
            return localVarFp.getTransferRequestedPayments(page, options).then((request) => request(axios, basePath));
        },
        /**
         * To get Ads that haven\'t been verified yet
         * @param {Pageable} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnverifiedAds(page: Pageable, options?: RawAxiosRequestConfig): AxiosPromise<Array<ProofOfAdDto>> {
            return localVarFp.getUnverifiedAds(page, options).then((request) => request(axios, basePath));
        },
        /**
         * To mark a payment as Done
         * @param {string} paymentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markPaymentAsDone(paymentId: string, options?: RawAxiosRequestConfig): AxiosPromise<PaymentDataDto> {
            return localVarFp.markPaymentAsDone(paymentId, options).then((request) => request(axios, basePath));
        },
        /**
         * To refund an Advertiser, on a Campaign, by Outdoor ID\'s and number of days to refund on each
         * @param {string} campaignId 
         * @param {CampaignRefundsDto} campaignRefundsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refundByOutdoorIdsInCampaign(campaignId: string, campaignRefundsDto: CampaignRefundsDto, options?: RawAxiosRequestConfig): AxiosPromise<CampaignResponseDto> {
            return localVarFp.refundByOutdoorIdsInCampaign(campaignId, campaignRefundsDto, options).then((request) => request(axios, basePath));
        },
        /**
         * To reject an unverified File
         * @param {string} fileId 
         * @param {RejectFileByIdTypeEnum} type 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectFileById(fileId: string, type: RejectFileByIdTypeEnum, options?: RawAxiosRequestConfig): AxiosPromise<UploadedFileDto> {
            return localVarFp.rejectFileById(fileId, type, options).then((request) => request(axios, basePath));
        },
        /**
         * Reject Pending request to Business Entity
         * @param {string} accessRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectPendingAccessRequest(accessRequestId: string, options?: RawAxiosRequestConfig): AxiosPromise<AccessRequestDto> {
            return localVarFp.rejectPendingAccessRequest(accessRequestId, options).then((request) => request(axios, basePath));
        },
        /**
         * Set how many commission-free sales a Business Entity (Advertiser or Placement Provider) has left. While positive, its sales carry no platform commission (nor VAT on it) and no commission invoice; one is used per paid Campaign.
         * @param {string} businessEntityId 
         * @param {FreeCommissionsRequestDto} freeCommissionsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setFreeCommissions(businessEntityId: string, freeCommissionsRequestDto: FreeCommissionsRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<FreeCommissionsDto> {
            return localVarFp.setFreeCommissions(businessEntityId, freeCommissionsRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * To get a SAS upload URL for the document evidencing a manual settlement of a Placement Provider\'s outstanding Debt
         * @param {string} placementProviderId 
         * @param {SettlePlacementProviderDebtRequestDto} settlePlacementProviderDebtRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        settlePlacementProviderDebt(placementProviderId: string, settlePlacementProviderDebtRequestDto: SettlePlacementProviderDebtRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<SettlePlacementProviderDebtUploadUrlDto> {
            return localVarFp.settlePlacementProviderDebt(placementProviderId, settlePlacementProviderDebtRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminControllerApi - object-oriented interface
 */
export class AdminControllerApi extends BaseAPI {
    /**
     * To approve an unverified File
     * @param {string} fileId 
     * @param {ApproveFileByIdTypeEnum} type 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public approveFileById(fileId: string, type: ApproveFileByIdTypeEnum, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).approveFileById(fileId, type, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Approve Pending request to Business Entity
     * @param {string} accessRequestId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public approvePendingAccessRequest(accessRequestId: string, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).approvePendingAccessRequest(accessRequestId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search for Campaigns
     * @param {Pageable} pageable 
     * @param {SearchCampaignsDto} searchCampaignsDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public campaignsSearch(pageable: Pageable, searchCampaignsDto: SearchCampaignsDto, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).campaignsSearch(pageable, searchCampaignsDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Check on Transfer Requested Payment by Transfer ID
     * @param {number} transferId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public checkPaymentByTransferId(transferId: number, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).checkPaymentByTransferId(transferId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search for Advertisers
     * @param {Pageable} page 
     * @param {string} [name] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAdvertisers(page: Pageable, name?: string, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).getAdvertisers(page, name, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get Advertisers paged Overview
     * @param {string} startDate 
     * @param {string} endDate 
     * @param {Pageable} page 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAdvertisersOverview(startDate: string, endDate: string, page: Pageable, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).getAdvertisersOverview(startDate, endDate, page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get an upload SAS URL for a CSV file of Outdoors to bulk-import for a Placement Provider. Once the file finishes uploading, its rows are imported asynchronously (see BlobCreatedHandler.handleOutdoorsCsvUploaded)
     * @param {string} businessEntityId 
     * @param {string} fileName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getOutdoorsCsvUploadUrl(businessEntityId: string, fileName: string, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).getOutdoorsCsvUploadUrl(businessEntityId, fileName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get paged installments still not paid 6 days after their due date (the debit\'s confirmation window), by due date
     * @param {Pageable} page 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getOverdueInstallments(page: Pageable, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).getOverdueInstallments(page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * To get a paged list of Placement Provider Debts, grouped by Placement Provider
     * @param {Pageable} page 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPagedDebts(page: Pageable, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).getPagedDebts(page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get payments by status
     * @param {GetPaymentsByStatusStatusEnum} status 
     * @param {Pageable} page 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPaymentsByStatus(status: GetPaymentsByStatusStatusEnum, page: Pageable, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).getPaymentsByStatus(status, page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Pending requests to Business Entities
     * @param {Pageable} page 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPendingAccessRequests(page: Pageable, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).getPendingAccessRequests(page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Manual Verification of Ads
     * @param {Pageable} page 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPendingAds(page: Pageable, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).getPendingAds(page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Manual Verification of Business proofs
     * @param {Pageable} page 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPendingBusinessProofs(page: Pageable, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).getPendingBusinessProofs(page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get pending payments
     * @param {Pageable} page 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPendingPayments(page: Pageable, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).getPendingPayments(page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Manual Verification of Proof of Ads
     * @param {Pageable} page 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPendingProofOfAds(page: Pageable, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).getPendingProofOfAds(page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search for Placement Providers
     * @param {Pageable} page 
     * @param {string} [name] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPlacementProviders(page: Pageable, name?: string, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).getPlacementProviders(page, name, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get Placement Providers paged Overview
     * @param {string} startDate 
     * @param {string} endDate 
     * @param {Pageable} page 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPlacementProvidersOverview(startDate: string, endDate: string, page: Pageable, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).getPlacementProvidersOverview(startDate, endDate, page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get platform revenue by currency and day within a date range: net revenue (commission) and VAT from all Invoices created in the range (both Advertiser and Placement Provider), plus gross revenue - the ad value Advertisers actually paid us, from PAID BUYING_ADS Payments received in the range
     * @param {string} startDate 
     * @param {string} endDate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPlatformRevenue(startDate: string, endDate: string, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).getPlatformRevenue(startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get live backlog counts and ids for every Admin validation queue (proof of company, ad creatives, proof of ads, missing proof of ads, transfer-requested payments, pending access requests)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getSectionCounts(options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).getSectionCounts(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get paged TRANSFER_REQUESTED Payments, awaiting Wise transfer confirmation
     * @param {Pageable} page 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getTransferRequestedPayments(page: Pageable, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).getTransferRequestedPayments(page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * To get Ads that haven\'t been verified yet
     * @param {Pageable} page 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getUnverifiedAds(page: Pageable, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).getUnverifiedAds(page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * To mark a payment as Done
     * @param {string} paymentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public markPaymentAsDone(paymentId: string, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).markPaymentAsDone(paymentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * To refund an Advertiser, on a Campaign, by Outdoor ID\'s and number of days to refund on each
     * @param {string} campaignId 
     * @param {CampaignRefundsDto} campaignRefundsDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public refundByOutdoorIdsInCampaign(campaignId: string, campaignRefundsDto: CampaignRefundsDto, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).refundByOutdoorIdsInCampaign(campaignId, campaignRefundsDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * To reject an unverified File
     * @param {string} fileId 
     * @param {RejectFileByIdTypeEnum} type 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public rejectFileById(fileId: string, type: RejectFileByIdTypeEnum, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).rejectFileById(fileId, type, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Reject Pending request to Business Entity
     * @param {string} accessRequestId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public rejectPendingAccessRequest(accessRequestId: string, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).rejectPendingAccessRequest(accessRequestId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Set how many commission-free sales a Business Entity (Advertiser or Placement Provider) has left. While positive, its sales carry no platform commission (nor VAT on it) and no commission invoice; one is used per paid Campaign.
     * @param {string} businessEntityId 
     * @param {FreeCommissionsRequestDto} freeCommissionsRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public setFreeCommissions(businessEntityId: string, freeCommissionsRequestDto: FreeCommissionsRequestDto, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).setFreeCommissions(businessEntityId, freeCommissionsRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * To get a SAS upload URL for the document evidencing a manual settlement of a Placement Provider\'s outstanding Debt
     * @param {string} placementProviderId 
     * @param {SettlePlacementProviderDebtRequestDto} settlePlacementProviderDebtRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public settlePlacementProviderDebt(placementProviderId: string, settlePlacementProviderDebtRequestDto: SettlePlacementProviderDebtRequestDto, options?: RawAxiosRequestConfig) {
        return AdminControllerApiFp(this.configuration).settlePlacementProviderDebt(placementProviderId, settlePlacementProviderDebtRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}

export const ApproveFileByIdTypeEnum = {
    ProofOfCompany: 'PROOF_OF_COMPANY',
    Ad: 'AD',
    ProofOfAd: 'PROOF_OF_AD',
} as const;
export type ApproveFileByIdTypeEnum = typeof ApproveFileByIdTypeEnum[keyof typeof ApproveFileByIdTypeEnum];
export const GetPaymentsByStatusStatusEnum = {
    Pending: 'PENDING',
    ValidatingPayment: 'VALIDATING_PAYMENT',
    ManualValidation: 'MANUAL_VALIDATION',
    TransferRequested: 'TRANSFER_REQUESTED',
    Paid: 'PAID',
    Cancelled: 'CANCELLED',
    PartiallyRefunded: 'PARTIALLY_REFUNDED',
    FullyRefunded: 'FULLY_REFUNDED',
    Failed: 'FAILED',
} as const;
export type GetPaymentsByStatusStatusEnum = typeof GetPaymentsByStatusStatusEnum[keyof typeof GetPaymentsByStatusStatusEnum];
export const RejectFileByIdTypeEnum = {
    ProofOfCompany: 'PROOF_OF_COMPANY',
    Ad: 'AD',
    ProofOfAd: 'PROOF_OF_AD',
} as const;
export type RejectFileByIdTypeEnum = typeof RejectFileByIdTypeEnum[keyof typeof RejectFileByIdTypeEnum];


/**
 * ApprovalEndpointsApi - axios parameter creator
 */
export const ApprovalEndpointsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get the calling Placement Provider\'s Outdoors in a Campaign, with what each earns them
         * @param {string} campaignId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApprovals: async (campaignId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'campaignId' is not null or undefined
            assertParamExists('getApprovals', 'campaignId', campaignId)
            const localVarPath = `/api/v1/approvals/{campaignId}`
                .replace('{campaignId}', encodeURIComponent(String(campaignId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * A page of Campaigns still being confirmed, each with the caller\'s Outdoors in it they haven\'t answered on yet - the most immediate first, by the earliest start date of those Outdoors.
         * @summary Get the Campaigns waiting on the calling Placement Provider\'s answer
         * @param {Pageable} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCampaignsAwaitingFeedback: async (page: Pageable, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('getCampaignsAwaitingFeedback', 'page', page)
            const localVarPath = `/api/v1/approvals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                for (const [key, value] of Object.entries(page)) {
                    localVarQueryParameter[key] = value;
                }
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * One entry per Campaign Outdoor of theirs. An UNAVAILABLE one needs the time range the Outdoor is blocked for.
         * @summary Say whether each of the calling Placement Provider\'s Outdoors in a Campaign is available (APPROVED) or UNAVAILABLE
         * @param {string} campaignId 
         * @param {Array<CampaignOutdoorFeedbackDto>} campaignOutdoorFeedbackDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        giveFeedback: async (campaignId: string, campaignOutdoorFeedbackDto: Array<CampaignOutdoorFeedbackDto>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'campaignId' is not null or undefined
            assertParamExists('giveFeedback', 'campaignId', campaignId)
            // verify required parameter 'campaignOutdoorFeedbackDto' is not null or undefined
            assertParamExists('giveFeedback', 'campaignOutdoorFeedbackDto', campaignOutdoorFeedbackDto)
            const localVarPath = `/api/v1/approvals/{campaignId}/feedback`
                .replace('{campaignId}', encodeURIComponent(String(campaignId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(campaignOutdoorFeedbackDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ApprovalEndpointsApi - functional programming interface
 */
export const ApprovalEndpointsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ApprovalEndpointsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get the calling Placement Provider\'s Outdoors in a Campaign, with what each earns them
         * @param {string} campaignId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApprovals(campaignId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CampaignOutdoorApprovalDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApprovals(campaignId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApprovalEndpointsApi.getApprovals']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * A page of Campaigns still being confirmed, each with the caller\'s Outdoors in it they haven\'t answered on yet - the most immediate first, by the earliest start date of those Outdoors.
         * @summary Get the Campaigns waiting on the calling Placement Provider\'s answer
         * @param {Pageable} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCampaignsAwaitingFeedback(page: Pageable, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedCampaignApprovalsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCampaignsAwaitingFeedback(page, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApprovalEndpointsApi.getCampaignsAwaitingFeedback']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * One entry per Campaign Outdoor of theirs. An UNAVAILABLE one needs the time range the Outdoor is blocked for.
         * @summary Say whether each of the calling Placement Provider\'s Outdoors in a Campaign is available (APPROVED) or UNAVAILABLE
         * @param {string} campaignId 
         * @param {Array<CampaignOutdoorFeedbackDto>} campaignOutdoorFeedbackDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async giveFeedback(campaignId: string, campaignOutdoorFeedbackDto: Array<CampaignOutdoorFeedbackDto>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CampaignOutdoorApprovalDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.giveFeedback(campaignId, campaignOutdoorFeedbackDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApprovalEndpointsApi.giveFeedback']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ApprovalEndpointsApi - factory interface
 */
export const ApprovalEndpointsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ApprovalEndpointsApiFp(configuration)
    return {
        /**
         * 
         * @summary Get the calling Placement Provider\'s Outdoors in a Campaign, with what each earns them
         * @param {string} campaignId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApprovals(campaignId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<CampaignOutdoorApprovalDto>> {
            return localVarFp.getApprovals(campaignId, options).then((request) => request(axios, basePath));
        },
        /**
         * A page of Campaigns still being confirmed, each with the caller\'s Outdoors in it they haven\'t answered on yet - the most immediate first, by the earliest start date of those Outdoors.
         * @summary Get the Campaigns waiting on the calling Placement Provider\'s answer
         * @param {Pageable} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCampaignsAwaitingFeedback(page: Pageable, options?: RawAxiosRequestConfig): AxiosPromise<PagedCampaignApprovalsDto> {
            return localVarFp.getCampaignsAwaitingFeedback(page, options).then((request) => request(axios, basePath));
        },
        /**
         * One entry per Campaign Outdoor of theirs. An UNAVAILABLE one needs the time range the Outdoor is blocked for.
         * @summary Say whether each of the calling Placement Provider\'s Outdoors in a Campaign is available (APPROVED) or UNAVAILABLE
         * @param {string} campaignId 
         * @param {Array<CampaignOutdoorFeedbackDto>} campaignOutdoorFeedbackDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        giveFeedback(campaignId: string, campaignOutdoorFeedbackDto: Array<CampaignOutdoorFeedbackDto>, options?: RawAxiosRequestConfig): AxiosPromise<Array<CampaignOutdoorApprovalDto>> {
            return localVarFp.giveFeedback(campaignId, campaignOutdoorFeedbackDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ApprovalEndpointsApi - object-oriented interface
 */
export class ApprovalEndpointsApi extends BaseAPI {
    /**
     * 
     * @summary Get the calling Placement Provider\'s Outdoors in a Campaign, with what each earns them
     * @param {string} campaignId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getApprovals(campaignId: string, options?: RawAxiosRequestConfig) {
        return ApprovalEndpointsApiFp(this.configuration).getApprovals(campaignId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * A page of Campaigns still being confirmed, each with the caller\'s Outdoors in it they haven\'t answered on yet - the most immediate first, by the earliest start date of those Outdoors.
     * @summary Get the Campaigns waiting on the calling Placement Provider\'s answer
     * @param {Pageable} page 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCampaignsAwaitingFeedback(page: Pageable, options?: RawAxiosRequestConfig) {
        return ApprovalEndpointsApiFp(this.configuration).getCampaignsAwaitingFeedback(page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * One entry per Campaign Outdoor of theirs. An UNAVAILABLE one needs the time range the Outdoor is blocked for.
     * @summary Say whether each of the calling Placement Provider\'s Outdoors in a Campaign is available (APPROVED) or UNAVAILABLE
     * @param {string} campaignId 
     * @param {Array<CampaignOutdoorFeedbackDto>} campaignOutdoorFeedbackDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public giveFeedback(campaignId: string, campaignOutdoorFeedbackDto: Array<CampaignOutdoorFeedbackDto>, options?: RawAxiosRequestConfig) {
        return ApprovalEndpointsApiFp(this.configuration).giveFeedback(campaignId, campaignOutdoorFeedbackDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AuthControllerApi - axios parameter creator
 */
export const AuthControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary To login a User
         * @param {LoginRequestDto} loginRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login: async (loginRequestDto: LoginRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loginRequestDto' is not null or undefined
            assertParamExists('login', 'loginRequestDto', loginRequestDto)
            const localVarPath = `/api/v1/auth/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loginRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary To refresh a User token
         * @param {RefreshTokenRequest} refreshTokenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshToken: async (refreshTokenRequest: RefreshTokenRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'refreshTokenRequest' is not null or undefined
            assertParamExists('refreshToken', 'refreshTokenRequest', refreshTokenRequest)
            const localVarPath = `/api/v1/auth/refresh`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(refreshTokenRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthControllerApi - functional programming interface
 */
export const AuthControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary To login a User
         * @param {LoginRequestDto} loginRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async login(loginRequestDto: LoginRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TokenDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.login(loginRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthControllerApi.login']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary To refresh a User token
         * @param {RefreshTokenRequest} refreshTokenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async refreshToken(refreshTokenRequest: RefreshTokenRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TokenDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.refreshToken(refreshTokenRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthControllerApi.refreshToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AuthControllerApi - factory interface
 */
export const AuthControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary To login a User
         * @param {LoginRequestDto} loginRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login(loginRequestDto: LoginRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<TokenDto> {
            return localVarFp.login(loginRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary To refresh a User token
         * @param {RefreshTokenRequest} refreshTokenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshToken(refreshTokenRequest: RefreshTokenRequest, options?: RawAxiosRequestConfig): AxiosPromise<TokenDto> {
            return localVarFp.refreshToken(refreshTokenRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuthControllerApi - object-oriented interface
 */
export class AuthControllerApi extends BaseAPI {
    /**
     * 
     * @summary To login a User
     * @param {LoginRequestDto} loginRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public login(loginRequestDto: LoginRequestDto, options?: RawAxiosRequestConfig) {
        return AuthControllerApiFp(this.configuration).login(loginRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary To refresh a User token
     * @param {RefreshTokenRequest} refreshTokenRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public refreshToken(refreshTokenRequest: RefreshTokenRequest, options?: RawAxiosRequestConfig) {
        return AuthControllerApiFp(this.configuration).refreshToken(refreshTokenRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BusinessEntityControllerApi - axios parameter creator
 */
export const BusinessEntityControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * To approve access to a Business Entity
         * @param {string} businessEntityId 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveAccess: async (businessEntityId: string, userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessEntityId' is not null or undefined
            assertParamExists('approveAccess', 'businessEntityId', businessEntityId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('approveAccess', 'userId', userId)
            const localVarPath = `/api/v1/business-entities/{businessEntityId}/accesses/{userId}/approve`
                .replace('{businessEntityId}', encodeURIComponent(String(businessEntityId)))
                .replace('{userId}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * To cancel access request to a Business Entity
         * @param {string} businessEntityId 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelAccess: async (businessEntityId: string, userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessEntityId' is not null or undefined
            assertParamExists('cancelAccess', 'businessEntityId', businessEntityId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('cancelAccess', 'userId', userId)
            const localVarPath = `/api/v1/business-entities/{businessEntityId}/accesses/{userId}/cancel`
                .replace('{businessEntityId}', encodeURIComponent(String(businessEntityId)))
                .replace('{userId}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Cancel Business invitation
         * @param {string} businessEntityId 
         * @param {string} invitationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelBusinessInvitation: async (businessEntityId: string, invitationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessEntityId' is not null or undefined
            assertParamExists('cancelBusinessInvitation', 'businessEntityId', businessEntityId)
            // verify required parameter 'invitationId' is not null or undefined
            assertParamExists('cancelBusinessInvitation', 'invitationId', invitationId)
            const localVarPath = `/api/v1/business-entities/{businessEntityId}/invitations/{invitationId}/cancel`
                .replace('{businessEntityId}', encodeURIComponent(String(businessEntityId)))
                .replace('{invitationId}', encodeURIComponent(String(invitationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary To create a Business Entity
         * @param {CreateBusinessEntityRequestDto} createBusinessEntityRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBusinessEntity: async (createBusinessEntityRequestDto: CreateBusinessEntityRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createBusinessEntityRequestDto' is not null or undefined
            assertParamExists('createBusinessEntity', 'createBusinessEntityRequestDto', createBusinessEntityRequestDto)
            const localVarPath = `/api/v1/business-entities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createBusinessEntityRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Send Business invitation to User
         * @param {string} businessEntityId 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInvitation: async (businessEntityId: string, email: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessEntityId' is not null or undefined
            assertParamExists('createInvitation', 'businessEntityId', businessEntityId)
            // verify required parameter 'email' is not null or undefined
            assertParamExists('createInvitation', 'email', email)
            const localVarPath = `/api/v1/business-entities/{businessEntityId}/invitations`
                .replace('{businessEntityId}', encodeURIComponent(String(businessEntityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary To delete a Business invitation
         * @param {string} businessEntityId 
         * @param {string} invitationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteInvitation: async (businessEntityId: string, invitationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessEntityId' is not null or undefined
            assertParamExists('deleteInvitation', 'businessEntityId', businessEntityId)
            // verify required parameter 'invitationId' is not null or undefined
            assertParamExists('deleteInvitation', 'invitationId', invitationId)
            const localVarPath = `/api/v1/business-entities/{businessEntityId}/invitations/{invitationId}`
                .replace('{businessEntityId}', encodeURIComponent(String(businessEntityId)))
                .replace('{invitationId}', encodeURIComponent(String(invitationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * To get access request to a Business Entity by User ID
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccessByUser: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getAccessByUser', 'userId', userId)
            const localVarPath = `/api/v1/business-entities/accesses/{userId}`
                .replace('{userId}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * To get access requests to Business Entity
         * @param {string} businessEntityId 
         * @param {Pageable} page 
         * @param {Set<GetAccessesStatusesEnum>} [statuses] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccesses: async (businessEntityId: string, page: Pageable, statuses?: Set<GetAccessesStatusesEnum>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessEntityId' is not null or undefined
            assertParamExists('getAccesses', 'businessEntityId', businessEntityId)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('getAccesses', 'page', page)
            const localVarPath = `/api/v1/business-entities/{businessEntityId}/accesses`
                .replace('{businessEntityId}', encodeURIComponent(String(businessEntityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (statuses) {
                localVarQueryParameter['statuses'] = Array.from(statuses);
            }

            if (page !== undefined) {
                for (const [key, value] of Object.entries(page)) {
                    localVarQueryParameter[key] = value;
                }
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get Active users of Business Entity
         * @param {string} businessEntityId 
         * @param {Pageable} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveUsersFromBusiness: async (businessEntityId: string, page: Pageable, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessEntityId' is not null or undefined
            assertParamExists('getActiveUsersFromBusiness', 'businessEntityId', businessEntityId)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('getActiveUsersFromBusiness', 'page', page)
            const localVarPath = `/api/v1/business-entities/{businessEntityId}/active-users`
                .replace('{businessEntityId}', encodeURIComponent(String(businessEntityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                for (const [key, value] of Object.entries(page)) {
                    localVarQueryParameter[key] = value;
                }
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary To get performance Overview of an Advertiser
         * @param {string} advertiserId 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdvertiserOverview: async (advertiserId: string, startDate?: string, endDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'advertiserId' is not null or undefined
            assertParamExists('getAdvertiserOverview', 'advertiserId', advertiserId)
            const localVarPath = `/api/v1/business-entities/advertisers/{advertiserId}/overview`
                .replace('{advertiserId}', encodeURIComponent(String(advertiserId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString().substring(0,10) :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString().substring(0,10) :
                    endDate;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * To get a Business Entity
         * @param {string} businessEntityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBusinessEntity: async (businessEntityId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessEntityId' is not null or undefined
            assertParamExists('getBusinessEntity', 'businessEntityId', businessEntityId)
            const localVarPath = `/api/v1/business-entities/{businessEntityId}`
                .replace('{businessEntityId}', encodeURIComponent(String(businessEntityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Send Business invitation to User
         * @param {string} businessEntityId 
         * @param {Pageable} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBusinessPendingInvitation: async (businessEntityId: string, page: Pageable, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessEntityId' is not null or undefined
            assertParamExists('getBusinessPendingInvitation', 'businessEntityId', businessEntityId)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('getBusinessPendingInvitation', 'page', page)
            const localVarPath = `/api/v1/business-entities/{businessEntityId}/invitations/pending`
                .replace('{businessEntityId}', encodeURIComponent(String(businessEntityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                for (const [key, value] of Object.entries(page)) {
                    localVarQueryParameter[key] = value;
                }
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * To get platform commissions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommissions: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/business-entities/commissions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary To get performance Overview of Placement Provider
         * @param {string} placementProviderId 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlacementProviderOverview: async (placementProviderId: string, startDate?: string, endDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'placementProviderId' is not null or undefined
            assertParamExists('getPlacementProviderOverview', 'placementProviderId', placementProviderId)
            const localVarPath = `/api/v1/business-entities/placement-providers/{placementProviderId}/overview`
                .replace('{placementProviderId}', encodeURIComponent(String(placementProviderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString().substring(0,10) :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString().substring(0,10) :
                    endDate;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * To reject access to a Business Entity
         * @param {string} businessEntityId 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectAccess: async (businessEntityId: string, userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessEntityId' is not null or undefined
            assertParamExists('rejectAccess', 'businessEntityId', businessEntityId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('rejectAccess', 'userId', userId)
            const localVarPath = `/api/v1/business-entities/{businessEntityId}/accesses/{userId}/reject`
                .replace('{businessEntityId}', encodeURIComponent(String(businessEntityId)))
                .replace('{userId}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * To request access to a Business Entity
         * @param {string} businessEntityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestAccess: async (businessEntityId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessEntityId' is not null or undefined
            assertParamExists('requestAccess', 'businessEntityId', businessEntityId)
            const localVarPath = `/api/v1/business-entities/{businessEntityId}/accesses`
                .replace('{businessEntityId}', encodeURIComponent(String(businessEntityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search for Business Entities
         * @param {Pageable} page 
         * @param {string} [name] 
         * @param {SearchBusinessEntitiesTypeEnum} [type] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchBusinessEntities: async (page: Pageable, name?: string, type?: SearchBusinessEntitiesTypeEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('searchBusinessEntities', 'page', page)
            const localVarPath = `/api/v1/business-entities/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (page !== undefined) {
                for (const [key, value] of Object.entries(page)) {
                    localVarQueryParameter[key] = value;
                }
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * To update a Business Entity\'s bank details
         * @param {string} id 
         * @param {BankDetailsDto} bankDetailsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBankDetails: async (id: string, bankDetailsDto: BankDetailsDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateBankDetails', 'id', id)
            // verify required parameter 'bankDetailsDto' is not null or undefined
            assertParamExists('updateBankDetails', 'bankDetailsDto', bankDetailsDto)
            const localVarPath = `/api/v1/business-entities/{id}/bank-details`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bankDetailsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary To update a Business Entity
         * @param {string} id 
         * @param {UpdateBusinessEntityRequestDto} updateBusinessEntityRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBusinessEntity: async (id: string, updateBusinessEntityRequestDto: UpdateBusinessEntityRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateBusinessEntity', 'id', id)
            // verify required parameter 'updateBusinessEntityRequestDto' is not null or undefined
            assertParamExists('updateBusinessEntity', 'updateBusinessEntityRequestDto', updateBusinessEntityRequestDto)
            const localVarPath = `/api/v1/business-entities/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateBusinessEntityRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary To get new Upload URL for Proof of Company document
         * @param {string} id 
         * @param {string} fileName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProofOfCompany: async (id: string, fileName: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateProofOfCompany', 'id', id)
            // verify required parameter 'fileName' is not null or undefined
            assertParamExists('updateProofOfCompany', 'fileName', fileName)
            const localVarPath = `/api/v1/business-entities/{id}/proof-of-file`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (fileName !== undefined) {
                localVarQueryParameter['fileName'] = fileName;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BusinessEntityControllerApi - functional programming interface
 */
export const BusinessEntityControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BusinessEntityControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * To approve access to a Business Entity
         * @param {string} businessEntityId 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async approveAccess(businessEntityId: string, userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccessRequestDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.approveAccess(businessEntityId, userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BusinessEntityControllerApi.approveAccess']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * To cancel access request to a Business Entity
         * @param {string} businessEntityId 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelAccess(businessEntityId: string, userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccessRequestDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelAccess(businessEntityId, userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BusinessEntityControllerApi.cancelAccess']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Cancel Business invitation
         * @param {string} businessEntityId 
         * @param {string} invitationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelBusinessInvitation(businessEntityId: string, invitationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelBusinessInvitation(businessEntityId, invitationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BusinessEntityControllerApi.cancelBusinessInvitation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary To create a Business Entity
         * @param {CreateBusinessEntityRequestDto} createBusinessEntityRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createBusinessEntity(createBusinessEntityRequestDto: CreateBusinessEntityRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateBusinessEntityResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createBusinessEntity(createBusinessEntityRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BusinessEntityControllerApi.createBusinessEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Send Business invitation to User
         * @param {string} businessEntityId 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createInvitation(businessEntityId: string, email: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createInvitation(businessEntityId, email, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BusinessEntityControllerApi.createInvitation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary To delete a Business invitation
         * @param {string} businessEntityId 
         * @param {string} invitationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteInvitation(businessEntityId: string, invitationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteInvitation(businessEntityId, invitationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BusinessEntityControllerApi.deleteInvitation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * To get access request to a Business Entity by User ID
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccessByUser(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccessRequestDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccessByUser(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BusinessEntityControllerApi.getAccessByUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * To get access requests to Business Entity
         * @param {string} businessEntityId 
         * @param {Pageable} page 
         * @param {Set<GetAccessesStatusesEnum>} [statuses] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccesses(businessEntityId: string, page: Pageable, statuses?: Set<GetAccessesStatusesEnum>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedAccessRequestResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccesses(businessEntityId, page, statuses, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BusinessEntityControllerApi.getAccesses']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get Active users of Business Entity
         * @param {string} businessEntityId 
         * @param {Pageable} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getActiveUsersFromBusiness(businessEntityId: string, page: Pageable, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedUsersDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getActiveUsersFromBusiness(businessEntityId, page, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BusinessEntityControllerApi.getActiveUsersFromBusiness']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary To get performance Overview of an Advertiser
         * @param {string} advertiserId 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdvertiserOverview(advertiserId: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdvertiserOverviewDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdvertiserOverview(advertiserId, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BusinessEntityControllerApi.getAdvertiserOverview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * To get a Business Entity
         * @param {string} businessEntityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBusinessEntity(businessEntityId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BusinessEntityDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBusinessEntity(businessEntityId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BusinessEntityControllerApi.getBusinessEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Send Business invitation to User
         * @param {string} businessEntityId 
         * @param {Pageable} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBusinessPendingInvitation(businessEntityId: string, page: Pageable, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedBusinessInvitationsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBusinessPendingInvitation(businessEntityId, page, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BusinessEntityControllerApi.getBusinessPendingInvitation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * To get platform commissions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCommissions(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommissionsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCommissions(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BusinessEntityControllerApi.getCommissions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary To get performance Overview of Placement Provider
         * @param {string} placementProviderId 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPlacementProviderOverview(placementProviderId: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlacementProviderOverviewDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPlacementProviderOverview(placementProviderId, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BusinessEntityControllerApi.getPlacementProviderOverview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * To reject access to a Business Entity
         * @param {string} businessEntityId 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rejectAccess(businessEntityId: string, userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccessRequestDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rejectAccess(businessEntityId, userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BusinessEntityControllerApi.rejectAccess']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * To request access to a Business Entity
         * @param {string} businessEntityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestAccess(businessEntityId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccessRequestDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestAccess(businessEntityId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BusinessEntityControllerApi.requestAccess']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search for Business Entities
         * @param {Pageable} page 
         * @param {string} [name] 
         * @param {SearchBusinessEntitiesTypeEnum} [type] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchBusinessEntities(page: Pageable, name?: string, type?: SearchBusinessEntitiesTypeEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedBusinessEntitiesDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchBusinessEntities(page, name, type, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BusinessEntityControllerApi.searchBusinessEntities']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * To update a Business Entity\'s bank details
         * @param {string} id 
         * @param {BankDetailsDto} bankDetailsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateBankDetails(id: string, bankDetailsDto: BankDetailsDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BusinessEntityDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateBankDetails(id, bankDetailsDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BusinessEntityControllerApi.updateBankDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary To update a Business Entity
         * @param {string} id 
         * @param {UpdateBusinessEntityRequestDto} updateBusinessEntityRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateBusinessEntity(id: string, updateBusinessEntityRequestDto: UpdateBusinessEntityRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BusinessEntityDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateBusinessEntity(id, updateBusinessEntityRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BusinessEntityControllerApi.updateBusinessEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary To get new Upload URL for Proof of Company document
         * @param {string} id 
         * @param {string} fileName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProofOfCompany(id: string, fileName: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateProofFileResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProofOfCompany(id, fileName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BusinessEntityControllerApi.updateProofOfCompany']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BusinessEntityControllerApi - factory interface
 */
export const BusinessEntityControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BusinessEntityControllerApiFp(configuration)
    return {
        /**
         * To approve access to a Business Entity
         * @param {string} businessEntityId 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveAccess(businessEntityId: string, userId: string, options?: RawAxiosRequestConfig): AxiosPromise<AccessRequestDto> {
            return localVarFp.approveAccess(businessEntityId, userId, options).then((request) => request(axios, basePath));
        },
        /**
         * To cancel access request to a Business Entity
         * @param {string} businessEntityId 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelAccess(businessEntityId: string, userId: string, options?: RawAxiosRequestConfig): AxiosPromise<AccessRequestDto> {
            return localVarFp.cancelAccess(businessEntityId, userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Cancel Business invitation
         * @param {string} businessEntityId 
         * @param {string} invitationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelBusinessInvitation(businessEntityId: string, invitationId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.cancelBusinessInvitation(businessEntityId, invitationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary To create a Business Entity
         * @param {CreateBusinessEntityRequestDto} createBusinessEntityRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBusinessEntity(createBusinessEntityRequestDto: CreateBusinessEntityRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<CreateBusinessEntityResponseDto> {
            return localVarFp.createBusinessEntity(createBusinessEntityRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Send Business invitation to User
         * @param {string} businessEntityId 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInvitation(businessEntityId: string, email: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.createInvitation(businessEntityId, email, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary To delete a Business invitation
         * @param {string} businessEntityId 
         * @param {string} invitationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteInvitation(businessEntityId: string, invitationId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteInvitation(businessEntityId, invitationId, options).then((request) => request(axios, basePath));
        },
        /**
         * To get access request to a Business Entity by User ID
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccessByUser(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<AccessRequestDto> {
            return localVarFp.getAccessByUser(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * To get access requests to Business Entity
         * @param {string} businessEntityId 
         * @param {Pageable} page 
         * @param {Set<GetAccessesStatusesEnum>} [statuses] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccesses(businessEntityId: string, page: Pageable, statuses?: Set<GetAccessesStatusesEnum>, options?: RawAxiosRequestConfig): AxiosPromise<PagedAccessRequestResponse> {
            return localVarFp.getAccesses(businessEntityId, page, statuses, options).then((request) => request(axios, basePath));
        },
        /**
         * Get Active users of Business Entity
         * @param {string} businessEntityId 
         * @param {Pageable} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveUsersFromBusiness(businessEntityId: string, page: Pageable, options?: RawAxiosRequestConfig): AxiosPromise<PagedUsersDto> {
            return localVarFp.getActiveUsersFromBusiness(businessEntityId, page, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary To get performance Overview of an Advertiser
         * @param {string} advertiserId 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdvertiserOverview(advertiserId: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): AxiosPromise<AdvertiserOverviewDto> {
            return localVarFp.getAdvertiserOverview(advertiserId, startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * To get a Business Entity
         * @param {string} businessEntityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBusinessEntity(businessEntityId: string, options?: RawAxiosRequestConfig): AxiosPromise<BusinessEntityDto> {
            return localVarFp.getBusinessEntity(businessEntityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Send Business invitation to User
         * @param {string} businessEntityId 
         * @param {Pageable} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBusinessPendingInvitation(businessEntityId: string, page: Pageable, options?: RawAxiosRequestConfig): AxiosPromise<PagedBusinessInvitationsDto> {
            return localVarFp.getBusinessPendingInvitation(businessEntityId, page, options).then((request) => request(axios, basePath));
        },
        /**
         * To get platform commissions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommissions(options?: RawAxiosRequestConfig): AxiosPromise<CommissionsDto> {
            return localVarFp.getCommissions(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary To get performance Overview of Placement Provider
         * @param {string} placementProviderId 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlacementProviderOverview(placementProviderId: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): AxiosPromise<PlacementProviderOverviewDto> {
            return localVarFp.getPlacementProviderOverview(placementProviderId, startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * To reject access to a Business Entity
         * @param {string} businessEntityId 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectAccess(businessEntityId: string, userId: string, options?: RawAxiosRequestConfig): AxiosPromise<AccessRequestDto> {
            return localVarFp.rejectAccess(businessEntityId, userId, options).then((request) => request(axios, basePath));
        },
        /**
         * To request access to a Business Entity
         * @param {string} businessEntityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestAccess(businessEntityId: string, options?: RawAxiosRequestConfig): AxiosPromise<AccessRequestDto> {
            return localVarFp.requestAccess(businessEntityId, options).then((request) => request(axios, basePath));
        },
        /**
         * Search for Business Entities
         * @param {Pageable} page 
         * @param {string} [name] 
         * @param {SearchBusinessEntitiesTypeEnum} [type] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchBusinessEntities(page: Pageable, name?: string, type?: SearchBusinessEntitiesTypeEnum, options?: RawAxiosRequestConfig): AxiosPromise<PagedBusinessEntitiesDto> {
            return localVarFp.searchBusinessEntities(page, name, type, options).then((request) => request(axios, basePath));
        },
        /**
         * To update a Business Entity\'s bank details
         * @param {string} id 
         * @param {BankDetailsDto} bankDetailsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBankDetails(id: string, bankDetailsDto: BankDetailsDto, options?: RawAxiosRequestConfig): AxiosPromise<BusinessEntityDto> {
            return localVarFp.updateBankDetails(id, bankDetailsDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary To update a Business Entity
         * @param {string} id 
         * @param {UpdateBusinessEntityRequestDto} updateBusinessEntityRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBusinessEntity(id: string, updateBusinessEntityRequestDto: UpdateBusinessEntityRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<BusinessEntityDto> {
            return localVarFp.updateBusinessEntity(id, updateBusinessEntityRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary To get new Upload URL for Proof of Company document
         * @param {string} id 
         * @param {string} fileName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProofOfCompany(id: string, fileName: string, options?: RawAxiosRequestConfig): AxiosPromise<UpdateProofFileResponseDto> {
            return localVarFp.updateProofOfCompany(id, fileName, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BusinessEntityControllerApi - object-oriented interface
 */
export class BusinessEntityControllerApi extends BaseAPI {
    /**
     * To approve access to a Business Entity
     * @param {string} businessEntityId 
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public approveAccess(businessEntityId: string, userId: string, options?: RawAxiosRequestConfig) {
        return BusinessEntityControllerApiFp(this.configuration).approveAccess(businessEntityId, userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * To cancel access request to a Business Entity
     * @param {string} businessEntityId 
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public cancelAccess(businessEntityId: string, userId: string, options?: RawAxiosRequestConfig) {
        return BusinessEntityControllerApiFp(this.configuration).cancelAccess(businessEntityId, userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Cancel Business invitation
     * @param {string} businessEntityId 
     * @param {string} invitationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public cancelBusinessInvitation(businessEntityId: string, invitationId: string, options?: RawAxiosRequestConfig) {
        return BusinessEntityControllerApiFp(this.configuration).cancelBusinessInvitation(businessEntityId, invitationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary To create a Business Entity
     * @param {CreateBusinessEntityRequestDto} createBusinessEntityRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createBusinessEntity(createBusinessEntityRequestDto: CreateBusinessEntityRequestDto, options?: RawAxiosRequestConfig) {
        return BusinessEntityControllerApiFp(this.configuration).createBusinessEntity(createBusinessEntityRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Send Business invitation to User
     * @param {string} businessEntityId 
     * @param {string} email 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createInvitation(businessEntityId: string, email: string, options?: RawAxiosRequestConfig) {
        return BusinessEntityControllerApiFp(this.configuration).createInvitation(businessEntityId, email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary To delete a Business invitation
     * @param {string} businessEntityId 
     * @param {string} invitationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteInvitation(businessEntityId: string, invitationId: string, options?: RawAxiosRequestConfig) {
        return BusinessEntityControllerApiFp(this.configuration).deleteInvitation(businessEntityId, invitationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * To get access request to a Business Entity by User ID
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAccessByUser(userId: string, options?: RawAxiosRequestConfig) {
        return BusinessEntityControllerApiFp(this.configuration).getAccessByUser(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * To get access requests to Business Entity
     * @param {string} businessEntityId 
     * @param {Pageable} page 
     * @param {Set<GetAccessesStatusesEnum>} [statuses] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAccesses(businessEntityId: string, page: Pageable, statuses?: Set<GetAccessesStatusesEnum>, options?: RawAxiosRequestConfig) {
        return BusinessEntityControllerApiFp(this.configuration).getAccesses(businessEntityId, page, statuses, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get Active users of Business Entity
     * @param {string} businessEntityId 
     * @param {Pageable} page 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getActiveUsersFromBusiness(businessEntityId: string, page: Pageable, options?: RawAxiosRequestConfig) {
        return BusinessEntityControllerApiFp(this.configuration).getActiveUsersFromBusiness(businessEntityId, page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary To get performance Overview of an Advertiser
     * @param {string} advertiserId 
     * @param {string} [startDate] 
     * @param {string} [endDate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAdvertiserOverview(advertiserId: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig) {
        return BusinessEntityControllerApiFp(this.configuration).getAdvertiserOverview(advertiserId, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * To get a Business Entity
     * @param {string} businessEntityId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getBusinessEntity(businessEntityId: string, options?: RawAxiosRequestConfig) {
        return BusinessEntityControllerApiFp(this.configuration).getBusinessEntity(businessEntityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Send Business invitation to User
     * @param {string} businessEntityId 
     * @param {Pageable} page 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getBusinessPendingInvitation(businessEntityId: string, page: Pageable, options?: RawAxiosRequestConfig) {
        return BusinessEntityControllerApiFp(this.configuration).getBusinessPendingInvitation(businessEntityId, page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * To get platform commissions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCommissions(options?: RawAxiosRequestConfig) {
        return BusinessEntityControllerApiFp(this.configuration).getCommissions(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary To get performance Overview of Placement Provider
     * @param {string} placementProviderId 
     * @param {string} [startDate] 
     * @param {string} [endDate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPlacementProviderOverview(placementProviderId: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig) {
        return BusinessEntityControllerApiFp(this.configuration).getPlacementProviderOverview(placementProviderId, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * To reject access to a Business Entity
     * @param {string} businessEntityId 
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public rejectAccess(businessEntityId: string, userId: string, options?: RawAxiosRequestConfig) {
        return BusinessEntityControllerApiFp(this.configuration).rejectAccess(businessEntityId, userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * To request access to a Business Entity
     * @param {string} businessEntityId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public requestAccess(businessEntityId: string, options?: RawAxiosRequestConfig) {
        return BusinessEntityControllerApiFp(this.configuration).requestAccess(businessEntityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search for Business Entities
     * @param {Pageable} page 
     * @param {string} [name] 
     * @param {SearchBusinessEntitiesTypeEnum} [type] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchBusinessEntities(page: Pageable, name?: string, type?: SearchBusinessEntitiesTypeEnum, options?: RawAxiosRequestConfig) {
        return BusinessEntityControllerApiFp(this.configuration).searchBusinessEntities(page, name, type, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * To update a Business Entity\'s bank details
     * @param {string} id 
     * @param {BankDetailsDto} bankDetailsDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateBankDetails(id: string, bankDetailsDto: BankDetailsDto, options?: RawAxiosRequestConfig) {
        return BusinessEntityControllerApiFp(this.configuration).updateBankDetails(id, bankDetailsDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary To update a Business Entity
     * @param {string} id 
     * @param {UpdateBusinessEntityRequestDto} updateBusinessEntityRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateBusinessEntity(id: string, updateBusinessEntityRequestDto: UpdateBusinessEntityRequestDto, options?: RawAxiosRequestConfig) {
        return BusinessEntityControllerApiFp(this.configuration).updateBusinessEntity(id, updateBusinessEntityRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary To get new Upload URL for Proof of Company document
     * @param {string} id 
     * @param {string} fileName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateProofOfCompany(id: string, fileName: string, options?: RawAxiosRequestConfig) {
        return BusinessEntityControllerApiFp(this.configuration).updateProofOfCompany(id, fileName, options).then((request) => request(this.axios, this.basePath));
    }
}

export const GetAccessesStatusesEnum = {
    Pending: 'PENDING',
    Approved: 'APPROVED',
    Rejected: 'REJECTED',
    Revoked: 'REVOKED',
    Cancelled: 'CANCELLED',
} as const;
export type GetAccessesStatusesEnum = typeof GetAccessesStatusesEnum[keyof typeof GetAccessesStatusesEnum];
export const SearchBusinessEntitiesTypeEnum = {
    PlacementProvider: 'PLACEMENT_PROVIDER',
    Advertiser: 'ADVERTISER',
} as const;
export type SearchBusinessEntitiesTypeEnum = typeof SearchBusinessEntitiesTypeEnum[keyof typeof SearchBusinessEntitiesTypeEnum];


/**
 * BusinessInvitationsApi - axios parameter creator
 */
export const BusinessInvitationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * To accept a business invitation
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptById: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('acceptById', 'id', id)
            const localVarPath = `/api/v1/business-invitations/{id}/accept`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get business invitations by email
         * @param {string} email 
         * @param {Pageable} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findPendingByEmail: async (email: string, page: Pageable, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('findPendingByEmail', 'email', email)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('findPendingByEmail', 'page', page)
            const localVarPath = `/api/v1/business-invitations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (page !== undefined) {
                for (const [key, value] of Object.entries(page)) {
                    localVarQueryParameter[key] = value;
                }
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * To reject a business invitation
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectById: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('rejectById', 'id', id)
            const localVarPath = `/api/v1/business-invitations/{id}/reject`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BusinessInvitationsApi - functional programming interface
 */
export const BusinessInvitationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BusinessInvitationsApiAxiosParamCreator(configuration)
    return {
        /**
         * To accept a business invitation
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async acceptById(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.acceptById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BusinessInvitationsApi.acceptById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get business invitations by email
         * @param {string} email 
         * @param {Pageable} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findPendingByEmail(email: string, page: Pageable, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedBusinessInvitations>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findPendingByEmail(email, page, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BusinessInvitationsApi.findPendingByEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * To reject a business invitation
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rejectById(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rejectById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BusinessInvitationsApi.rejectById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BusinessInvitationsApi - factory interface
 */
export const BusinessInvitationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BusinessInvitationsApiFp(configuration)
    return {
        /**
         * To accept a business invitation
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptById(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.acceptById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get business invitations by email
         * @param {string} email 
         * @param {Pageable} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findPendingByEmail(email: string, page: Pageable, options?: RawAxiosRequestConfig): AxiosPromise<PagedBusinessInvitations> {
            return localVarFp.findPendingByEmail(email, page, options).then((request) => request(axios, basePath));
        },
        /**
         * To reject a business invitation
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectById(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.rejectById(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BusinessInvitationsApi - object-oriented interface
 */
export class BusinessInvitationsApi extends BaseAPI {
    /**
     * To accept a business invitation
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public acceptById(id: string, options?: RawAxiosRequestConfig) {
        return BusinessInvitationsApiFp(this.configuration).acceptById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get business invitations by email
     * @param {string} email 
     * @param {Pageable} page 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public findPendingByEmail(email: string, page: Pageable, options?: RawAxiosRequestConfig) {
        return BusinessInvitationsApiFp(this.configuration).findPendingByEmail(email, page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * To reject a business invitation
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public rejectById(id: string, options?: RawAxiosRequestConfig) {
        return BusinessInvitationsApiFp(this.configuration).rejectById(id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CampaignEndpointsApi - axios parameter creator
 */
export const CampaignEndpointsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add an Additional File to a Campaign
         * @param {string} campaignId 
         * @param {AddAdditionalFileRequestDto} addAdditionalFileRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addAdditionalFile: async (campaignId: string, addAdditionalFileRequestDto: AddAdditionalFileRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'campaignId' is not null or undefined
            assertParamExists('addAdditionalFile', 'campaignId', campaignId)
            // verify required parameter 'addAdditionalFileRequestDto' is not null or undefined
            assertParamExists('addAdditionalFile', 'addAdditionalFileRequestDto', addAdditionalFileRequestDto)
            const localVarPath = `/api/v1/campaigns/{campaignId}/additional-files`
                .replace('{campaignId}', encodeURIComponent(String(campaignId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addAdditionalFileRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Add creatives to a Campaign
         * @param {string} campaignId 
         * @param {Array<CreativeRequestDto>} creativeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCreatives: async (campaignId: string, creativeRequestDto: Array<CreativeRequestDto>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'campaignId' is not null or undefined
            assertParamExists('addCreatives', 'campaignId', campaignId)
            // verify required parameter 'creativeRequestDto' is not null or undefined
            assertParamExists('addCreatives', 'creativeRequestDto', creativeRequestDto)
            const localVarPath = `/api/v1/campaigns/{campaignId}/creatives`
                .replace('{campaignId}', encodeURIComponent(String(campaignId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(creativeRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Add Outdoors to Campaign
         * @param {string} campaignId 
         * @param {Array<CreateOutdoorSlotRequestDto>} createOutdoorSlotRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addOutdoorSlots: async (campaignId: string, createOutdoorSlotRequestDto: Array<CreateOutdoorSlotRequestDto>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'campaignId' is not null or undefined
            assertParamExists('addOutdoorSlots', 'campaignId', campaignId)
            // verify required parameter 'createOutdoorSlotRequestDto' is not null or undefined
            assertParamExists('addOutdoorSlots', 'createOutdoorSlotRequestDto', createOutdoorSlotRequestDto)
            const localVarPath = `/api/v1/campaigns/{campaignId}/campaign-outdoors`
                .replace('{campaignId}', encodeURIComponent(String(campaignId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createOutdoorSlotRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Outdoors from Placement Provider being used in Campaign
         * @param {string} campaignId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignOutdoorsByCampaignForPlacementProvider: async (campaignId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'campaignId' is not null or undefined
            assertParamExists('campaignOutdoorsByCampaignForPlacementProvider', 'campaignId', campaignId)
            const localVarPath = `/api/v1/campaigns/{campaignId}/placement-providers/campaign-outdoors`
                .replace('{campaignId}', encodeURIComponent(String(campaignId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * To cancel a Campaign
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelCampaign: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('cancelCampaign', 'id', id)
            const localVarPath = `/api/v1/campaigns/{id}/cancel`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Check if Campaign is paid
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkCampaignIsPaid: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('checkCampaignIsPaid', 'id', id)
            const localVarPath = `/api/v1/campaigns/{id}/check-payment`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Stripe redirects the Advertiser here after the direct debit mandate checkout; they\'re redirected on to the card payment checkout.
         * @summary Continue a MONTHLY Campaign\'s checkout once its direct debit mandate is signed
         * @param {string} id 
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeDirectDebitMandate: async (id: string, sessionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('completeDirectDebitMandate', 'id', id)
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('completeDirectDebitMandate', 'sessionId', sessionId)
            const localVarPath = `/api/v1/campaigns/{id}/checkout/direct-debit-completed`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (sessionId !== undefined) {
                localVarQueryParameter['session_id'] = sessionId;
            }


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a Campaign
         * @param {string} advertiserId 
         * @param {WriteCampaignRequestDto} writeCampaignRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCampaign: async (advertiserId: string, writeCampaignRequestDto: WriteCampaignRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'advertiserId' is not null or undefined
            assertParamExists('createCampaign', 'advertiserId', advertiserId)
            // verify required parameter 'writeCampaignRequestDto' is not null or undefined
            assertParamExists('createCampaign', 'writeCampaignRequestDto', writeCampaignRequestDto)
            const localVarPath = `/api/v1/campaigns/advertisers/{advertiserId}`
                .replace('{advertiserId}', encodeURIComponent(String(advertiserId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(writeCampaignRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Checkout session for a Campaign
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCheckoutSession: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createCheckoutSession', 'id', id)
            const localVarPath = `/api/v1/campaigns/{id}/checkout-session`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Only while AWAITING_CONFIRMATION, by its Advertiser: CONFIRM pays for the available Outdoors only, CANCEL releases the payment.
         * @summary Confirm or cancel a Campaign some of whose Outdoors are unavailable
         * @param {string} campaignId 
         * @param {AdvertiserConfirmationDto} advertiserConfirmationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        decideOnConfirmation: async (campaignId: string, advertiserConfirmationDto: AdvertiserConfirmationDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'campaignId' is not null or undefined
            assertParamExists('decideOnConfirmation', 'campaignId', campaignId)
            // verify required parameter 'advertiserConfirmationDto' is not null or undefined
            assertParamExists('decideOnConfirmation', 'advertiserConfirmationDto', advertiserConfirmationDto)
            const localVarPath = `/api/v1/campaigns/{campaignId}/confirmation`
                .replace('{campaignId}', encodeURIComponent(String(campaignId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(advertiserConfirmationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete an Additional File from a Campaign
         * @param {string} campaignId 
         * @param {string} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdditionalFile: async (campaignId: string, fileId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'campaignId' is not null or undefined
            assertParamExists('deleteAdditionalFile', 'campaignId', campaignId)
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('deleteAdditionalFile', 'fileId', fileId)
            const localVarPath = `/api/v1/campaigns/{campaignId}/additional-files/{fileId}`
                .replace('{campaignId}', encodeURIComponent(String(campaignId)))
                .replace('{fileId}', encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Outdoors from a Campaign
         * @param {string} campaignId 
         * @param {Set<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCampaignOutdoors: async (campaignId: string, requestBody: Set<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'campaignId' is not null or undefined
            assertParamExists('deleteCampaignOutdoors', 'campaignId', campaignId)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('deleteCampaignOutdoors', 'requestBody', requestBody)
            const localVarPath = `/api/v1/campaigns/{campaignId}/campaign-outdoors`
                .replace('{campaignId}', encodeURIComponent(String(campaignId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete creatives from a Campaign
         * @param {string} campaignId 
         * @param {Set<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCreatives: async (campaignId: string, requestBody: Set<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'campaignId' is not null or undefined
            assertParamExists('deleteCreatives', 'campaignId', campaignId)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('deleteCreatives', 'requestBody', requestBody)
            const localVarPath = `/api/v1/campaigns/{campaignId}/creatives`
                .replace('{campaignId}', encodeURIComponent(String(campaignId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Search Aggregated Campaigns from Placement Provider
         * @param {string} placementProviderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAggregatedByPlacementProvider: async (placementProviderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'placementProviderId' is not null or undefined
            assertParamExists('getAggregatedByPlacementProvider', 'placementProviderId', placementProviderId)
            const localVarPath = `/api/v1/campaigns/placement-providers/{placementProviderId}/aggregation`
                .replace('{placementProviderId}', encodeURIComponent(String(placementProviderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a Campaign
         * @param {string} campaignId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCampaign: async (campaignId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'campaignId' is not null or undefined
            assertParamExists('getCampaign', 'campaignId', campaignId)
            const localVarPath = `/api/v1/campaigns/{campaignId}`
                .replace('{campaignId}', encodeURIComponent(String(campaignId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get costs per Campaign Outdoor
         * @param {string} campaignId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCampaignOutdoorCosts: async (campaignId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'campaignId' is not null or undefined
            assertParamExists('getCampaignOutdoorCosts', 'campaignId', campaignId)
            const localVarPath = `/api/v1/campaigns/{campaignId}/costs`
                .replace('{campaignId}', encodeURIComponent(String(campaignId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Invoice Upload URL
         * @param {string} campaignId 
         * @param {CampaignInvoiceRequestDto} campaignInvoiceRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoiceUploadUrl: async (campaignId: string, campaignInvoiceRequestDto: CampaignInvoiceRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'campaignId' is not null or undefined
            assertParamExists('getInvoiceUploadUrl', 'campaignId', campaignId)
            // verify required parameter 'campaignInvoiceRequestDto' is not null or undefined
            assertParamExists('getInvoiceUploadUrl', 'campaignInvoiceRequestDto', campaignInvoiceRequestDto)
            const localVarPath = `/api/v1/campaigns/{campaignId}/invoice-upload-url`
                .replace('{campaignId}', encodeURIComponent(String(campaignId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(campaignInvoiceRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get final Placement Provider earnings for a batch of Campaigns
         * @param {string} placementProviderId 
         * @param {Set<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlacementProviderEarnings: async (placementProviderId: string, requestBody: Set<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'placementProviderId' is not null or undefined
            assertParamExists('getPlacementProviderEarnings', 'placementProviderId', placementProviderId)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('getPlacementProviderEarnings', 'requestBody', requestBody)
            const localVarPath = `/api/v1/campaigns/placement-providers/{placementProviderId}/earnings`
                .replace('{placementProviderId}', encodeURIComponent(String(placementProviderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get current running Campaigns that have Pending CampaignOutdoors, by Placement Provider ID
         * @param {string} placementProviderId 
         * @param {Pageable} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlacementProvidersCampaignsToVerify: async (placementProviderId: string, page: Pageable, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'placementProviderId' is not null or undefined
            assertParamExists('getPlacementProvidersCampaignsToVerify', 'placementProviderId', placementProviderId)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('getPlacementProvidersCampaignsToVerify', 'page', page)
            const localVarPath = `/api/v1/campaigns/placement-providers/{placementProviderId}/verify`
                .replace('{placementProviderId}', encodeURIComponent(String(placementProviderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                for (const [key, value] of Object.entries(page)) {
                    localVarQueryParameter[key] = value;
                }
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upload Proof of Payment
         * @param {string} id 
         * @param {string} fileName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProofOfPaymentUploadUrl: async (id: string, fileName: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getProofOfPaymentUploadUrl', 'id', id)
            // verify required parameter 'fileName' is not null or undefined
            assertParamExists('getProofOfPaymentUploadUrl', 'fileName', fileName)
            const localVarPath = `/api/v1/campaigns/{id}/proof-of-payment-url`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (fileName !== undefined) {
                localVarQueryParameter['fileName'] = fileName;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Search for Advertisers\' Campaigns
         * @param {string} advertiserId 
         * @param {Pageable} pageable 
         * @param {SearchCampaignsDto} searchCampaignsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        search: async (advertiserId: string, pageable: Pageable, searchCampaignsDto: SearchCampaignsDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'advertiserId' is not null or undefined
            assertParamExists('search', 'advertiserId', advertiserId)
            // verify required parameter 'pageable' is not null or undefined
            assertParamExists('search', 'pageable', pageable)
            // verify required parameter 'searchCampaignsDto' is not null or undefined
            assertParamExists('search', 'searchCampaignsDto', searchCampaignsDto)
            const localVarPath = `/api/v1/campaigns/search/advertisers/{advertiserId}`
                .replace('{advertiserId}', encodeURIComponent(String(advertiserId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (pageable !== undefined) {
                for (const [key, value] of Object.entries(pageable)) {
                    localVarQueryParameter[key] = value;
                }
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(searchCampaignsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Search Campaigns by Outdoor
         * @param {string} outdoorId 
         * @param {Pageable} pageable 
         * @param {SearchCampaignsDto} searchCampaignsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchByOutdoor: async (outdoorId: string, pageable: Pageable, searchCampaignsDto: SearchCampaignsDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'outdoorId' is not null or undefined
            assertParamExists('searchByOutdoor', 'outdoorId', outdoorId)
            // verify required parameter 'pageable' is not null or undefined
            assertParamExists('searchByOutdoor', 'pageable', pageable)
            // verify required parameter 'searchCampaignsDto' is not null or undefined
            assertParamExists('searchByOutdoor', 'searchCampaignsDto', searchCampaignsDto)
            const localVarPath = `/api/v1/campaigns/search/outdoors/{outdoorId}`
                .replace('{outdoorId}', encodeURIComponent(String(outdoorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (pageable !== undefined) {
                for (const [key, value] of Object.entries(pageable)) {
                    localVarQueryParameter[key] = value;
                }
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(searchCampaignsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Search Campaigns from Placement Provider
         * @param {string} placementProviderId 
         * @param {Pageable} pageable 
         * @param {SearchCampaignsDto} searchCampaignsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchByPlacementProvider1: async (placementProviderId: string, pageable: Pageable, searchCampaignsDto: SearchCampaignsDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'placementProviderId' is not null or undefined
            assertParamExists('searchByPlacementProvider1', 'placementProviderId', placementProviderId)
            // verify required parameter 'pageable' is not null or undefined
            assertParamExists('searchByPlacementProvider1', 'pageable', pageable)
            // verify required parameter 'searchCampaignsDto' is not null or undefined
            assertParamExists('searchByPlacementProvider1', 'searchCampaignsDto', searchCampaignsDto)
            const localVarPath = `/api/v1/campaigns/search/placement-providers/{placementProviderId}`
                .replace('{placementProviderId}', encodeURIComponent(String(placementProviderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (pageable !== undefined) {
                for (const [key, value] of Object.entries(pageable)) {
                    localVarQueryParameter[key] = value;
                }
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(searchCampaignsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Same filters as the full Advertiser Campaign search, but returns less data per Campaign and reads less data from the database
         * @summary Search for Advertisers\' Campaign projections
         * @param {string} advertiserId 
         * @param {Pageable} pageable 
         * @param {SearchCampaignsDto} searchCampaignsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchProjections: async (advertiserId: string, pageable: Pageable, searchCampaignsDto: SearchCampaignsDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'advertiserId' is not null or undefined
            assertParamExists('searchProjections', 'advertiserId', advertiserId)
            // verify required parameter 'pageable' is not null or undefined
            assertParamExists('searchProjections', 'pageable', pageable)
            // verify required parameter 'searchCampaignsDto' is not null or undefined
            assertParamExists('searchProjections', 'searchCampaignsDto', searchCampaignsDto)
            const localVarPath = `/api/v1/campaigns/search/advertisers/{advertiserId}/projections`
                .replace('{advertiserId}', encodeURIComponent(String(advertiserId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (pageable !== undefined) {
                for (const [key, value] of Object.entries(pageable)) {
                    localVarQueryParameter[key] = value;
                }
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(searchCampaignsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * To accept or revoke acceptance of a Campaign\'s terms and conditions
         * @param {string} campaignId 
         * @param {boolean} acceptedTermsAndConditions 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAcceptedTermsAndConditions: async (campaignId: string, acceptedTermsAndConditions: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'campaignId' is not null or undefined
            assertParamExists('updateAcceptedTermsAndConditions', 'campaignId', campaignId)
            // verify required parameter 'acceptedTermsAndConditions' is not null or undefined
            assertParamExists('updateAcceptedTermsAndConditions', 'acceptedTermsAndConditions', acceptedTermsAndConditions)
            const localVarPath = `/api/v1/campaigns/{campaignId}/terms-and-conditions`
                .replace('{campaignId}', encodeURIComponent(String(campaignId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (acceptedTermsAndConditions !== undefined) {
                localVarQueryParameter['acceptedTermsAndConditions'] = acceptedTermsAndConditions;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a Campaign
         * @param {string} campaignId 
         * @param {WriteCampaignRequestDto} writeCampaignRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCampaign: async (campaignId: string, writeCampaignRequestDto: WriteCampaignRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'campaignId' is not null or undefined
            assertParamExists('updateCampaign', 'campaignId', campaignId)
            // verify required parameter 'writeCampaignRequestDto' is not null or undefined
            assertParamExists('updateCampaign', 'writeCampaignRequestDto', writeCampaignRequestDto)
            const localVarPath = `/api/v1/campaigns/{campaignId}`
                .replace('{campaignId}', encodeURIComponent(String(campaignId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(writeCampaignRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * To update instructions of a Campaign
         * @param {string} campaignId 
         * @param {UpdateInstructionsDto} updateInstructionsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateInstructions: async (campaignId: string, updateInstructionsDto: UpdateInstructionsDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'campaignId' is not null or undefined
            assertParamExists('updateInstructions', 'campaignId', campaignId)
            // verify required parameter 'updateInstructionsDto' is not null or undefined
            assertParamExists('updateInstructions', 'updateInstructionsDto', updateInstructionsDto)
            const localVarPath = `/api/v1/campaigns/{campaignId}/instructions`
                .replace('{campaignId}', encodeURIComponent(String(campaignId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateInstructionsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Check Campaign Outdoors availability, either removing the ones no longer available (REMOVE) or just reporting them (FLAG)
         * @param {string} campaignId 
         * @param {UpdateOutdoorsOnAvailabilityOfActionEnum} [action] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOutdoorsOnAvailabilityOf: async (campaignId: string, action?: UpdateOutdoorsOnAvailabilityOfActionEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'campaignId' is not null or undefined
            assertParamExists('updateOutdoorsOnAvailabilityOf', 'campaignId', campaignId)
            const localVarPath = `/api/v1/campaigns/{campaignId}/update-on-availability`
                .replace('{campaignId}', encodeURIComponent(String(campaignId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (action !== undefined) {
                localVarQueryParameter['action'] = action;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CampaignEndpointsApi - functional programming interface
 */
export const CampaignEndpointsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CampaignEndpointsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Add an Additional File to a Campaign
         * @param {string} campaignId 
         * @param {AddAdditionalFileRequestDto} addAdditionalFileRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addAdditionalFile(campaignId: string, addAdditionalFileRequestDto: AddAdditionalFileRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddAdditionalFileResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addAdditionalFile(campaignId, addAdditionalFileRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CampaignEndpointsApi.addAdditionalFile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Add creatives to a Campaign
         * @param {string} campaignId 
         * @param {Array<CreativeRequestDto>} creativeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addCreatives(campaignId: string, creativeRequestDto: Array<CreativeRequestDto>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddCreativesResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addCreatives(campaignId, creativeRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CampaignEndpointsApi.addCreatives']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Add Outdoors to Campaign
         * @param {string} campaignId 
         * @param {Array<CreateOutdoorSlotRequestDto>} createOutdoorSlotRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addOutdoorSlots(campaignId: string, createOutdoorSlotRequestDto: Array<CreateOutdoorSlotRequestDto>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CampaignResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addOutdoorSlots(campaignId, createOutdoorSlotRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CampaignEndpointsApi.addOutdoorSlots']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Outdoors from Placement Provider being used in Campaign
         * @param {string} campaignId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async campaignOutdoorsByCampaignForPlacementProvider(campaignId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CampaignOutdoorDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.campaignOutdoorsByCampaignForPlacementProvider(campaignId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CampaignEndpointsApi.campaignOutdoorsByCampaignForPlacementProvider']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * To cancel a Campaign
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelCampaign(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CampaignResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelCampaign(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CampaignEndpointsApi.cancelCampaign']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Check if Campaign is paid
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkCampaignIsPaid(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CampaignPaymentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkCampaignIsPaid(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CampaignEndpointsApi.checkCampaignIsPaid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Stripe redirects the Advertiser here after the direct debit mandate checkout; they\'re redirected on to the card payment checkout.
         * @summary Continue a MONTHLY Campaign\'s checkout once its direct debit mandate is signed
         * @param {string} id 
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async completeDirectDebitMandate(id: string, sessionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.completeDirectDebitMandate(id, sessionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CampaignEndpointsApi.completeDirectDebitMandate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a Campaign
         * @param {string} advertiserId 
         * @param {WriteCampaignRequestDto} writeCampaignRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCampaign(advertiserId: string, writeCampaignRequestDto: WriteCampaignRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WriteCampaignResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCampaign(advertiserId, writeCampaignRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CampaignEndpointsApi.createCampaign']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Checkout session for a Campaign
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCheckoutSession(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckoutSessionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCheckoutSession(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CampaignEndpointsApi.createCheckoutSession']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Only while AWAITING_CONFIRMATION, by its Advertiser: CONFIRM pays for the available Outdoors only, CANCEL releases the payment.
         * @summary Confirm or cancel a Campaign some of whose Outdoors are unavailable
         * @param {string} campaignId 
         * @param {AdvertiserConfirmationDto} advertiserConfirmationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async decideOnConfirmation(campaignId: string, advertiserConfirmationDto: AdvertiserConfirmationDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CampaignResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.decideOnConfirmation(campaignId, advertiserConfirmationDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CampaignEndpointsApi.decideOnConfirmation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete an Additional File from a Campaign
         * @param {string} campaignId 
         * @param {string} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAdditionalFile(campaignId: string, fileId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CampaignResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAdditionalFile(campaignId, fileId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CampaignEndpointsApi.deleteAdditionalFile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete Outdoors from a Campaign
         * @param {string} campaignId 
         * @param {Set<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCampaignOutdoors(campaignId: string, requestBody: Set<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CampaignResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCampaignOutdoors(campaignId, requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CampaignEndpointsApi.deleteCampaignOutdoors']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete creatives from a Campaign
         * @param {string} campaignId 
         * @param {Set<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCreatives(campaignId: string, requestBody: Set<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CampaignResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCreatives(campaignId, requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CampaignEndpointsApi.deleteCreatives']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Search Aggregated Campaigns from Placement Provider
         * @param {string} placementProviderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAggregatedByPlacementProvider(placementProviderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BusinessEntityCampaignAggregationDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAggregatedByPlacementProvider(placementProviderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CampaignEndpointsApi.getAggregatedByPlacementProvider']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a Campaign
         * @param {string} campaignId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCampaign(campaignId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CampaignResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCampaign(campaignId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CampaignEndpointsApi.getCampaign']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get costs per Campaign Outdoor
         * @param {string} campaignId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCampaignOutdoorCosts(campaignId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CampaignOutdoorCostDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCampaignOutdoorCosts(campaignId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CampaignEndpointsApi.getCampaignOutdoorCosts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Invoice Upload URL
         * @param {string} campaignId 
         * @param {CampaignInvoiceRequestDto} campaignInvoiceRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInvoiceUploadUrl(campaignId: string, campaignInvoiceRequestDto: CampaignInvoiceRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UploadOfInvoiceDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInvoiceUploadUrl(campaignId, campaignInvoiceRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CampaignEndpointsApi.getInvoiceUploadUrl']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get final Placement Provider earnings for a batch of Campaigns
         * @param {string} placementProviderId 
         * @param {Set<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPlacementProviderEarnings(placementProviderId: string, requestBody: Set<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PlacementProviderCampaignEarningsDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPlacementProviderEarnings(placementProviderId, requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CampaignEndpointsApi.getPlacementProviderEarnings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get current running Campaigns that have Pending CampaignOutdoors, by Placement Provider ID
         * @param {string} placementProviderId 
         * @param {Pageable} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPlacementProvidersCampaignsToVerify(placementProviderId: string, page: Pageable, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedCampaignProjectionsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPlacementProvidersCampaignsToVerify(placementProviderId, page, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CampaignEndpointsApi.getPlacementProvidersCampaignsToVerify']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Upload Proof of Payment
         * @param {string} id 
         * @param {string} fileName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProofOfPaymentUploadUrl(id: string, fileName: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProofOfPaymentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProofOfPaymentUploadUrl(id, fileName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CampaignEndpointsApi.getProofOfPaymentUploadUrl']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Search for Advertisers\' Campaigns
         * @param {string} advertiserId 
         * @param {Pageable} pageable 
         * @param {SearchCampaignsDto} searchCampaignsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async search(advertiserId: string, pageable: Pageable, searchCampaignsDto: SearchCampaignsDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedCampaignsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.search(advertiserId, pageable, searchCampaignsDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CampaignEndpointsApi.search']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Search Campaigns by Outdoor
         * @param {string} outdoorId 
         * @param {Pageable} pageable 
         * @param {SearchCampaignsDto} searchCampaignsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchByOutdoor(outdoorId: string, pageable: Pageable, searchCampaignsDto: SearchCampaignsDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedCampaignsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchByOutdoor(outdoorId, pageable, searchCampaignsDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CampaignEndpointsApi.searchByOutdoor']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Search Campaigns from Placement Provider
         * @param {string} placementProviderId 
         * @param {Pageable} pageable 
         * @param {SearchCampaignsDto} searchCampaignsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchByPlacementProvider1(placementProviderId: string, pageable: Pageable, searchCampaignsDto: SearchCampaignsDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedCampaignsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchByPlacementProvider1(placementProviderId, pageable, searchCampaignsDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CampaignEndpointsApi.searchByPlacementProvider1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Same filters as the full Advertiser Campaign search, but returns less data per Campaign and reads less data from the database
         * @summary Search for Advertisers\' Campaign projections
         * @param {string} advertiserId 
         * @param {Pageable} pageable 
         * @param {SearchCampaignsDto} searchCampaignsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchProjections(advertiserId: string, pageable: Pageable, searchCampaignsDto: SearchCampaignsDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedCampaignSearchProjectionsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchProjections(advertiserId, pageable, searchCampaignsDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CampaignEndpointsApi.searchProjections']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * To accept or revoke acceptance of a Campaign\'s terms and conditions
         * @param {string} campaignId 
         * @param {boolean} acceptedTermsAndConditions 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAcceptedTermsAndConditions(campaignId: string, acceptedTermsAndConditions: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CampaignResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAcceptedTermsAndConditions(campaignId, acceptedTermsAndConditions, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CampaignEndpointsApi.updateAcceptedTermsAndConditions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a Campaign
         * @param {string} campaignId 
         * @param {WriteCampaignRequestDto} writeCampaignRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCampaign(campaignId: string, writeCampaignRequestDto: WriteCampaignRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WriteCampaignResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCampaign(campaignId, writeCampaignRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CampaignEndpointsApi.updateCampaign']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * To update instructions of a Campaign
         * @param {string} campaignId 
         * @param {UpdateInstructionsDto} updateInstructionsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateInstructions(campaignId: string, updateInstructionsDto: UpdateInstructionsDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CampaignResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateInstructions(campaignId, updateInstructionsDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CampaignEndpointsApi.updateInstructions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Check Campaign Outdoors availability, either removing the ones no longer available (REMOVE) or just reporting them (FLAG)
         * @param {string} campaignId 
         * @param {UpdateOutdoorsOnAvailabilityOfActionEnum} [action] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOutdoorsOnAvailabilityOf(campaignId: string, action?: UpdateOutdoorsOnAvailabilityOfActionEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdatedCampaignOutdoorsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOutdoorsOnAvailabilityOf(campaignId, action, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CampaignEndpointsApi.updateOutdoorsOnAvailabilityOf']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CampaignEndpointsApi - factory interface
 */
export const CampaignEndpointsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CampaignEndpointsApiFp(configuration)
    return {
        /**
         * 
         * @summary Add an Additional File to a Campaign
         * @param {string} campaignId 
         * @param {AddAdditionalFileRequestDto} addAdditionalFileRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addAdditionalFile(campaignId: string, addAdditionalFileRequestDto: AddAdditionalFileRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<AddAdditionalFileResponseDto> {
            return localVarFp.addAdditionalFile(campaignId, addAdditionalFileRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Add creatives to a Campaign
         * @param {string} campaignId 
         * @param {Array<CreativeRequestDto>} creativeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCreatives(campaignId: string, creativeRequestDto: Array<CreativeRequestDto>, options?: RawAxiosRequestConfig): AxiosPromise<AddCreativesResponseDto> {
            return localVarFp.addCreatives(campaignId, creativeRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Add Outdoors to Campaign
         * @param {string} campaignId 
         * @param {Array<CreateOutdoorSlotRequestDto>} createOutdoorSlotRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addOutdoorSlots(campaignId: string, createOutdoorSlotRequestDto: Array<CreateOutdoorSlotRequestDto>, options?: RawAxiosRequestConfig): AxiosPromise<CampaignResponseDto> {
            return localVarFp.addOutdoorSlots(campaignId, createOutdoorSlotRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Outdoors from Placement Provider being used in Campaign
         * @param {string} campaignId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignOutdoorsByCampaignForPlacementProvider(campaignId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<CampaignOutdoorDto>> {
            return localVarFp.campaignOutdoorsByCampaignForPlacementProvider(campaignId, options).then((request) => request(axios, basePath));
        },
        /**
         * To cancel a Campaign
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelCampaign(id: string, options?: RawAxiosRequestConfig): AxiosPromise<CampaignResponseDto> {
            return localVarFp.cancelCampaign(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Check if Campaign is paid
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkCampaignIsPaid(id: string, options?: RawAxiosRequestConfig): AxiosPromise<CampaignPaymentDto> {
            return localVarFp.checkCampaignIsPaid(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Stripe redirects the Advertiser here after the direct debit mandate checkout; they\'re redirected on to the card payment checkout.
         * @summary Continue a MONTHLY Campaign\'s checkout once its direct debit mandate is signed
         * @param {string} id 
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeDirectDebitMandate(id: string, sessionId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.completeDirectDebitMandate(id, sessionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a Campaign
         * @param {string} advertiserId 
         * @param {WriteCampaignRequestDto} writeCampaignRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCampaign(advertiserId: string, writeCampaignRequestDto: WriteCampaignRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<WriteCampaignResponseDto> {
            return localVarFp.createCampaign(advertiserId, writeCampaignRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Checkout session for a Campaign
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCheckoutSession(id: string, options?: RawAxiosRequestConfig): AxiosPromise<CheckoutSessionDto> {
            return localVarFp.createCheckoutSession(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Only while AWAITING_CONFIRMATION, by its Advertiser: CONFIRM pays for the available Outdoors only, CANCEL releases the payment.
         * @summary Confirm or cancel a Campaign some of whose Outdoors are unavailable
         * @param {string} campaignId 
         * @param {AdvertiserConfirmationDto} advertiserConfirmationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        decideOnConfirmation(campaignId: string, advertiserConfirmationDto: AdvertiserConfirmationDto, options?: RawAxiosRequestConfig): AxiosPromise<CampaignResponseDto> {
            return localVarFp.decideOnConfirmation(campaignId, advertiserConfirmationDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete an Additional File from a Campaign
         * @param {string} campaignId 
         * @param {string} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdditionalFile(campaignId: string, fileId: string, options?: RawAxiosRequestConfig): AxiosPromise<CampaignResponseDto> {
            return localVarFp.deleteAdditionalFile(campaignId, fileId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Outdoors from a Campaign
         * @param {string} campaignId 
         * @param {Set<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCampaignOutdoors(campaignId: string, requestBody: Set<string>, options?: RawAxiosRequestConfig): AxiosPromise<CampaignResponseDto> {
            return localVarFp.deleteCampaignOutdoors(campaignId, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete creatives from a Campaign
         * @param {string} campaignId 
         * @param {Set<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCreatives(campaignId: string, requestBody: Set<string>, options?: RawAxiosRequestConfig): AxiosPromise<CampaignResponseDto> {
            return localVarFp.deleteCreatives(campaignId, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Search Aggregated Campaigns from Placement Provider
         * @param {string} placementProviderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAggregatedByPlacementProvider(placementProviderId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<BusinessEntityCampaignAggregationDto>> {
            return localVarFp.getAggregatedByPlacementProvider(placementProviderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a Campaign
         * @param {string} campaignId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCampaign(campaignId: string, options?: RawAxiosRequestConfig): AxiosPromise<CampaignResponseDto> {
            return localVarFp.getCampaign(campaignId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get costs per Campaign Outdoor
         * @param {string} campaignId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCampaignOutdoorCosts(campaignId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<CampaignOutdoorCostDto>> {
            return localVarFp.getCampaignOutdoorCosts(campaignId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Invoice Upload URL
         * @param {string} campaignId 
         * @param {CampaignInvoiceRequestDto} campaignInvoiceRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoiceUploadUrl(campaignId: string, campaignInvoiceRequestDto: CampaignInvoiceRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<UploadOfInvoiceDto> {
            return localVarFp.getInvoiceUploadUrl(campaignId, campaignInvoiceRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get final Placement Provider earnings for a batch of Campaigns
         * @param {string} placementProviderId 
         * @param {Set<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlacementProviderEarnings(placementProviderId: string, requestBody: Set<string>, options?: RawAxiosRequestConfig): AxiosPromise<Array<PlacementProviderCampaignEarningsDto>> {
            return localVarFp.getPlacementProviderEarnings(placementProviderId, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Get current running Campaigns that have Pending CampaignOutdoors, by Placement Provider ID
         * @param {string} placementProviderId 
         * @param {Pageable} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlacementProvidersCampaignsToVerify(placementProviderId: string, page: Pageable, options?: RawAxiosRequestConfig): AxiosPromise<PagedCampaignProjectionsDto> {
            return localVarFp.getPlacementProvidersCampaignsToVerify(placementProviderId, page, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upload Proof of Payment
         * @param {string} id 
         * @param {string} fileName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProofOfPaymentUploadUrl(id: string, fileName: string, options?: RawAxiosRequestConfig): AxiosPromise<ProofOfPaymentDto> {
            return localVarFp.getProofOfPaymentUploadUrl(id, fileName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Search for Advertisers\' Campaigns
         * @param {string} advertiserId 
         * @param {Pageable} pageable 
         * @param {SearchCampaignsDto} searchCampaignsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        search(advertiserId: string, pageable: Pageable, searchCampaignsDto: SearchCampaignsDto, options?: RawAxiosRequestConfig): AxiosPromise<PagedCampaignsDto> {
            return localVarFp.search(advertiserId, pageable, searchCampaignsDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Search Campaigns by Outdoor
         * @param {string} outdoorId 
         * @param {Pageable} pageable 
         * @param {SearchCampaignsDto} searchCampaignsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchByOutdoor(outdoorId: string, pageable: Pageable, searchCampaignsDto: SearchCampaignsDto, options?: RawAxiosRequestConfig): AxiosPromise<PagedCampaignsDto> {
            return localVarFp.searchByOutdoor(outdoorId, pageable, searchCampaignsDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Search Campaigns from Placement Provider
         * @param {string} placementProviderId 
         * @param {Pageable} pageable 
         * @param {SearchCampaignsDto} searchCampaignsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchByPlacementProvider1(placementProviderId: string, pageable: Pageable, searchCampaignsDto: SearchCampaignsDto, options?: RawAxiosRequestConfig): AxiosPromise<PagedCampaignsDto> {
            return localVarFp.searchByPlacementProvider1(placementProviderId, pageable, searchCampaignsDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Same filters as the full Advertiser Campaign search, but returns less data per Campaign and reads less data from the database
         * @summary Search for Advertisers\' Campaign projections
         * @param {string} advertiserId 
         * @param {Pageable} pageable 
         * @param {SearchCampaignsDto} searchCampaignsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchProjections(advertiserId: string, pageable: Pageable, searchCampaignsDto: SearchCampaignsDto, options?: RawAxiosRequestConfig): AxiosPromise<PagedCampaignSearchProjectionsDto> {
            return localVarFp.searchProjections(advertiserId, pageable, searchCampaignsDto, options).then((request) => request(axios, basePath));
        },
        /**
         * To accept or revoke acceptance of a Campaign\'s terms and conditions
         * @param {string} campaignId 
         * @param {boolean} acceptedTermsAndConditions 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAcceptedTermsAndConditions(campaignId: string, acceptedTermsAndConditions: boolean, options?: RawAxiosRequestConfig): AxiosPromise<CampaignResponseDto> {
            return localVarFp.updateAcceptedTermsAndConditions(campaignId, acceptedTermsAndConditions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a Campaign
         * @param {string} campaignId 
         * @param {WriteCampaignRequestDto} writeCampaignRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCampaign(campaignId: string, writeCampaignRequestDto: WriteCampaignRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<WriteCampaignResponseDto> {
            return localVarFp.updateCampaign(campaignId, writeCampaignRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * To update instructions of a Campaign
         * @param {string} campaignId 
         * @param {UpdateInstructionsDto} updateInstructionsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateInstructions(campaignId: string, updateInstructionsDto: UpdateInstructionsDto, options?: RawAxiosRequestConfig): AxiosPromise<CampaignResponseDto> {
            return localVarFp.updateInstructions(campaignId, updateInstructionsDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Check Campaign Outdoors availability, either removing the ones no longer available (REMOVE) or just reporting them (FLAG)
         * @param {string} campaignId 
         * @param {UpdateOutdoorsOnAvailabilityOfActionEnum} [action] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOutdoorsOnAvailabilityOf(campaignId: string, action?: UpdateOutdoorsOnAvailabilityOfActionEnum, options?: RawAxiosRequestConfig): AxiosPromise<UpdatedCampaignOutdoorsDto> {
            return localVarFp.updateOutdoorsOnAvailabilityOf(campaignId, action, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CampaignEndpointsApi - object-oriented interface
 */
export class CampaignEndpointsApi extends BaseAPI {
    /**
     * 
     * @summary Add an Additional File to a Campaign
     * @param {string} campaignId 
     * @param {AddAdditionalFileRequestDto} addAdditionalFileRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public addAdditionalFile(campaignId: string, addAdditionalFileRequestDto: AddAdditionalFileRequestDto, options?: RawAxiosRequestConfig) {
        return CampaignEndpointsApiFp(this.configuration).addAdditionalFile(campaignId, addAdditionalFileRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Add creatives to a Campaign
     * @param {string} campaignId 
     * @param {Array<CreativeRequestDto>} creativeRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public addCreatives(campaignId: string, creativeRequestDto: Array<CreativeRequestDto>, options?: RawAxiosRequestConfig) {
        return CampaignEndpointsApiFp(this.configuration).addCreatives(campaignId, creativeRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Add Outdoors to Campaign
     * @param {string} campaignId 
     * @param {Array<CreateOutdoorSlotRequestDto>} createOutdoorSlotRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public addOutdoorSlots(campaignId: string, createOutdoorSlotRequestDto: Array<CreateOutdoorSlotRequestDto>, options?: RawAxiosRequestConfig) {
        return CampaignEndpointsApiFp(this.configuration).addOutdoorSlots(campaignId, createOutdoorSlotRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Outdoors from Placement Provider being used in Campaign
     * @param {string} campaignId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public campaignOutdoorsByCampaignForPlacementProvider(campaignId: string, options?: RawAxiosRequestConfig) {
        return CampaignEndpointsApiFp(this.configuration).campaignOutdoorsByCampaignForPlacementProvider(campaignId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * To cancel a Campaign
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public cancelCampaign(id: string, options?: RawAxiosRequestConfig) {
        return CampaignEndpointsApiFp(this.configuration).cancelCampaign(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Check if Campaign is paid
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public checkCampaignIsPaid(id: string, options?: RawAxiosRequestConfig) {
        return CampaignEndpointsApiFp(this.configuration).checkCampaignIsPaid(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Stripe redirects the Advertiser here after the direct debit mandate checkout; they\'re redirected on to the card payment checkout.
     * @summary Continue a MONTHLY Campaign\'s checkout once its direct debit mandate is signed
     * @param {string} id 
     * @param {string} sessionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public completeDirectDebitMandate(id: string, sessionId: string, options?: RawAxiosRequestConfig) {
        return CampaignEndpointsApiFp(this.configuration).completeDirectDebitMandate(id, sessionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a Campaign
     * @param {string} advertiserId 
     * @param {WriteCampaignRequestDto} writeCampaignRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createCampaign(advertiserId: string, writeCampaignRequestDto: WriteCampaignRequestDto, options?: RawAxiosRequestConfig) {
        return CampaignEndpointsApiFp(this.configuration).createCampaign(advertiserId, writeCampaignRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Checkout session for a Campaign
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createCheckoutSession(id: string, options?: RawAxiosRequestConfig) {
        return CampaignEndpointsApiFp(this.configuration).createCheckoutSession(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Only while AWAITING_CONFIRMATION, by its Advertiser: CONFIRM pays for the available Outdoors only, CANCEL releases the payment.
     * @summary Confirm or cancel a Campaign some of whose Outdoors are unavailable
     * @param {string} campaignId 
     * @param {AdvertiserConfirmationDto} advertiserConfirmationDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public decideOnConfirmation(campaignId: string, advertiserConfirmationDto: AdvertiserConfirmationDto, options?: RawAxiosRequestConfig) {
        return CampaignEndpointsApiFp(this.configuration).decideOnConfirmation(campaignId, advertiserConfirmationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete an Additional File from a Campaign
     * @param {string} campaignId 
     * @param {string} fileId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteAdditionalFile(campaignId: string, fileId: string, options?: RawAxiosRequestConfig) {
        return CampaignEndpointsApiFp(this.configuration).deleteAdditionalFile(campaignId, fileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Outdoors from a Campaign
     * @param {string} campaignId 
     * @param {Set<string>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteCampaignOutdoors(campaignId: string, requestBody: Set<string>, options?: RawAxiosRequestConfig) {
        return CampaignEndpointsApiFp(this.configuration).deleteCampaignOutdoors(campaignId, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete creatives from a Campaign
     * @param {string} campaignId 
     * @param {Set<string>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteCreatives(campaignId: string, requestBody: Set<string>, options?: RawAxiosRequestConfig) {
        return CampaignEndpointsApiFp(this.configuration).deleteCreatives(campaignId, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Search Aggregated Campaigns from Placement Provider
     * @param {string} placementProviderId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAggregatedByPlacementProvider(placementProviderId: string, options?: RawAxiosRequestConfig) {
        return CampaignEndpointsApiFp(this.configuration).getAggregatedByPlacementProvider(placementProviderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a Campaign
     * @param {string} campaignId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCampaign(campaignId: string, options?: RawAxiosRequestConfig) {
        return CampaignEndpointsApiFp(this.configuration).getCampaign(campaignId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get costs per Campaign Outdoor
     * @param {string} campaignId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCampaignOutdoorCosts(campaignId: string, options?: RawAxiosRequestConfig) {
        return CampaignEndpointsApiFp(this.configuration).getCampaignOutdoorCosts(campaignId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Invoice Upload URL
     * @param {string} campaignId 
     * @param {CampaignInvoiceRequestDto} campaignInvoiceRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getInvoiceUploadUrl(campaignId: string, campaignInvoiceRequestDto: CampaignInvoiceRequestDto, options?: RawAxiosRequestConfig) {
        return CampaignEndpointsApiFp(this.configuration).getInvoiceUploadUrl(campaignId, campaignInvoiceRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get final Placement Provider earnings for a batch of Campaigns
     * @param {string} placementProviderId 
     * @param {Set<string>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPlacementProviderEarnings(placementProviderId: string, requestBody: Set<string>, options?: RawAxiosRequestConfig) {
        return CampaignEndpointsApiFp(this.configuration).getPlacementProviderEarnings(placementProviderId, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get current running Campaigns that have Pending CampaignOutdoors, by Placement Provider ID
     * @param {string} placementProviderId 
     * @param {Pageable} page 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPlacementProvidersCampaignsToVerify(placementProviderId: string, page: Pageable, options?: RawAxiosRequestConfig) {
        return CampaignEndpointsApiFp(this.configuration).getPlacementProvidersCampaignsToVerify(placementProviderId, page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upload Proof of Payment
     * @param {string} id 
     * @param {string} fileName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getProofOfPaymentUploadUrl(id: string, fileName: string, options?: RawAxiosRequestConfig) {
        return CampaignEndpointsApiFp(this.configuration).getProofOfPaymentUploadUrl(id, fileName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Search for Advertisers\' Campaigns
     * @param {string} advertiserId 
     * @param {Pageable} pageable 
     * @param {SearchCampaignsDto} searchCampaignsDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public search(advertiserId: string, pageable: Pageable, searchCampaignsDto: SearchCampaignsDto, options?: RawAxiosRequestConfig) {
        return CampaignEndpointsApiFp(this.configuration).search(advertiserId, pageable, searchCampaignsDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Search Campaigns by Outdoor
     * @param {string} outdoorId 
     * @param {Pageable} pageable 
     * @param {SearchCampaignsDto} searchCampaignsDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchByOutdoor(outdoorId: string, pageable: Pageable, searchCampaignsDto: SearchCampaignsDto, options?: RawAxiosRequestConfig) {
        return CampaignEndpointsApiFp(this.configuration).searchByOutdoor(outdoorId, pageable, searchCampaignsDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Search Campaigns from Placement Provider
     * @param {string} placementProviderId 
     * @param {Pageable} pageable 
     * @param {SearchCampaignsDto} searchCampaignsDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchByPlacementProvider1(placementProviderId: string, pageable: Pageable, searchCampaignsDto: SearchCampaignsDto, options?: RawAxiosRequestConfig) {
        return CampaignEndpointsApiFp(this.configuration).searchByPlacementProvider1(placementProviderId, pageable, searchCampaignsDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Same filters as the full Advertiser Campaign search, but returns less data per Campaign and reads less data from the database
     * @summary Search for Advertisers\' Campaign projections
     * @param {string} advertiserId 
     * @param {Pageable} pageable 
     * @param {SearchCampaignsDto} searchCampaignsDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchProjections(advertiserId: string, pageable: Pageable, searchCampaignsDto: SearchCampaignsDto, options?: RawAxiosRequestConfig) {
        return CampaignEndpointsApiFp(this.configuration).searchProjections(advertiserId, pageable, searchCampaignsDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * To accept or revoke acceptance of a Campaign\'s terms and conditions
     * @param {string} campaignId 
     * @param {boolean} acceptedTermsAndConditions 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateAcceptedTermsAndConditions(campaignId: string, acceptedTermsAndConditions: boolean, options?: RawAxiosRequestConfig) {
        return CampaignEndpointsApiFp(this.configuration).updateAcceptedTermsAndConditions(campaignId, acceptedTermsAndConditions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a Campaign
     * @param {string} campaignId 
     * @param {WriteCampaignRequestDto} writeCampaignRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateCampaign(campaignId: string, writeCampaignRequestDto: WriteCampaignRequestDto, options?: RawAxiosRequestConfig) {
        return CampaignEndpointsApiFp(this.configuration).updateCampaign(campaignId, writeCampaignRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * To update instructions of a Campaign
     * @param {string} campaignId 
     * @param {UpdateInstructionsDto} updateInstructionsDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateInstructions(campaignId: string, updateInstructionsDto: UpdateInstructionsDto, options?: RawAxiosRequestConfig) {
        return CampaignEndpointsApiFp(this.configuration).updateInstructions(campaignId, updateInstructionsDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Check Campaign Outdoors availability, either removing the ones no longer available (REMOVE) or just reporting them (FLAG)
     * @param {string} campaignId 
     * @param {UpdateOutdoorsOnAvailabilityOfActionEnum} [action] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateOutdoorsOnAvailabilityOf(campaignId: string, action?: UpdateOutdoorsOnAvailabilityOfActionEnum, options?: RawAxiosRequestConfig) {
        return CampaignEndpointsApiFp(this.configuration).updateOutdoorsOnAvailabilityOf(campaignId, action, options).then((request) => request(this.axios, this.basePath));
    }
}

export const UpdateOutdoorsOnAvailabilityOfActionEnum = {
    Remove: 'REMOVE',
    Flag: 'FLAG',
} as const;
export type UpdateOutdoorsOnAvailabilityOfActionEnum = typeof UpdateOutdoorsOnAvailabilityOfActionEnum[keyof typeof UpdateOutdoorsOnAvailabilityOfActionEnum];


/**
 * CampaignOutdoorEndpointsApi - axios parameter creator
 */
export const CampaignOutdoorEndpointsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Upload Proof of Ad
         * @param {string} campaignOutdoorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProofOfAd: async (campaignOutdoorId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'campaignOutdoorId' is not null or undefined
            assertParamExists('deleteProofOfAd', 'campaignOutdoorId', campaignOutdoorId)
            const localVarPath = `/api/v1/campaign-outdoors/{campaignOutdoorId}/proof-of-ad`
                .replace('{campaignOutdoorId}', encodeURIComponent(String(campaignOutdoorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * To get blocked dates by Outdoor ID
         * @param {string} outdoorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBlockedDatesOfOutdoor: async (outdoorId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'outdoorId' is not null or undefined
            assertParamExists('getBlockedDatesOfOutdoor', 'outdoorId', outdoorId)
            const localVarPath = `/api/v1/campaign-outdoors/outdoors/{outdoorId}/blocked-dates`
                .replace('{outdoorId}', encodeURIComponent(String(outdoorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Pending Campaign Outdoors
         * @param {string} placementProviderId 
         * @param {string} campaignId 
         * @param {Pageable} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCampaignOutdoorsByPlacementProviderAndCampaign: async (placementProviderId: string, campaignId: string, page: Pageable, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'placementProviderId' is not null or undefined
            assertParamExists('getCampaignOutdoorsByPlacementProviderAndCampaign', 'placementProviderId', placementProviderId)
            // verify required parameter 'campaignId' is not null or undefined
            assertParamExists('getCampaignOutdoorsByPlacementProviderAndCampaign', 'campaignId', campaignId)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('getCampaignOutdoorsByPlacementProviderAndCampaign', 'page', page)
            const localVarPath = `/api/v1/campaign-outdoors/placement-providers/{placementProviderId}/campaigns/{campaignId}`
                .replace('{placementProviderId}', encodeURIComponent(String(placementProviderId)))
                .replace('{campaignId}', encodeURIComponent(String(campaignId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                for (const [key, value] of Object.entries(page)) {
                    localVarQueryParameter[key] = value;
                }
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upload Proof of Ad
         * @param {string} campaignOutdoorId 
         * @param {string} fileName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestUploadUrl: async (campaignOutdoorId: string, fileName: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'campaignOutdoorId' is not null or undefined
            assertParamExists('requestUploadUrl', 'campaignOutdoorId', campaignOutdoorId)
            // verify required parameter 'fileName' is not null or undefined
            assertParamExists('requestUploadUrl', 'fileName', fileName)
            const localVarPath = `/api/v1/campaign-outdoors/{campaignOutdoorId}/proof-of-ad-url`
                .replace('{campaignOutdoorId}', encodeURIComponent(String(campaignOutdoorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (fileName !== undefined) {
                localVarQueryParameter['fileName'] = fileName;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update the start and end dates of a Campaign Outdoor
         * @param {string} campaignOutdoorId 
         * @param {UpdateCampaignOutdoorDatesRequestDto} updateCampaignOutdoorDatesRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDates: async (campaignOutdoorId: string, updateCampaignOutdoorDatesRequestDto: UpdateCampaignOutdoorDatesRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'campaignOutdoorId' is not null or undefined
            assertParamExists('updateDates', 'campaignOutdoorId', campaignOutdoorId)
            // verify required parameter 'updateCampaignOutdoorDatesRequestDto' is not null or undefined
            assertParamExists('updateDates', 'updateCampaignOutdoorDatesRequestDto', updateCampaignOutdoorDatesRequestDto)
            const localVarPath = `/api/v1/campaign-outdoors/{campaignOutdoorId}/dates`
                .replace('{campaignOutdoorId}', encodeURIComponent(String(campaignOutdoorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCampaignOutdoorDatesRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CampaignOutdoorEndpointsApi - functional programming interface
 */
export const CampaignOutdoorEndpointsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CampaignOutdoorEndpointsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Upload Proof of Ad
         * @param {string} campaignOutdoorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteProofOfAd(campaignOutdoorId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteProofOfAd(campaignOutdoorId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CampaignOutdoorEndpointsApi.deleteProofOfAd']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * To get blocked dates by Outdoor ID
         * @param {string} outdoorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBlockedDatesOfOutdoor(outdoorId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OutdoorBlockedDatesDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBlockedDatesOfOutdoor(outdoorId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CampaignOutdoorEndpointsApi.getBlockedDatesOfOutdoor']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Pending Campaign Outdoors
         * @param {string} placementProviderId 
         * @param {string} campaignId 
         * @param {Pageable} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCampaignOutdoorsByPlacementProviderAndCampaign(placementProviderId: string, campaignId: string, page: Pageable, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedCampaignOutdoorDtos>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCampaignOutdoorsByPlacementProviderAndCampaign(placementProviderId, campaignId, page, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CampaignOutdoorEndpointsApi.getCampaignOutdoorsByPlacementProviderAndCampaign']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Upload Proof of Ad
         * @param {string} campaignOutdoorId 
         * @param {string} fileName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestUploadUrl(campaignOutdoorId: string, fileName: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CampaignOutdoorProofDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestUploadUrl(campaignOutdoorId, fileName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CampaignOutdoorEndpointsApi.requestUploadUrl']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update the start and end dates of a Campaign Outdoor
         * @param {string} campaignOutdoorId 
         * @param {UpdateCampaignOutdoorDatesRequestDto} updateCampaignOutdoorDatesRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDates(campaignOutdoorId: string, updateCampaignOutdoorDatesRequestDto: UpdateCampaignOutdoorDatesRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CampaignOutdoorDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDates(campaignOutdoorId, updateCampaignOutdoorDatesRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CampaignOutdoorEndpointsApi.updateDates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CampaignOutdoorEndpointsApi - factory interface
 */
export const CampaignOutdoorEndpointsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CampaignOutdoorEndpointsApiFp(configuration)
    return {
        /**
         * 
         * @summary Upload Proof of Ad
         * @param {string} campaignOutdoorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProofOfAd(campaignOutdoorId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteProofOfAd(campaignOutdoorId, options).then((request) => request(axios, basePath));
        },
        /**
         * To get blocked dates by Outdoor ID
         * @param {string} outdoorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBlockedDatesOfOutdoor(outdoorId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<OutdoorBlockedDatesDto>> {
            return localVarFp.getBlockedDatesOfOutdoor(outdoorId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Pending Campaign Outdoors
         * @param {string} placementProviderId 
         * @param {string} campaignId 
         * @param {Pageable} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCampaignOutdoorsByPlacementProviderAndCampaign(placementProviderId: string, campaignId: string, page: Pageable, options?: RawAxiosRequestConfig): AxiosPromise<PagedCampaignOutdoorDtos> {
            return localVarFp.getCampaignOutdoorsByPlacementProviderAndCampaign(placementProviderId, campaignId, page, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upload Proof of Ad
         * @param {string} campaignOutdoorId 
         * @param {string} fileName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestUploadUrl(campaignOutdoorId: string, fileName: string, options?: RawAxiosRequestConfig): AxiosPromise<CampaignOutdoorProofDto> {
            return localVarFp.requestUploadUrl(campaignOutdoorId, fileName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update the start and end dates of a Campaign Outdoor
         * @param {string} campaignOutdoorId 
         * @param {UpdateCampaignOutdoorDatesRequestDto} updateCampaignOutdoorDatesRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDates(campaignOutdoorId: string, updateCampaignOutdoorDatesRequestDto: UpdateCampaignOutdoorDatesRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<CampaignOutdoorDto> {
            return localVarFp.updateDates(campaignOutdoorId, updateCampaignOutdoorDatesRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CampaignOutdoorEndpointsApi - object-oriented interface
 */
export class CampaignOutdoorEndpointsApi extends BaseAPI {
    /**
     * 
     * @summary Upload Proof of Ad
     * @param {string} campaignOutdoorId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteProofOfAd(campaignOutdoorId: string, options?: RawAxiosRequestConfig) {
        return CampaignOutdoorEndpointsApiFp(this.configuration).deleteProofOfAd(campaignOutdoorId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * To get blocked dates by Outdoor ID
     * @param {string} outdoorId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getBlockedDatesOfOutdoor(outdoorId: string, options?: RawAxiosRequestConfig) {
        return CampaignOutdoorEndpointsApiFp(this.configuration).getBlockedDatesOfOutdoor(outdoorId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Pending Campaign Outdoors
     * @param {string} placementProviderId 
     * @param {string} campaignId 
     * @param {Pageable} page 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCampaignOutdoorsByPlacementProviderAndCampaign(placementProviderId: string, campaignId: string, page: Pageable, options?: RawAxiosRequestConfig) {
        return CampaignOutdoorEndpointsApiFp(this.configuration).getCampaignOutdoorsByPlacementProviderAndCampaign(placementProviderId, campaignId, page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upload Proof of Ad
     * @param {string} campaignOutdoorId 
     * @param {string} fileName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public requestUploadUrl(campaignOutdoorId: string, fileName: string, options?: RawAxiosRequestConfig) {
        return CampaignOutdoorEndpointsApiFp(this.configuration).requestUploadUrl(campaignOutdoorId, fileName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update the start and end dates of a Campaign Outdoor
     * @param {string} campaignOutdoorId 
     * @param {UpdateCampaignOutdoorDatesRequestDto} updateCampaignOutdoorDatesRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateDates(campaignOutdoorId: string, updateCampaignOutdoorDatesRequestDto: UpdateCampaignOutdoorDatesRequestDto, options?: RawAxiosRequestConfig) {
        return CampaignOutdoorEndpointsApiFp(this.configuration).updateDates(campaignOutdoorId, updateCampaignOutdoorDatesRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * EmailsControllerApi - axios parameter creator
 */
export const EmailsControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Send information email
         * @param {InfoEmailDto} infoEmailDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendInfoEmail: async (infoEmailDto: InfoEmailDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'infoEmailDto' is not null or undefined
            assertParamExists('sendInfoEmail', 'infoEmailDto', infoEmailDto)
            const localVarPath = `/api/v1/emails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(infoEmailDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EmailsControllerApi - functional programming interface
 */
export const EmailsControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EmailsControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Send information email
         * @param {InfoEmailDto} infoEmailDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendInfoEmail(infoEmailDto: InfoEmailDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendInfoEmail(infoEmailDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmailsControllerApi.sendInfoEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EmailsControllerApi - factory interface
 */
export const EmailsControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EmailsControllerApiFp(configuration)
    return {
        /**
         * Send information email
         * @param {InfoEmailDto} infoEmailDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendInfoEmail(infoEmailDto: InfoEmailDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.sendInfoEmail(infoEmailDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EmailsControllerApi - object-oriented interface
 */
export class EmailsControllerApi extends BaseAPI {
    /**
     * Send information email
     * @param {InfoEmailDto} infoEmailDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public sendInfoEmail(infoEmailDto: InfoEmailDto, options?: RawAxiosRequestConfig) {
        return EmailsControllerApiFp(this.configuration).sendInfoEmail(infoEmailDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * EventsEndpointsApi - axios parameter creator
 */
export const EventsEndpointsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Subscribe to Platform events
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subscribe: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/events/subscribe`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EventsEndpointsApi - functional programming interface
 */
export const EventsEndpointsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EventsEndpointsApiAxiosParamCreator(configuration)
    return {
        /**
         * Subscribe to Platform events
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async subscribe(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubscribedEventsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.subscribe(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EventsEndpointsApi.subscribe']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EventsEndpointsApi - factory interface
 */
export const EventsEndpointsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EventsEndpointsApiFp(configuration)
    return {
        /**
         * Subscribe to Platform events
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subscribe(options?: RawAxiosRequestConfig): AxiosPromise<SubscribedEventsDto> {
            return localVarFp.subscribe(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EventsEndpointsApi - object-oriented interface
 */
export class EventsEndpointsApi extends BaseAPI {
    /**
     * Subscribe to Platform events
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public subscribe(options?: RawAxiosRequestConfig) {
        return EventsEndpointsApiFp(this.configuration).subscribe(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * InvoicesEndpointsApi - axios parameter creator
 */
export const InvoicesEndpointsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Getting paged Invoices by Business Entity
         * @param {string} businessEntityId 
         * @param {Pageable} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoicesByBusinessEntity: async (businessEntityId: string, page: Pageable, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessEntityId' is not null or undefined
            assertParamExists('getInvoicesByBusinessEntity', 'businessEntityId', businessEntityId)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('getInvoicesByBusinessEntity', 'page', page)
            const localVarPath = `/api/v1/invoices/business-entities/{businessEntityId}`
                .replace('{businessEntityId}', encodeURIComponent(String(businessEntityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                for (const [key, value] of Object.entries(page)) {
                    localVarQueryParameter[key] = value;
                }
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InvoicesEndpointsApi - functional programming interface
 */
export const InvoicesEndpointsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InvoicesEndpointsApiAxiosParamCreator(configuration)
    return {
        /**
         * Getting paged Invoices by Business Entity
         * @param {string} businessEntityId 
         * @param {Pageable} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInvoicesByBusinessEntity(businessEntityId: string, page: Pageable, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedInvoicesDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInvoicesByBusinessEntity(businessEntityId, page, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoicesEndpointsApi.getInvoicesByBusinessEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * InvoicesEndpointsApi - factory interface
 */
export const InvoicesEndpointsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InvoicesEndpointsApiFp(configuration)
    return {
        /**
         * Getting paged Invoices by Business Entity
         * @param {string} businessEntityId 
         * @param {Pageable} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoicesByBusinessEntity(businessEntityId: string, page: Pageable, options?: RawAxiosRequestConfig): AxiosPromise<PagedInvoicesDto> {
            return localVarFp.getInvoicesByBusinessEntity(businessEntityId, page, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * InvoicesEndpointsApi - object-oriented interface
 */
export class InvoicesEndpointsApi extends BaseAPI {
    /**
     * Getting paged Invoices by Business Entity
     * @param {string} businessEntityId 
     * @param {Pageable} page 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getInvoicesByBusinessEntity(businessEntityId: string, page: Pageable, options?: RawAxiosRequestConfig) {
        return InvoicesEndpointsApiFp(this.configuration).getInvoicesByBusinessEntity(businessEntityId, page, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * LocalWebhookControllerApi - axios parameter creator
 */
export const LocalWebhookControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} transferId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleWebhook2: async (transferId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'transferId' is not null or undefined
            assertParamExists('handleWebhook2', 'transferId', transferId)
            const localVarPath = `/api/v1/webhooks/wise-transfers/local`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (transferId !== undefined) {
                localVarQueryParameter['transferId'] = transferId;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LocalWebhookControllerApi - functional programming interface
 */
export const LocalWebhookControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LocalWebhookControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} transferId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async handleWebhook2(transferId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.handleWebhook2(transferId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocalWebhookControllerApi.handleWebhook2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LocalWebhookControllerApi - factory interface
 */
export const LocalWebhookControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LocalWebhookControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {number} transferId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleWebhook2(transferId: number, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.handleWebhook2(transferId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LocalWebhookControllerApi - object-oriented interface
 */
export class LocalWebhookControllerApi extends BaseAPI {
    /**
     * 
     * @param {number} transferId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public handleWebhook2(transferId: number, options?: RawAxiosRequestConfig) {
        return LocalWebhookControllerApiFp(this.configuration).handleWebhook2(transferId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MessagesEndpointsApi - axios parameter creator
 */
export const MessagesEndpointsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary To get Campaign Messages projections
         * @param {string} businessEntityId 
         * @param {string} campaignId 
         * @param {Pageable} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCampaignMessageProjections: async (businessEntityId: string, campaignId: string, page: Pageable, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessEntityId' is not null or undefined
            assertParamExists('getCampaignMessageProjections', 'businessEntityId', businessEntityId)
            // verify required parameter 'campaignId' is not null or undefined
            assertParamExists('getCampaignMessageProjections', 'campaignId', campaignId)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('getCampaignMessageProjections', 'page', page)
            const localVarPath = `/api/v1/messages/business-entities/{businessEntityId}/campaigns/{campaignId}`
                .replace('{businessEntityId}', encodeURIComponent(String(businessEntityId)))
                .replace('{campaignId}', encodeURIComponent(String(campaignId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                for (const [key, value] of Object.entries(page)) {
                    localVarQueryParameter[key] = value;
                }
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary To get Campaign Messages
         * @param {string} businessEntityId1 
         * @param {string} businessEntityId2 
         * @param {string} campaignId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCampaignMessages: async (businessEntityId1: string, businessEntityId2: string, campaignId: string, page?: number, size?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessEntityId1' is not null or undefined
            assertParamExists('getCampaignMessages', 'businessEntityId1', businessEntityId1)
            // verify required parameter 'businessEntityId2' is not null or undefined
            assertParamExists('getCampaignMessages', 'businessEntityId2', businessEntityId2)
            // verify required parameter 'campaignId' is not null or undefined
            assertParamExists('getCampaignMessages', 'campaignId', campaignId)
            const localVarPath = `/api/v1/messages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (businessEntityId1 !== undefined) {
                localVarQueryParameter['businessEntityId1'] = businessEntityId1;
            }

            if (businessEntityId2 !== undefined) {
                localVarQueryParameter['businessEntityId2'] = businessEntityId2;
            }

            if (campaignId !== undefined) {
                localVarQueryParameter['campaignId'] = campaignId;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Send Campaign message
         * @param {string} campaignId 
         * @param {CreateCampaignMessageDto} createCampaignMessageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendCampaignMessage: async (campaignId: string, createCampaignMessageDto: CreateCampaignMessageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'campaignId' is not null or undefined
            assertParamExists('sendCampaignMessage', 'campaignId', campaignId)
            // verify required parameter 'createCampaignMessageDto' is not null or undefined
            assertParamExists('sendCampaignMessage', 'createCampaignMessageDto', createCampaignMessageDto)
            const localVarPath = `/api/v1/messages/campaigns/{campaignId}`
                .replace('{campaignId}', encodeURIComponent(String(campaignId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCampaignMessageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MessagesEndpointsApi - functional programming interface
 */
export const MessagesEndpointsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MessagesEndpointsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary To get Campaign Messages projections
         * @param {string} businessEntityId 
         * @param {string} campaignId 
         * @param {Pageable} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCampaignMessageProjections(businessEntityId: string, campaignId: string, page: Pageable, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedCampaignMessageProjectionsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCampaignMessageProjections(businessEntityId, campaignId, page, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MessagesEndpointsApi.getCampaignMessageProjections']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary To get Campaign Messages
         * @param {string} businessEntityId1 
         * @param {string} businessEntityId2 
         * @param {string} campaignId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCampaignMessages(businessEntityId1: string, businessEntityId2: string, campaignId: string, page?: number, size?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CampaignMessageDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCampaignMessages(businessEntityId1, businessEntityId2, campaignId, page, size, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MessagesEndpointsApi.getCampaignMessages']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Send Campaign message
         * @param {string} campaignId 
         * @param {CreateCampaignMessageDto} createCampaignMessageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendCampaignMessage(campaignId: string, createCampaignMessageDto: CreateCampaignMessageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CampaignMessageDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendCampaignMessage(campaignId, createCampaignMessageDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MessagesEndpointsApi.sendCampaignMessage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MessagesEndpointsApi - factory interface
 */
export const MessagesEndpointsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MessagesEndpointsApiFp(configuration)
    return {
        /**
         * 
         * @summary To get Campaign Messages projections
         * @param {string} businessEntityId 
         * @param {string} campaignId 
         * @param {Pageable} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCampaignMessageProjections(businessEntityId: string, campaignId: string, page: Pageable, options?: RawAxiosRequestConfig): AxiosPromise<PagedCampaignMessageProjectionsDto> {
            return localVarFp.getCampaignMessageProjections(businessEntityId, campaignId, page, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary To get Campaign Messages
         * @param {string} businessEntityId1 
         * @param {string} businessEntityId2 
         * @param {string} campaignId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCampaignMessages(businessEntityId1: string, businessEntityId2: string, campaignId: string, page?: number, size?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<CampaignMessageDto>> {
            return localVarFp.getCampaignMessages(businessEntityId1, businessEntityId2, campaignId, page, size, options).then((request) => request(axios, basePath));
        },
        /**
         * Send Campaign message
         * @param {string} campaignId 
         * @param {CreateCampaignMessageDto} createCampaignMessageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendCampaignMessage(campaignId: string, createCampaignMessageDto: CreateCampaignMessageDto, options?: RawAxiosRequestConfig): AxiosPromise<CampaignMessageDto> {
            return localVarFp.sendCampaignMessage(campaignId, createCampaignMessageDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MessagesEndpointsApi - object-oriented interface
 */
export class MessagesEndpointsApi extends BaseAPI {
    /**
     * 
     * @summary To get Campaign Messages projections
     * @param {string} businessEntityId 
     * @param {string} campaignId 
     * @param {Pageable} page 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCampaignMessageProjections(businessEntityId: string, campaignId: string, page: Pageable, options?: RawAxiosRequestConfig) {
        return MessagesEndpointsApiFp(this.configuration).getCampaignMessageProjections(businessEntityId, campaignId, page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary To get Campaign Messages
     * @param {string} businessEntityId1 
     * @param {string} businessEntityId2 
     * @param {string} campaignId 
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCampaignMessages(businessEntityId1: string, businessEntityId2: string, campaignId: string, page?: number, size?: number, options?: RawAxiosRequestConfig) {
        return MessagesEndpointsApiFp(this.configuration).getCampaignMessages(businessEntityId1, businessEntityId2, campaignId, page, size, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Send Campaign message
     * @param {string} campaignId 
     * @param {CreateCampaignMessageDto} createCampaignMessageDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public sendCampaignMessage(campaignId: string, createCampaignMessageDto: CreateCampaignMessageDto, options?: RawAxiosRequestConfig) {
        return MessagesEndpointsApiFp(this.configuration).sendCampaignMessage(campaignId, createCampaignMessageDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * OfflineCampaignEndpointsApi - axios parameter creator
 */
export const OfflineCampaignEndpointsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add a file to an OFFLINE Campaign - returns where to upload it
         * @param {string} campaignId 
         * @param {AddAdditionalFileRequestDto} addAdditionalFileRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addAdditionalFile1: async (campaignId: string, addAdditionalFileRequestDto: AddAdditionalFileRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'campaignId' is not null or undefined
            assertParamExists('addAdditionalFile1', 'campaignId', campaignId)
            // verify required parameter 'addAdditionalFileRequestDto' is not null or undefined
            assertParamExists('addAdditionalFile1', 'addAdditionalFileRequestDto', addAdditionalFileRequestDto)
            const localVarPath = `/api/v1/campaigns/offline/{campaignId}/additional-files`
                .replace('{campaignId}', encodeURIComponent(String(campaignId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addAdditionalFileRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Book more of the Placement Provider\'s Outdoors in an OFFLINE Campaign - all or nothing
         * @param {string} campaignId 
         * @param {Array<CreateOutdoorSlotRequestDto>} createOutdoorSlotRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCampaignOutdoors: async (campaignId: string, createOutdoorSlotRequestDto: Array<CreateOutdoorSlotRequestDto>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'campaignId' is not null or undefined
            assertParamExists('addCampaignOutdoors', 'campaignId', campaignId)
            // verify required parameter 'createOutdoorSlotRequestDto' is not null or undefined
            assertParamExists('addCampaignOutdoors', 'createOutdoorSlotRequestDto', createOutdoorSlotRequestDto)
            const localVarPath = `/api/v1/campaigns/offline/{campaignId}/campaign-outdoors`
                .replace('{campaignId}', encodeURIComponent(String(campaignId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createOutdoorSlotRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Add creatives (each with its preview) to an OFFLINE Campaign - returns where to upload them; never checked once uploaded
         * @param {string} campaignId 
         * @param {Array<CreativeRequestDto>} creativeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCreatives1: async (campaignId: string, creativeRequestDto: Array<CreativeRequestDto>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'campaignId' is not null or undefined
            assertParamExists('addCreatives1', 'campaignId', campaignId)
            // verify required parameter 'creativeRequestDto' is not null or undefined
            assertParamExists('addCreatives1', 'creativeRequestDto', creativeRequestDto)
            const localVarPath = `/api/v1/campaigns/offline/{campaignId}/creatives`
                .replace('{campaignId}', encodeURIComponent(String(campaignId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(creativeRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create an OFFLINE Campaign of a Placement Provider
         * @param {string} placementProviderId 
         * @param {WriteOfflineCampaignRequestDto} writeOfflineCampaignRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: async (placementProviderId: string, writeOfflineCampaignRequestDto: WriteOfflineCampaignRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'placementProviderId' is not null or undefined
            assertParamExists('create', 'placementProviderId', placementProviderId)
            // verify required parameter 'writeOfflineCampaignRequestDto' is not null or undefined
            assertParamExists('create', 'writeOfflineCampaignRequestDto', writeOfflineCampaignRequestDto)
            const localVarPath = `/api/v1/campaigns/offline/placement-providers/{placementProviderId}`
                .replace('{placementProviderId}', encodeURIComponent(String(placementProviderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(writeOfflineCampaignRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a file of an OFFLINE Campaign
         * @param {string} campaignId 
         * @param {string} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdditionalFile1: async (campaignId: string, fileId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'campaignId' is not null or undefined
            assertParamExists('deleteAdditionalFile1', 'campaignId', campaignId)
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('deleteAdditionalFile1', 'fileId', fileId)
            const localVarPath = `/api/v1/campaigns/offline/{campaignId}/additional-files/{fileId}`
                .replace('{campaignId}', encodeURIComponent(String(campaignId)))
                .replace('{fileId}', encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete creatives of an OFFLINE Campaign
         * @param {string} campaignId 
         * @param {Set<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCreatives1: async (campaignId: string, requestBody: Set<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'campaignId' is not null or undefined
            assertParamExists('deleteCreatives1', 'campaignId', campaignId)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('deleteCreatives1', 'requestBody', requestBody)
            const localVarPath = `/api/v1/campaigns/offline/{campaignId}/creatives`
                .replace('{campaignId}', encodeURIComponent(String(campaignId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get an OFFLINE Campaign
         * @param {string} campaignId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: async (campaignId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'campaignId' is not null or undefined
            assertParamExists('get', 'campaignId', campaignId)
            const localVarPath = `/api/v1/campaigns/offline/{campaignId}`
                .replace('{campaignId}', encodeURIComponent(String(campaignId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a Placement Provider\'s OFFLINE Campaigns, a page at a time - the most recently updated first
         * @param {string} placementProviderId 
         * @param {Pageable} pageable 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByPlacementProvider1: async (placementProviderId: string, pageable: Pageable, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'placementProviderId' is not null or undefined
            assertParamExists('getByPlacementProvider1', 'placementProviderId', placementProviderId)
            // verify required parameter 'pageable' is not null or undefined
            assertParamExists('getByPlacementProvider1', 'pageable', pageable)
            const localVarPath = `/api/v1/campaigns/offline/placement-providers/{placementProviderId}`
                .replace('{placementProviderId}', encodeURIComponent(String(placementProviderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (pageable !== undefined) {
                for (const [key, value] of Object.entries(pageable)) {
                    localVarQueryParameter[key] = value;
                }
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Replace every Outdoor booked in an OFFLINE Campaign - all or nothing
         * @param {string} campaignId 
         * @param {Array<CreateOutdoorSlotRequestDto>} createOutdoorSlotRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceCampaignOutdoors: async (campaignId: string, createOutdoorSlotRequestDto: Array<CreateOutdoorSlotRequestDto>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'campaignId' is not null or undefined
            assertParamExists('replaceCampaignOutdoors', 'campaignId', campaignId)
            // verify required parameter 'createOutdoorSlotRequestDto' is not null or undefined
            assertParamExists('replaceCampaignOutdoors', 'createOutdoorSlotRequestDto', createOutdoorSlotRequestDto)
            const localVarPath = `/api/v1/campaigns/offline/{campaignId}/campaign-outdoors`
                .replace('{campaignId}', encodeURIComponent(String(campaignId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createOutdoorSlotRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update an OFFLINE Campaign\'s details
         * @param {string} campaignId 
         * @param {WriteOfflineCampaignRequestDto} writeOfflineCampaignRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (campaignId: string, writeOfflineCampaignRequestDto: WriteOfflineCampaignRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'campaignId' is not null or undefined
            assertParamExists('update', 'campaignId', campaignId)
            // verify required parameter 'writeOfflineCampaignRequestDto' is not null or undefined
            assertParamExists('update', 'writeOfflineCampaignRequestDto', writeOfflineCampaignRequestDto)
            const localVarPath = `/api/v1/campaigns/offline/{campaignId}`
                .replace('{campaignId}', encodeURIComponent(String(campaignId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(writeOfflineCampaignRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OfflineCampaignEndpointsApi - functional programming interface
 */
export const OfflineCampaignEndpointsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OfflineCampaignEndpointsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Add a file to an OFFLINE Campaign - returns where to upload it
         * @param {string} campaignId 
         * @param {AddAdditionalFileRequestDto} addAdditionalFileRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addAdditionalFile1(campaignId: string, addAdditionalFileRequestDto: AddAdditionalFileRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddAdditionalFileResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addAdditionalFile1(campaignId, addAdditionalFileRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OfflineCampaignEndpointsApi.addAdditionalFile1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Book more of the Placement Provider\'s Outdoors in an OFFLINE Campaign - all or nothing
         * @param {string} campaignId 
         * @param {Array<CreateOutdoorSlotRequestDto>} createOutdoorSlotRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addCampaignOutdoors(campaignId: string, createOutdoorSlotRequestDto: Array<CreateOutdoorSlotRequestDto>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OfflineCampaignResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addCampaignOutdoors(campaignId, createOutdoorSlotRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OfflineCampaignEndpointsApi.addCampaignOutdoors']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Add creatives (each with its preview) to an OFFLINE Campaign - returns where to upload them; never checked once uploaded
         * @param {string} campaignId 
         * @param {Array<CreativeRequestDto>} creativeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addCreatives1(campaignId: string, creativeRequestDto: Array<CreativeRequestDto>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddCreativesResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addCreatives1(campaignId, creativeRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OfflineCampaignEndpointsApi.addCreatives1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create an OFFLINE Campaign of a Placement Provider
         * @param {string} placementProviderId 
         * @param {WriteOfflineCampaignRequestDto} writeOfflineCampaignRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create(placementProviderId: string, writeOfflineCampaignRequestDto: WriteOfflineCampaignRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OfflineCampaignResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create(placementProviderId, writeOfflineCampaignRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OfflineCampaignEndpointsApi.create']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a file of an OFFLINE Campaign
         * @param {string} campaignId 
         * @param {string} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAdditionalFile1(campaignId: string, fileId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OfflineCampaignResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAdditionalFile1(campaignId, fileId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OfflineCampaignEndpointsApi.deleteAdditionalFile1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete creatives of an OFFLINE Campaign
         * @param {string} campaignId 
         * @param {Set<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCreatives1(campaignId: string, requestBody: Set<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OfflineCampaignResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCreatives1(campaignId, requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OfflineCampaignEndpointsApi.deleteCreatives1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get an OFFLINE Campaign
         * @param {string} campaignId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async get(campaignId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OfflineCampaignResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.get(campaignId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OfflineCampaignEndpointsApi.get']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a Placement Provider\'s OFFLINE Campaigns, a page at a time - the most recently updated first
         * @param {string} placementProviderId 
         * @param {Pageable} pageable 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getByPlacementProvider1(placementProviderId: string, pageable: Pageable, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedOfflineCampaignsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getByPlacementProvider1(placementProviderId, pageable, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OfflineCampaignEndpointsApi.getByPlacementProvider1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Replace every Outdoor booked in an OFFLINE Campaign - all or nothing
         * @param {string} campaignId 
         * @param {Array<CreateOutdoorSlotRequestDto>} createOutdoorSlotRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async replaceCampaignOutdoors(campaignId: string, createOutdoorSlotRequestDto: Array<CreateOutdoorSlotRequestDto>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OfflineCampaignResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.replaceCampaignOutdoors(campaignId, createOutdoorSlotRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OfflineCampaignEndpointsApi.replaceCampaignOutdoors']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update an OFFLINE Campaign\'s details
         * @param {string} campaignId 
         * @param {WriteOfflineCampaignRequestDto} writeOfflineCampaignRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(campaignId: string, writeOfflineCampaignRequestDto: WriteOfflineCampaignRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OfflineCampaignResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(campaignId, writeOfflineCampaignRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OfflineCampaignEndpointsApi.update']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OfflineCampaignEndpointsApi - factory interface
 */
export const OfflineCampaignEndpointsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OfflineCampaignEndpointsApiFp(configuration)
    return {
        /**
         * 
         * @summary Add a file to an OFFLINE Campaign - returns where to upload it
         * @param {string} campaignId 
         * @param {AddAdditionalFileRequestDto} addAdditionalFileRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addAdditionalFile1(campaignId: string, addAdditionalFileRequestDto: AddAdditionalFileRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<AddAdditionalFileResponseDto> {
            return localVarFp.addAdditionalFile1(campaignId, addAdditionalFileRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Book more of the Placement Provider\'s Outdoors in an OFFLINE Campaign - all or nothing
         * @param {string} campaignId 
         * @param {Array<CreateOutdoorSlotRequestDto>} createOutdoorSlotRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCampaignOutdoors(campaignId: string, createOutdoorSlotRequestDto: Array<CreateOutdoorSlotRequestDto>, options?: RawAxiosRequestConfig): AxiosPromise<OfflineCampaignResponseDto> {
            return localVarFp.addCampaignOutdoors(campaignId, createOutdoorSlotRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Add creatives (each with its preview) to an OFFLINE Campaign - returns where to upload them; never checked once uploaded
         * @param {string} campaignId 
         * @param {Array<CreativeRequestDto>} creativeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCreatives1(campaignId: string, creativeRequestDto: Array<CreativeRequestDto>, options?: RawAxiosRequestConfig): AxiosPromise<AddCreativesResponseDto> {
            return localVarFp.addCreatives1(campaignId, creativeRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create an OFFLINE Campaign of a Placement Provider
         * @param {string} placementProviderId 
         * @param {WriteOfflineCampaignRequestDto} writeOfflineCampaignRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(placementProviderId: string, writeOfflineCampaignRequestDto: WriteOfflineCampaignRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<OfflineCampaignResponseDto> {
            return localVarFp.create(placementProviderId, writeOfflineCampaignRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a file of an OFFLINE Campaign
         * @param {string} campaignId 
         * @param {string} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdditionalFile1(campaignId: string, fileId: string, options?: RawAxiosRequestConfig): AxiosPromise<OfflineCampaignResponseDto> {
            return localVarFp.deleteAdditionalFile1(campaignId, fileId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete creatives of an OFFLINE Campaign
         * @param {string} campaignId 
         * @param {Set<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCreatives1(campaignId: string, requestBody: Set<string>, options?: RawAxiosRequestConfig): AxiosPromise<OfflineCampaignResponseDto> {
            return localVarFp.deleteCreatives1(campaignId, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get an OFFLINE Campaign
         * @param {string} campaignId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(campaignId: string, options?: RawAxiosRequestConfig): AxiosPromise<OfflineCampaignResponseDto> {
            return localVarFp.get(campaignId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a Placement Provider\'s OFFLINE Campaigns, a page at a time - the most recently updated first
         * @param {string} placementProviderId 
         * @param {Pageable} pageable 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByPlacementProvider1(placementProviderId: string, pageable: Pageable, options?: RawAxiosRequestConfig): AxiosPromise<PagedOfflineCampaignsDto> {
            return localVarFp.getByPlacementProvider1(placementProviderId, pageable, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Replace every Outdoor booked in an OFFLINE Campaign - all or nothing
         * @param {string} campaignId 
         * @param {Array<CreateOutdoorSlotRequestDto>} createOutdoorSlotRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceCampaignOutdoors(campaignId: string, createOutdoorSlotRequestDto: Array<CreateOutdoorSlotRequestDto>, options?: RawAxiosRequestConfig): AxiosPromise<OfflineCampaignResponseDto> {
            return localVarFp.replaceCampaignOutdoors(campaignId, createOutdoorSlotRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update an OFFLINE Campaign\'s details
         * @param {string} campaignId 
         * @param {WriteOfflineCampaignRequestDto} writeOfflineCampaignRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(campaignId: string, writeOfflineCampaignRequestDto: WriteOfflineCampaignRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<OfflineCampaignResponseDto> {
            return localVarFp.update(campaignId, writeOfflineCampaignRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OfflineCampaignEndpointsApi - object-oriented interface
 */
export class OfflineCampaignEndpointsApi extends BaseAPI {
    /**
     * 
     * @summary Add a file to an OFFLINE Campaign - returns where to upload it
     * @param {string} campaignId 
     * @param {AddAdditionalFileRequestDto} addAdditionalFileRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public addAdditionalFile1(campaignId: string, addAdditionalFileRequestDto: AddAdditionalFileRequestDto, options?: RawAxiosRequestConfig) {
        return OfflineCampaignEndpointsApiFp(this.configuration).addAdditionalFile1(campaignId, addAdditionalFileRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Book more of the Placement Provider\'s Outdoors in an OFFLINE Campaign - all or nothing
     * @param {string} campaignId 
     * @param {Array<CreateOutdoorSlotRequestDto>} createOutdoorSlotRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public addCampaignOutdoors(campaignId: string, createOutdoorSlotRequestDto: Array<CreateOutdoorSlotRequestDto>, options?: RawAxiosRequestConfig) {
        return OfflineCampaignEndpointsApiFp(this.configuration).addCampaignOutdoors(campaignId, createOutdoorSlotRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Add creatives (each with its preview) to an OFFLINE Campaign - returns where to upload them; never checked once uploaded
     * @param {string} campaignId 
     * @param {Array<CreativeRequestDto>} creativeRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public addCreatives1(campaignId: string, creativeRequestDto: Array<CreativeRequestDto>, options?: RawAxiosRequestConfig) {
        return OfflineCampaignEndpointsApiFp(this.configuration).addCreatives1(campaignId, creativeRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create an OFFLINE Campaign of a Placement Provider
     * @param {string} placementProviderId 
     * @param {WriteOfflineCampaignRequestDto} writeOfflineCampaignRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public create(placementProviderId: string, writeOfflineCampaignRequestDto: WriteOfflineCampaignRequestDto, options?: RawAxiosRequestConfig) {
        return OfflineCampaignEndpointsApiFp(this.configuration).create(placementProviderId, writeOfflineCampaignRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a file of an OFFLINE Campaign
     * @param {string} campaignId 
     * @param {string} fileId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteAdditionalFile1(campaignId: string, fileId: string, options?: RawAxiosRequestConfig) {
        return OfflineCampaignEndpointsApiFp(this.configuration).deleteAdditionalFile1(campaignId, fileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete creatives of an OFFLINE Campaign
     * @param {string} campaignId 
     * @param {Set<string>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteCreatives1(campaignId: string, requestBody: Set<string>, options?: RawAxiosRequestConfig) {
        return OfflineCampaignEndpointsApiFp(this.configuration).deleteCreatives1(campaignId, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get an OFFLINE Campaign
     * @param {string} campaignId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public get(campaignId: string, options?: RawAxiosRequestConfig) {
        return OfflineCampaignEndpointsApiFp(this.configuration).get(campaignId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a Placement Provider\'s OFFLINE Campaigns, a page at a time - the most recently updated first
     * @param {string} placementProviderId 
     * @param {Pageable} pageable 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getByPlacementProvider1(placementProviderId: string, pageable: Pageable, options?: RawAxiosRequestConfig) {
        return OfflineCampaignEndpointsApiFp(this.configuration).getByPlacementProvider1(placementProviderId, pageable, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Replace every Outdoor booked in an OFFLINE Campaign - all or nothing
     * @param {string} campaignId 
     * @param {Array<CreateOutdoorSlotRequestDto>} createOutdoorSlotRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public replaceCampaignOutdoors(campaignId: string, createOutdoorSlotRequestDto: Array<CreateOutdoorSlotRequestDto>, options?: RawAxiosRequestConfig) {
        return OfflineCampaignEndpointsApiFp(this.configuration).replaceCampaignOutdoors(campaignId, createOutdoorSlotRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update an OFFLINE Campaign\'s details
     * @param {string} campaignId 
     * @param {WriteOfflineCampaignRequestDto} writeOfflineCampaignRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public update(campaignId: string, writeOfflineCampaignRequestDto: WriteOfflineCampaignRequestDto, options?: RawAxiosRequestConfig) {
        return OfflineCampaignEndpointsApiFp(this.configuration).update(campaignId, writeOfflineCampaignRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * OutdoorControllerApi - axios parameter creator
 */
export const OutdoorControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} outdoorId 
         * @param {DiscountDto} discountDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addDiscount: async (outdoorId: string, discountDto: DiscountDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'outdoorId' is not null or undefined
            assertParamExists('addDiscount', 'outdoorId', outdoorId)
            // verify required parameter 'discountDto' is not null or undefined
            assertParamExists('addDiscount', 'discountDto', discountDto)
            const localVarPath = `/api/v1/outdoors/{outdoorId}/discounts`
                .replace('{outdoorId}', encodeURIComponent(String(outdoorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(discountDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} outdoorId 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addOutdoorPictures: async (outdoorId: string, requestBody: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'outdoorId' is not null or undefined
            assertParamExists('addOutdoorPictures', 'outdoorId', outdoorId)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('addOutdoorPictures', 'requestBody', requestBody)
            const localVarPath = `/api/v1/outdoors/{outdoorId}/images`
                .replace('{outdoorId}', encodeURIComponent(String(outdoorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} placementProviderId 
         * @param {Array<WriteOutdoorRequestDto>} writeOutdoorRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMultipleOutdoors: async (placementProviderId: string, writeOutdoorRequestDto: Array<WriteOutdoorRequestDto>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'placementProviderId' is not null or undefined
            assertParamExists('createMultipleOutdoors', 'placementProviderId', placementProviderId)
            // verify required parameter 'writeOutdoorRequestDto' is not null or undefined
            assertParamExists('createMultipleOutdoors', 'writeOutdoorRequestDto', writeOutdoorRequestDto)
            const localVarPath = `/api/v1/outdoors/placement-providers/{placementProviderId}/batch`
                .replace('{placementProviderId}', encodeURIComponent(String(placementProviderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(writeOutdoorRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create Outdoor
         * @param {string} placementProviderId 
         * @param {WriteOutdoorRequestDto} writeOutdoorRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOutdoor: async (placementProviderId: string, writeOutdoorRequestDto: WriteOutdoorRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'placementProviderId' is not null or undefined
            assertParamExists('createOutdoor', 'placementProviderId', placementProviderId)
            // verify required parameter 'writeOutdoorRequestDto' is not null or undefined
            assertParamExists('createOutdoor', 'writeOutdoorRequestDto', writeOutdoorRequestDto)
            const localVarPath = `/api/v1/outdoors/placement-providers/{placementProviderId}`
                .replace('{placementProviderId}', encodeURIComponent(String(placementProviderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(writeOutdoorRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Set<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMultipleOutdoors: async (requestBody: Set<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('deleteMultipleOutdoors', 'requestBody', requestBody)
            const localVarPath = `/api/v1/outdoors/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} outdoorId 
         * @param {Set<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOutdoorPictures: async (outdoorId: string, requestBody: Set<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'outdoorId' is not null or undefined
            assertParamExists('deleteOutdoorPictures', 'outdoorId', outdoorId)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('deleteOutdoorPictures', 'requestBody', requestBody)
            const localVarPath = `/api/v1/outdoors/{outdoorId}/images`
                .replace('{outdoorId}', encodeURIComponent(String(outdoorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get Outdoor
         * @param {string} outdoorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getById: async (outdoorId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'outdoorId' is not null or undefined
            assertParamExists('getById', 'outdoorId', outdoorId)
            const localVarPath = `/api/v1/outdoors/{outdoorId}`
                .replace('{outdoorId}', encodeURIComponent(String(outdoorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get Outdoors by ID\'s
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByIds: async (requestBody: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('getByIds', 'requestBody', requestBody)
            const localVarPath = `/api/v1/outdoors/by-ids`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * To get Outdoors of Placement Provider
         * @param {string} placementProviderId 
         * @param {Pageable} page 
         * @param {string} [name] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByPlacementProvider: async (placementProviderId: string, page: Pageable, name?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'placementProviderId' is not null or undefined
            assertParamExists('getByPlacementProvider', 'placementProviderId', placementProviderId)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('getByPlacementProvider', 'page', page)
            const localVarPath = `/api/v1/outdoors/placement-providers/{placementProviderId}`
                .replace('{placementProviderId}', encodeURIComponent(String(placementProviderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (page !== undefined) {
                for (const [key, value] of Object.entries(page)) {
                    localVarQueryParameter[key] = value;
                }
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * To get, for each day from `from` to `to` (inclusive), whether the Placement Provider has bookings or blocked periods starting, finishing and running that day
         * @param {string} placementProviderId 
         * @param {string} from 
         * @param {string} to 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDailyStates: async (placementProviderId: string, from: string, to: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'placementProviderId' is not null or undefined
            assertParamExists('getDailyStates', 'placementProviderId', placementProviderId)
            // verify required parameter 'from' is not null or undefined
            assertParamExists('getDailyStates', 'from', from)
            // verify required parameter 'to' is not null or undefined
            assertParamExists('getDailyStates', 'to', to)
            const localVarPath = `/api/v1/outdoors/placement-providers/{placementProviderId}/daily-states`
                .replace('{placementProviderId}', encodeURIComponent(String(placementProviderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (from !== undefined) {
                localVarQueryParameter['from'] = (from as any instanceof Date) ?
                    (from as any).toISOString().substring(0,10) :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = (to as any instanceof Date) ?
                    (to as any).toISOString().substring(0,10) :
                    to;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * To get every distinct size (width and height, in metres) among a Placement Provider\'s Outdoors, smallest first
         * @param {string} placementProviderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDimensionsOfPlacementProvider: async (placementProviderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'placementProviderId' is not null or undefined
            assertParamExists('getDimensionsOfPlacementProvider', 'placementProviderId', placementProviderId)
            const localVarPath = `/api/v1/outdoors/placement-providers/{placementProviderId}/dimensions`
                .replace('{placementProviderId}', encodeURIComponent(String(placementProviderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Each: the percentage off for a booking of more than that number of days - from the shortest booking. Empty when it has none.
         * @summary Get an Outdoor\'s discounts
         * @param {string} outdoorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDiscounts: async (outdoorId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'outdoorId' is not null or undefined
            assertParamExists('getDiscounts', 'outdoorId', outdoorId)
            const localVarPath = `/api/v1/outdoors/{outdoorId}/discounts`
                .replace('{outdoorId}', encodeURIComponent(String(outdoorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * To get filters for Outdoors
         * @param {GetFiltersLanguageCodeEnum} [languageCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFilters: async (languageCode?: GetFiltersLanguageCodeEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/outdoors/filters`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (languageCode !== undefined) {
                localVarQueryParameter['languageCode'] = languageCode;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * To get the Outdoors of a Placement Provider that are booked or blocked on a date, earliest start first (a blocked period has no campaignOutdoorId). Optionally narrowed by (part of) the Outdoor name, case-insensitive
         * @param {string} placementProviderId 
         * @param {string} date 
         * @param {string} [name] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOutdoorsByDate: async (placementProviderId: string, date: string, name?: string, page?: number, size?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'placementProviderId' is not null or undefined
            assertParamExists('getOutdoorsByDate', 'placementProviderId', placementProviderId)
            // verify required parameter 'date' is not null or undefined
            assertParamExists('getOutdoorsByDate', 'date', date)
            const localVarPath = `/api/v1/outdoors/placement-providers/{placementProviderId}/by-date`
                .replace('{placementProviderId}', encodeURIComponent(String(placementProviderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (date !== undefined) {
                localVarQueryParameter['date'] = (date as any instanceof Date) ?
                    (date as any).toISOString().substring(0,10) :
                    date;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} outdoorId 
         * @param {string} discountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeDiscount: async (outdoorId: string, discountId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'outdoorId' is not null or undefined
            assertParamExists('removeDiscount', 'outdoorId', outdoorId)
            // verify required parameter 'discountId' is not null or undefined
            assertParamExists('removeDiscount', 'discountId', discountId)
            const localVarPath = `/api/v1/outdoors/{outdoorId}/discounts/{discountId}`
                .replace('{outdoorId}', encodeURIComponent(String(outdoorId)))
                .replace('{discountId}', encodeURIComponent(String(discountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} outdoorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeOutdoor: async (outdoorId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'outdoorId' is not null or undefined
            assertParamExists('removeOutdoor', 'outdoorId', outdoorId)
            const localVarPath = `/api/v1/outdoors/{outdoorId}`
                .replace('{outdoorId}', encodeURIComponent(String(outdoorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * To search a Placement Provider\'s own Outdoors by name, size (any of the given width and height pairs) and availability (free from availableFrom to availableTo - not booked by any active SCAPOW or OFFLINE Campaign, nor blocked)
         * @param {string} placementProviderId 
         * @param {Pageable} page 
         * @param {SearchPlacementProviderOutdoorsDto} searchPlacementProviderOutdoorsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchByPlacementProvider: async (placementProviderId: string, page: Pageable, searchPlacementProviderOutdoorsDto: SearchPlacementProviderOutdoorsDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'placementProviderId' is not null or undefined
            assertParamExists('searchByPlacementProvider', 'placementProviderId', placementProviderId)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('searchByPlacementProvider', 'page', page)
            // verify required parameter 'searchPlacementProviderOutdoorsDto' is not null or undefined
            assertParamExists('searchByPlacementProvider', 'searchPlacementProviderOutdoorsDto', searchPlacementProviderOutdoorsDto)
            const localVarPath = `/api/v1/outdoors/placement-providers/{placementProviderId}/search`
                .replace('{placementProviderId}', encodeURIComponent(String(placementProviderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                for (const [key, value] of Object.entries(page)) {
                    localVarQueryParameter[key] = value;
                }
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(searchPlacementProviderOutdoorsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Sort} sort 
         * @param {SearchOutdoorRequestDto} searchOutdoorRequestDto 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchOutdoors: async (sort: Sort, searchOutdoorRequestDto: SearchOutdoorRequestDto, page?: number, size?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sort' is not null or undefined
            assertParamExists('searchOutdoors', 'sort', sort)
            // verify required parameter 'searchOutdoorRequestDto' is not null or undefined
            assertParamExists('searchOutdoors', 'searchOutdoorRequestDto', searchOutdoorRequestDto)
            const localVarPath = `/api/v1/outdoors/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort !== undefined) {
                for (const [key, value] of Object.entries(sort)) {
                    localVarQueryParameter[key] = value;
                }
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(searchOutdoorRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * To toggle accepting new campaign of an Outdoor
         * @param {string} outdoorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleHiddenOutdoor: async (outdoorId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'outdoorId' is not null or undefined
            assertParamExists('toggleHiddenOutdoor', 'outdoorId', outdoorId)
            const localVarPath = `/api/v1/outdoors/{outdoorId}/toggle-hidden`
                .replace('{outdoorId}', encodeURIComponent(String(outdoorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * To update accepting new campaigns of several Outdoors
         * @param {OutdoorAcceptingCampaignsDto} outdoorAcceptingCampaignsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAcceptingCampaignsByOutdoorIds: async (outdoorAcceptingCampaignsDto: OutdoorAcceptingCampaignsDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'outdoorAcceptingCampaignsDto' is not null or undefined
            assertParamExists('updateAcceptingCampaignsByOutdoorIds', 'outdoorAcceptingCampaignsDto', outdoorAcceptingCampaignsDto)
            const localVarPath = `/api/v1/outdoors/accept-new-campaigns`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(outdoorAcceptingCampaignsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update Outdoor
         * @param {string} outdoorId 
         * @param {WriteOutdoorRequestDto} writeOutdoorRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOutdoor: async (outdoorId: string, writeOutdoorRequestDto: WriteOutdoorRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'outdoorId' is not null or undefined
            assertParamExists('updateOutdoor', 'outdoorId', outdoorId)
            // verify required parameter 'writeOutdoorRequestDto' is not null or undefined
            assertParamExists('updateOutdoor', 'writeOutdoorRequestDto', writeOutdoorRequestDto)
            const localVarPath = `/api/v1/outdoors/{outdoorId}`
                .replace('{outdoorId}', encodeURIComponent(String(outdoorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(writeOutdoorRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OutdoorControllerApi - functional programming interface
 */
export const OutdoorControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OutdoorControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} outdoorId 
         * @param {DiscountDto} discountDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addDiscount(outdoorId: string, discountDto: DiscountDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutdoorResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addDiscount(outdoorId, discountDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutdoorControllerApi.addDiscount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} outdoorId 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addOutdoorPictures(outdoorId: string, requestBody: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddPicturesResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addOutdoorPictures(outdoorId, requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutdoorControllerApi.addOutdoorPictures']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} placementProviderId 
         * @param {Array<WriteOutdoorRequestDto>} writeOutdoorRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createMultipleOutdoors(placementProviderId: string, writeOutdoorRequestDto: Array<WriteOutdoorRequestDto>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WriteOutdoorResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createMultipleOutdoors(placementProviderId, writeOutdoorRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutdoorControllerApi.createMultipleOutdoors']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create Outdoor
         * @param {string} placementProviderId 
         * @param {WriteOutdoorRequestDto} writeOutdoorRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOutdoor(placementProviderId: string, writeOutdoorRequestDto: WriteOutdoorRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WriteOutdoorResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOutdoor(placementProviderId, writeOutdoorRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutdoorControllerApi.createOutdoor']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Set<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteMultipleOutdoors(requestBody: Set<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteMultipleOutdoors(requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutdoorControllerApi.deleteMultipleOutdoors']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} outdoorId 
         * @param {Set<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOutdoorPictures(outdoorId: string, requestBody: Set<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutdoorResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOutdoorPictures(outdoorId, requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutdoorControllerApi.deleteOutdoorPictures']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get Outdoor
         * @param {string} outdoorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getById(outdoorId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutdoorResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getById(outdoorId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutdoorControllerApi.getById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get Outdoors by ID\'s
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getByIds(requestBody: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OutdoorResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getByIds(requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutdoorControllerApi.getByIds']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * To get Outdoors of Placement Provider
         * @param {string} placementProviderId 
         * @param {Pageable} page 
         * @param {string} [name] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getByPlacementProvider(placementProviderId: string, page: Pageable, name?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedOutdoorDtos>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getByPlacementProvider(placementProviderId, page, name, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutdoorControllerApi.getByPlacementProvider']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * To get, for each day from `from` to `to` (inclusive), whether the Placement Provider has bookings or blocked periods starting, finishing and running that day
         * @param {string} placementProviderId 
         * @param {string} from 
         * @param {string} to 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDailyStates(placementProviderId: string, from: string, to: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OutdoorDailyStateDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDailyStates(placementProviderId, from, to, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutdoorControllerApi.getDailyStates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * To get every distinct size (width and height, in metres) among a Placement Provider\'s Outdoors, smallest first
         * @param {string} placementProviderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDimensionsOfPlacementProvider(placementProviderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OutdoorDimensionsDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDimensionsOfPlacementProvider(placementProviderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutdoorControllerApi.getDimensionsOfPlacementProvider']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Each: the percentage off for a booking of more than that number of days - from the shortest booking. Empty when it has none.
         * @summary Get an Outdoor\'s discounts
         * @param {string} outdoorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDiscounts(outdoorId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OutdoorDiscountDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDiscounts(outdoorId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutdoorControllerApi.getDiscounts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * To get filters for Outdoors
         * @param {GetFiltersLanguageCodeEnum} [languageCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFilters(languageCode?: GetFiltersLanguageCodeEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FiltersDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFilters(languageCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutdoorControllerApi.getFilters']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * To get the Outdoors of a Placement Provider that are booked or blocked on a date, earliest start first (a blocked period has no campaignOutdoorId). Optionally narrowed by (part of) the Outdoor name, case-insensitive
         * @param {string} placementProviderId 
         * @param {string} date 
         * @param {string} [name] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOutdoorsByDate(placementProviderId: string, date: string, name?: string, page?: number, size?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedOutdoorsWithCampaignOutdoorDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOutdoorsByDate(placementProviderId, date, name, page, size, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutdoorControllerApi.getOutdoorsByDate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} outdoorId 
         * @param {string} discountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeDiscount(outdoorId: string, discountId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutdoorResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeDiscount(outdoorId, discountId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutdoorControllerApi.removeDiscount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} outdoorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeOutdoor(outdoorId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeOutdoor(outdoorId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutdoorControllerApi.removeOutdoor']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * To search a Placement Provider\'s own Outdoors by name, size (any of the given width and height pairs) and availability (free from availableFrom to availableTo - not booked by any active SCAPOW or OFFLINE Campaign, nor blocked)
         * @param {string} placementProviderId 
         * @param {Pageable} page 
         * @param {SearchPlacementProviderOutdoorsDto} searchPlacementProviderOutdoorsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchByPlacementProvider(placementProviderId: string, page: Pageable, searchPlacementProviderOutdoorsDto: SearchPlacementProviderOutdoorsDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedOutdoorDtos>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchByPlacementProvider(placementProviderId, page, searchPlacementProviderOutdoorsDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutdoorControllerApi.searchByPlacementProvider']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Sort} sort 
         * @param {SearchOutdoorRequestDto} searchOutdoorRequestDto 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchOutdoors(sort: Sort, searchOutdoorRequestDto: SearchOutdoorRequestDto, page?: number, size?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OutdoorProjectionDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchOutdoors(sort, searchOutdoorRequestDto, page, size, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutdoorControllerApi.searchOutdoors']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * To toggle accepting new campaign of an Outdoor
         * @param {string} outdoorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async toggleHiddenOutdoor(outdoorId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutdoorResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.toggleHiddenOutdoor(outdoorId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutdoorControllerApi.toggleHiddenOutdoor']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * To update accepting new campaigns of several Outdoors
         * @param {OutdoorAcceptingCampaignsDto} outdoorAcceptingCampaignsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAcceptingCampaignsByOutdoorIds(outdoorAcceptingCampaignsDto: OutdoorAcceptingCampaignsDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAcceptingCampaignsByOutdoorIds(outdoorAcceptingCampaignsDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutdoorControllerApi.updateAcceptingCampaignsByOutdoorIds']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update Outdoor
         * @param {string} outdoorId 
         * @param {WriteOutdoorRequestDto} writeOutdoorRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOutdoor(outdoorId: string, writeOutdoorRequestDto: WriteOutdoorRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WriteOutdoorResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOutdoor(outdoorId, writeOutdoorRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutdoorControllerApi.updateOutdoor']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OutdoorControllerApi - factory interface
 */
export const OutdoorControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OutdoorControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} outdoorId 
         * @param {DiscountDto} discountDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addDiscount(outdoorId: string, discountDto: DiscountDto, options?: RawAxiosRequestConfig): AxiosPromise<OutdoorResponseDto> {
            return localVarFp.addDiscount(outdoorId, discountDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} outdoorId 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addOutdoorPictures(outdoorId: string, requestBody: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<AddPicturesResponseDto> {
            return localVarFp.addOutdoorPictures(outdoorId, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} placementProviderId 
         * @param {Array<WriteOutdoorRequestDto>} writeOutdoorRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMultipleOutdoors(placementProviderId: string, writeOutdoorRequestDto: Array<WriteOutdoorRequestDto>, options?: RawAxiosRequestConfig): AxiosPromise<Array<WriteOutdoorResponseDto>> {
            return localVarFp.createMultipleOutdoors(placementProviderId, writeOutdoorRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Create Outdoor
         * @param {string} placementProviderId 
         * @param {WriteOutdoorRequestDto} writeOutdoorRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOutdoor(placementProviderId: string, writeOutdoorRequestDto: WriteOutdoorRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<WriteOutdoorResponseDto> {
            return localVarFp.createOutdoor(placementProviderId, writeOutdoorRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Set<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMultipleOutdoors(requestBody: Set<string>, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteMultipleOutdoors(requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} outdoorId 
         * @param {Set<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOutdoorPictures(outdoorId: string, requestBody: Set<string>, options?: RawAxiosRequestConfig): AxiosPromise<OutdoorResponseDto> {
            return localVarFp.deleteOutdoorPictures(outdoorId, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Get Outdoor
         * @param {string} outdoorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getById(outdoorId: string, options?: RawAxiosRequestConfig): AxiosPromise<OutdoorResponseDto> {
            return localVarFp.getById(outdoorId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get Outdoors by ID\'s
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByIds(requestBody: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<Array<OutdoorResponseDto>> {
            return localVarFp.getByIds(requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * To get Outdoors of Placement Provider
         * @param {string} placementProviderId 
         * @param {Pageable} page 
         * @param {string} [name] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByPlacementProvider(placementProviderId: string, page: Pageable, name?: string, options?: RawAxiosRequestConfig): AxiosPromise<PagedOutdoorDtos> {
            return localVarFp.getByPlacementProvider(placementProviderId, page, name, options).then((request) => request(axios, basePath));
        },
        /**
         * To get, for each day from `from` to `to` (inclusive), whether the Placement Provider has bookings or blocked periods starting, finishing and running that day
         * @param {string} placementProviderId 
         * @param {string} from 
         * @param {string} to 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDailyStates(placementProviderId: string, from: string, to: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<OutdoorDailyStateDto>> {
            return localVarFp.getDailyStates(placementProviderId, from, to, options).then((request) => request(axios, basePath));
        },
        /**
         * To get every distinct size (width and height, in metres) among a Placement Provider\'s Outdoors, smallest first
         * @param {string} placementProviderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDimensionsOfPlacementProvider(placementProviderId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<OutdoorDimensionsDto>> {
            return localVarFp.getDimensionsOfPlacementProvider(placementProviderId, options).then((request) => request(axios, basePath));
        },
        /**
         * Each: the percentage off for a booking of more than that number of days - from the shortest booking. Empty when it has none.
         * @summary Get an Outdoor\'s discounts
         * @param {string} outdoorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDiscounts(outdoorId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<OutdoorDiscountDto>> {
            return localVarFp.getDiscounts(outdoorId, options).then((request) => request(axios, basePath));
        },
        /**
         * To get filters for Outdoors
         * @param {GetFiltersLanguageCodeEnum} [languageCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFilters(languageCode?: GetFiltersLanguageCodeEnum, options?: RawAxiosRequestConfig): AxiosPromise<FiltersDto> {
            return localVarFp.getFilters(languageCode, options).then((request) => request(axios, basePath));
        },
        /**
         * To get the Outdoors of a Placement Provider that are booked or blocked on a date, earliest start first (a blocked period has no campaignOutdoorId). Optionally narrowed by (part of) the Outdoor name, case-insensitive
         * @param {string} placementProviderId 
         * @param {string} date 
         * @param {string} [name] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOutdoorsByDate(placementProviderId: string, date: string, name?: string, page?: number, size?: number, options?: RawAxiosRequestConfig): AxiosPromise<PagedOutdoorsWithCampaignOutdoorDto> {
            return localVarFp.getOutdoorsByDate(placementProviderId, date, name, page, size, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} outdoorId 
         * @param {string} discountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeDiscount(outdoorId: string, discountId: string, options?: RawAxiosRequestConfig): AxiosPromise<OutdoorResponseDto> {
            return localVarFp.removeDiscount(outdoorId, discountId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} outdoorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeOutdoor(outdoorId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.removeOutdoor(outdoorId, options).then((request) => request(axios, basePath));
        },
        /**
         * To search a Placement Provider\'s own Outdoors by name, size (any of the given width and height pairs) and availability (free from availableFrom to availableTo - not booked by any active SCAPOW or OFFLINE Campaign, nor blocked)
         * @param {string} placementProviderId 
         * @param {Pageable} page 
         * @param {SearchPlacementProviderOutdoorsDto} searchPlacementProviderOutdoorsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchByPlacementProvider(placementProviderId: string, page: Pageable, searchPlacementProviderOutdoorsDto: SearchPlacementProviderOutdoorsDto, options?: RawAxiosRequestConfig): AxiosPromise<PagedOutdoorDtos> {
            return localVarFp.searchByPlacementProvider(placementProviderId, page, searchPlacementProviderOutdoorsDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Sort} sort 
         * @param {SearchOutdoorRequestDto} searchOutdoorRequestDto 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchOutdoors(sort: Sort, searchOutdoorRequestDto: SearchOutdoorRequestDto, page?: number, size?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<OutdoorProjectionDto>> {
            return localVarFp.searchOutdoors(sort, searchOutdoorRequestDto, page, size, options).then((request) => request(axios, basePath));
        },
        /**
         * To toggle accepting new campaign of an Outdoor
         * @param {string} outdoorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleHiddenOutdoor(outdoorId: string, options?: RawAxiosRequestConfig): AxiosPromise<OutdoorResponseDto> {
            return localVarFp.toggleHiddenOutdoor(outdoorId, options).then((request) => request(axios, basePath));
        },
        /**
         * To update accepting new campaigns of several Outdoors
         * @param {OutdoorAcceptingCampaignsDto} outdoorAcceptingCampaignsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAcceptingCampaignsByOutdoorIds(outdoorAcceptingCampaignsDto: OutdoorAcceptingCampaignsDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateAcceptingCampaignsByOutdoorIds(outdoorAcceptingCampaignsDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Update Outdoor
         * @param {string} outdoorId 
         * @param {WriteOutdoorRequestDto} writeOutdoorRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOutdoor(outdoorId: string, writeOutdoorRequestDto: WriteOutdoorRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<WriteOutdoorResponseDto> {
            return localVarFp.updateOutdoor(outdoorId, writeOutdoorRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OutdoorControllerApi - object-oriented interface
 */
export class OutdoorControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} outdoorId 
     * @param {DiscountDto} discountDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public addDiscount(outdoorId: string, discountDto: DiscountDto, options?: RawAxiosRequestConfig) {
        return OutdoorControllerApiFp(this.configuration).addDiscount(outdoorId, discountDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} outdoorId 
     * @param {Array<string>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public addOutdoorPictures(outdoorId: string, requestBody: Array<string>, options?: RawAxiosRequestConfig) {
        return OutdoorControllerApiFp(this.configuration).addOutdoorPictures(outdoorId, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} placementProviderId 
     * @param {Array<WriteOutdoorRequestDto>} writeOutdoorRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createMultipleOutdoors(placementProviderId: string, writeOutdoorRequestDto: Array<WriteOutdoorRequestDto>, options?: RawAxiosRequestConfig) {
        return OutdoorControllerApiFp(this.configuration).createMultipleOutdoors(placementProviderId, writeOutdoorRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create Outdoor
     * @param {string} placementProviderId 
     * @param {WriteOutdoorRequestDto} writeOutdoorRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createOutdoor(placementProviderId: string, writeOutdoorRequestDto: WriteOutdoorRequestDto, options?: RawAxiosRequestConfig) {
        return OutdoorControllerApiFp(this.configuration).createOutdoor(placementProviderId, writeOutdoorRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Set<string>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteMultipleOutdoors(requestBody: Set<string>, options?: RawAxiosRequestConfig) {
        return OutdoorControllerApiFp(this.configuration).deleteMultipleOutdoors(requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} outdoorId 
     * @param {Set<string>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteOutdoorPictures(outdoorId: string, requestBody: Set<string>, options?: RawAxiosRequestConfig) {
        return OutdoorControllerApiFp(this.configuration).deleteOutdoorPictures(outdoorId, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get Outdoor
     * @param {string} outdoorId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getById(outdoorId: string, options?: RawAxiosRequestConfig) {
        return OutdoorControllerApiFp(this.configuration).getById(outdoorId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get Outdoors by ID\'s
     * @param {Array<string>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getByIds(requestBody: Array<string>, options?: RawAxiosRequestConfig) {
        return OutdoorControllerApiFp(this.configuration).getByIds(requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * To get Outdoors of Placement Provider
     * @param {string} placementProviderId 
     * @param {Pageable} page 
     * @param {string} [name] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getByPlacementProvider(placementProviderId: string, page: Pageable, name?: string, options?: RawAxiosRequestConfig) {
        return OutdoorControllerApiFp(this.configuration).getByPlacementProvider(placementProviderId, page, name, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * To get, for each day from `from` to `to` (inclusive), whether the Placement Provider has bookings or blocked periods starting, finishing and running that day
     * @param {string} placementProviderId 
     * @param {string} from 
     * @param {string} to 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getDailyStates(placementProviderId: string, from: string, to: string, options?: RawAxiosRequestConfig) {
        return OutdoorControllerApiFp(this.configuration).getDailyStates(placementProviderId, from, to, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * To get every distinct size (width and height, in metres) among a Placement Provider\'s Outdoors, smallest first
     * @param {string} placementProviderId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getDimensionsOfPlacementProvider(placementProviderId: string, options?: RawAxiosRequestConfig) {
        return OutdoorControllerApiFp(this.configuration).getDimensionsOfPlacementProvider(placementProviderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Each: the percentage off for a booking of more than that number of days - from the shortest booking. Empty when it has none.
     * @summary Get an Outdoor\'s discounts
     * @param {string} outdoorId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getDiscounts(outdoorId: string, options?: RawAxiosRequestConfig) {
        return OutdoorControllerApiFp(this.configuration).getDiscounts(outdoorId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * To get filters for Outdoors
     * @param {GetFiltersLanguageCodeEnum} [languageCode] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getFilters(languageCode?: GetFiltersLanguageCodeEnum, options?: RawAxiosRequestConfig) {
        return OutdoorControllerApiFp(this.configuration).getFilters(languageCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * To get the Outdoors of a Placement Provider that are booked or blocked on a date, earliest start first (a blocked period has no campaignOutdoorId). Optionally narrowed by (part of) the Outdoor name, case-insensitive
     * @param {string} placementProviderId 
     * @param {string} date 
     * @param {string} [name] 
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getOutdoorsByDate(placementProviderId: string, date: string, name?: string, page?: number, size?: number, options?: RawAxiosRequestConfig) {
        return OutdoorControllerApiFp(this.configuration).getOutdoorsByDate(placementProviderId, date, name, page, size, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} outdoorId 
     * @param {string} discountId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public removeDiscount(outdoorId: string, discountId: string, options?: RawAxiosRequestConfig) {
        return OutdoorControllerApiFp(this.configuration).removeDiscount(outdoorId, discountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} outdoorId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public removeOutdoor(outdoorId: string, options?: RawAxiosRequestConfig) {
        return OutdoorControllerApiFp(this.configuration).removeOutdoor(outdoorId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * To search a Placement Provider\'s own Outdoors by name, size (any of the given width and height pairs) and availability (free from availableFrom to availableTo - not booked by any active SCAPOW or OFFLINE Campaign, nor blocked)
     * @param {string} placementProviderId 
     * @param {Pageable} page 
     * @param {SearchPlacementProviderOutdoorsDto} searchPlacementProviderOutdoorsDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchByPlacementProvider(placementProviderId: string, page: Pageable, searchPlacementProviderOutdoorsDto: SearchPlacementProviderOutdoorsDto, options?: RawAxiosRequestConfig) {
        return OutdoorControllerApiFp(this.configuration).searchByPlacementProvider(placementProviderId, page, searchPlacementProviderOutdoorsDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Sort} sort 
     * @param {SearchOutdoorRequestDto} searchOutdoorRequestDto 
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchOutdoors(sort: Sort, searchOutdoorRequestDto: SearchOutdoorRequestDto, page?: number, size?: number, options?: RawAxiosRequestConfig) {
        return OutdoorControllerApiFp(this.configuration).searchOutdoors(sort, searchOutdoorRequestDto, page, size, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * To toggle accepting new campaign of an Outdoor
     * @param {string} outdoorId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public toggleHiddenOutdoor(outdoorId: string, options?: RawAxiosRequestConfig) {
        return OutdoorControllerApiFp(this.configuration).toggleHiddenOutdoor(outdoorId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * To update accepting new campaigns of several Outdoors
     * @param {OutdoorAcceptingCampaignsDto} outdoorAcceptingCampaignsDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateAcceptingCampaignsByOutdoorIds(outdoorAcceptingCampaignsDto: OutdoorAcceptingCampaignsDto, options?: RawAxiosRequestConfig) {
        return OutdoorControllerApiFp(this.configuration).updateAcceptingCampaignsByOutdoorIds(outdoorAcceptingCampaignsDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update Outdoor
     * @param {string} outdoorId 
     * @param {WriteOutdoorRequestDto} writeOutdoorRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateOutdoor(outdoorId: string, writeOutdoorRequestDto: WriteOutdoorRequestDto, options?: RawAxiosRequestConfig) {
        return OutdoorControllerApiFp(this.configuration).updateOutdoor(outdoorId, writeOutdoorRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}

export const GetFiltersLanguageCodeEnum = {
    Pt: 'PT',
    En: 'EN',
    Es: 'ES',
    Fr: 'FR',
    It: 'IT',
    Cn: 'CN',
    Jp: 'JP',
} as const;
export type GetFiltersLanguageCodeEnum = typeof GetFiltersLanguageCodeEnum[keyof typeof GetFiltersLanguageCodeEnum];


/**
 * PaymentsEndpointsApi - axios parameter creator
 */
export const PaymentsEndpointsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Searching for Business Entity payments
         * @param {string} businessEntityId 
         * @param {Pageable} page 
         * @param {Set<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchByBusinessEntity: async (businessEntityId: string, page: Pageable, requestBody: Set<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessEntityId' is not null or undefined
            assertParamExists('searchByBusinessEntity', 'businessEntityId', businessEntityId)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('searchByBusinessEntity', 'page', page)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('searchByBusinessEntity', 'requestBody', requestBody)
            const localVarPath = `/api/v1/payments/{businessEntityId}/search`
                .replace('{businessEntityId}', encodeURIComponent(String(businessEntityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                for (const [key, value] of Object.entries(page)) {
                    localVarQueryParameter[key] = value;
                }
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PaymentsEndpointsApi - functional programming interface
 */
export const PaymentsEndpointsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PaymentsEndpointsApiAxiosParamCreator(configuration)
    return {
        /**
         * Searching for Business Entity payments
         * @param {string} businessEntityId 
         * @param {Pageable} page 
         * @param {Set<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchByBusinessEntity(businessEntityId: string, page: Pageable, requestBody: Set<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedPaymentsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchByBusinessEntity(businessEntityId, page, requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentsEndpointsApi.searchByBusinessEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PaymentsEndpointsApi - factory interface
 */
export const PaymentsEndpointsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PaymentsEndpointsApiFp(configuration)
    return {
        /**
         * Searching for Business Entity payments
         * @param {string} businessEntityId 
         * @param {Pageable} page 
         * @param {Set<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchByBusinessEntity(businessEntityId: string, page: Pageable, requestBody: Set<string>, options?: RawAxiosRequestConfig): AxiosPromise<PagedPaymentsResponse> {
            return localVarFp.searchByBusinessEntity(businessEntityId, page, requestBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PaymentsEndpointsApi - object-oriented interface
 */
export class PaymentsEndpointsApi extends BaseAPI {
    /**
     * Searching for Business Entity payments
     * @param {string} businessEntityId 
     * @param {Pageable} page 
     * @param {Set<string>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchByBusinessEntity(businessEntityId: string, page: Pageable, requestBody: Set<string>, options?: RawAxiosRequestConfig) {
        return PaymentsEndpointsApiFp(this.configuration).searchByBusinessEntity(businessEntityId, page, requestBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SectionViewsStatesApi - axios parameter creator
 */
export const SectionViewsStatesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get section news by Business Entity
         * @param {string} businessEntityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByBusinessEntity: async (businessEntityId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessEntityId' is not null or undefined
            assertParamExists('getByBusinessEntity', 'businessEntityId', businessEntityId)
            const localVarPath = `/api/v1/section-views/{businessEntityId}`
                .replace('{businessEntityId}', encodeURIComponent(String(businessEntityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Mark specific Campaigns as checked within a section, without affecting any other still-new Campaign in that section
         * @param {string} businessEntityId 
         * @param {MarkCampaignsAsCheckedSectionTypeEnum} sectionType 
         * @param {Set<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markCampaignsAsChecked: async (businessEntityId: string, sectionType: MarkCampaignsAsCheckedSectionTypeEnum, requestBody: Set<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessEntityId' is not null or undefined
            assertParamExists('markCampaignsAsChecked', 'businessEntityId', businessEntityId)
            // verify required parameter 'sectionType' is not null or undefined
            assertParamExists('markCampaignsAsChecked', 'sectionType', sectionType)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('markCampaignsAsChecked', 'requestBody', requestBody)
            const localVarPath = `/api/v1/section-views/{businessEntityId}/sections/{sectionType}/campaigns/checked`
                .replace('{businessEntityId}', encodeURIComponent(String(businessEntityId)))
                .replace('{sectionType}', encodeURIComponent(String(sectionType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Mark a section as seen
         * @param {string} businessEntityId 
         * @param {MarkSectionAsSeenSectionTypeEnum} sectionType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markSectionAsSeen: async (businessEntityId: string, sectionType: MarkSectionAsSeenSectionTypeEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessEntityId' is not null or undefined
            assertParamExists('markSectionAsSeen', 'businessEntityId', businessEntityId)
            // verify required parameter 'sectionType' is not null or undefined
            assertParamExists('markSectionAsSeen', 'sectionType', sectionType)
            const localVarPath = `/api/v1/section-views/{businessEntityId}/sections/{sectionType}/seen`
                .replace('{businessEntityId}', encodeURIComponent(String(businessEntityId)))
                .replace('{sectionType}', encodeURIComponent(String(sectionType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SectionViewsStatesApi - functional programming interface
 */
export const SectionViewsStatesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SectionViewsStatesApiAxiosParamCreator(configuration)
    return {
        /**
         * Get section news by Business Entity
         * @param {string} businessEntityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getByBusinessEntity(businessEntityId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SectionViewDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getByBusinessEntity(businessEntityId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SectionViewsStatesApi.getByBusinessEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Mark specific Campaigns as checked within a section, without affecting any other still-new Campaign in that section
         * @param {string} businessEntityId 
         * @param {MarkCampaignsAsCheckedSectionTypeEnum} sectionType 
         * @param {Set<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markCampaignsAsChecked(businessEntityId: string, sectionType: MarkCampaignsAsCheckedSectionTypeEnum, requestBody: Set<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markCampaignsAsChecked(businessEntityId, sectionType, requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SectionViewsStatesApi.markCampaignsAsChecked']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Mark a section as seen
         * @param {string} businessEntityId 
         * @param {MarkSectionAsSeenSectionTypeEnum} sectionType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markSectionAsSeen(businessEntityId: string, sectionType: MarkSectionAsSeenSectionTypeEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markSectionAsSeen(businessEntityId, sectionType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SectionViewsStatesApi.markSectionAsSeen']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SectionViewsStatesApi - factory interface
 */
export const SectionViewsStatesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SectionViewsStatesApiFp(configuration)
    return {
        /**
         * Get section news by Business Entity
         * @param {string} businessEntityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByBusinessEntity(businessEntityId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<SectionViewDto>> {
            return localVarFp.getByBusinessEntity(businessEntityId, options).then((request) => request(axios, basePath));
        },
        /**
         * Mark specific Campaigns as checked within a section, without affecting any other still-new Campaign in that section
         * @param {string} businessEntityId 
         * @param {MarkCampaignsAsCheckedSectionTypeEnum} sectionType 
         * @param {Set<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markCampaignsAsChecked(businessEntityId: string, sectionType: MarkCampaignsAsCheckedSectionTypeEnum, requestBody: Set<string>, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.markCampaignsAsChecked(businessEntityId, sectionType, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Mark a section as seen
         * @param {string} businessEntityId 
         * @param {MarkSectionAsSeenSectionTypeEnum} sectionType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markSectionAsSeen(businessEntityId: string, sectionType: MarkSectionAsSeenSectionTypeEnum, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.markSectionAsSeen(businessEntityId, sectionType, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SectionViewsStatesApi - object-oriented interface
 */
export class SectionViewsStatesApi extends BaseAPI {
    /**
     * Get section news by Business Entity
     * @param {string} businessEntityId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getByBusinessEntity(businessEntityId: string, options?: RawAxiosRequestConfig) {
        return SectionViewsStatesApiFp(this.configuration).getByBusinessEntity(businessEntityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Mark specific Campaigns as checked within a section, without affecting any other still-new Campaign in that section
     * @param {string} businessEntityId 
     * @param {MarkCampaignsAsCheckedSectionTypeEnum} sectionType 
     * @param {Set<string>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public markCampaignsAsChecked(businessEntityId: string, sectionType: MarkCampaignsAsCheckedSectionTypeEnum, requestBody: Set<string>, options?: RawAxiosRequestConfig) {
        return SectionViewsStatesApiFp(this.configuration).markCampaignsAsChecked(businessEntityId, sectionType, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Mark a section as seen
     * @param {string} businessEntityId 
     * @param {MarkSectionAsSeenSectionTypeEnum} sectionType 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public markSectionAsSeen(businessEntityId: string, sectionType: MarkSectionAsSeenSectionTypeEnum, options?: RawAxiosRequestConfig) {
        return SectionViewsStatesApiFp(this.configuration).markSectionAsSeen(businessEntityId, sectionType, options).then((request) => request(this.axios, this.basePath));
    }
}

export const MarkCampaignsAsCheckedSectionTypeEnum = {
    ReadyCampaigns: 'READY_CAMPAIGNS',
    RunningCampaigns: 'RUNNING_CAMPAIGNS',
    VerifiedCampaignOutdoor: 'VERIFIED_CAMPAIGN_OUTDOOR',
    MessagesReceived: 'MESSAGES_RECEIVED',
} as const;
export type MarkCampaignsAsCheckedSectionTypeEnum = typeof MarkCampaignsAsCheckedSectionTypeEnum[keyof typeof MarkCampaignsAsCheckedSectionTypeEnum];
export const MarkSectionAsSeenSectionTypeEnum = {
    ReadyCampaigns: 'READY_CAMPAIGNS',
    RunningCampaigns: 'RUNNING_CAMPAIGNS',
    VerifiedCampaignOutdoor: 'VERIFIED_CAMPAIGN_OUTDOOR',
    MessagesReceived: 'MESSAGES_RECEIVED',
} as const;
export type MarkSectionAsSeenSectionTypeEnum = typeof MarkSectionAsSeenSectionTypeEnum[keyof typeof MarkSectionAsSeenSectionTypeEnum];


/**
 * StripeWebhookApi - axios parameter creator
 */
export const StripeWebhookApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} stripeSignature 
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleWebhook1: async (stripeSignature: string, body: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stripeSignature' is not null or undefined
            assertParamExists('handleWebhook1', 'stripeSignature', stripeSignature)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('handleWebhook1', 'body', body)
            const localVarPath = `/api/v1/webhooks/stripe`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            if (stripeSignature != null) {
                localVarHeaderParameter['Stripe-Signature'] = String(stripeSignature);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StripeWebhookApi - functional programming interface
 */
export const StripeWebhookApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StripeWebhookApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} stripeSignature 
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async handleWebhook1(stripeSignature: string, body: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.handleWebhook1(stripeSignature, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StripeWebhookApi.handleWebhook1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * StripeWebhookApi - factory interface
 */
export const StripeWebhookApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StripeWebhookApiFp(configuration)
    return {
        /**
         * 
         * @param {string} stripeSignature 
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleWebhook1(stripeSignature: string, body: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.handleWebhook1(stripeSignature, body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StripeWebhookApi - object-oriented interface
 */
export class StripeWebhookApi extends BaseAPI {
    /**
     * 
     * @param {string} stripeSignature 
     * @param {string} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public handleWebhook1(stripeSignature: string, body: string, options?: RawAxiosRequestConfig) {
        return StripeWebhookApiFp(this.configuration).handleWebhook1(stripeSignature, body, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UserControllerApi - axios parameter creator
 */
export const UserControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * To create User
         * @param {CreateUserRequest} createUserRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUser: async (createUserRequest: CreateUserRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createUserRequest' is not null or undefined
            assertParamExists('createUser', 'createUserRequest', createUserRequest)
            const localVarPath = `/api/v1/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createUserRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * To get user info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserInfo: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/users/info`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * To request user verification
         * @param {VerificationRequest} verificationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestNewVerification: async (verificationRequest: VerificationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'verificationRequest' is not null or undefined
            assertParamExists('requestNewVerification', 'verificationRequest', verificationRequest)
            const localVarPath = `/api/v1/users/verify`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(verificationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * To request password reset
         * @param {RequestResetPasswordDto} requestResetPasswordDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestPasswordReset: async (requestResetPasswordDto: RequestResetPasswordDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestResetPasswordDto' is not null or undefined
            assertParamExists('requestPasswordReset', 'requestResetPasswordDto', requestResetPasswordDto)
            const localVarPath = `/api/v1/users/request-password-reset`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestResetPasswordDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * To reset password
         * @param {string} userId 
         * @param {string} passwordResetId 
         * @param {ResetPasswordDto} resetPasswordDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPassword: async (userId: string, passwordResetId: string, resetPasswordDto: ResetPasswordDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('resetPassword', 'userId', userId)
            // verify required parameter 'passwordResetId' is not null or undefined
            assertParamExists('resetPassword', 'passwordResetId', passwordResetId)
            // verify required parameter 'resetPasswordDto' is not null or undefined
            assertParamExists('resetPassword', 'resetPasswordDto', resetPasswordDto)
            const localVarPath = `/api/v1/users/{userId}/reset-password/{passwordResetId}`
                .replace('{userId}', encodeURIComponent(String(userId)))
                .replace('{passwordResetId}', encodeURIComponent(String(passwordResetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resetPasswordDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * To update User
         * @param {string} id 
         * @param {UpdateUserRequest} updateUserRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUser: async (id: string, updateUserRequest: UpdateUserRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateUser', 'id', id)
            // verify required parameter 'updateUserRequest' is not null or undefined
            assertParamExists('updateUser', 'updateUserRequest', updateUserRequest)
            const localVarPath = `/api/v1/users/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUserRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * To verify account
         * @param {string} verificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyUser: async (verificationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'verificationId' is not null or undefined
            assertParamExists('verifyUser', 'verificationId', verificationId)
            const localVarPath = `/api/v1/users/verify/{verificationId}`
                .replace('{verificationId}', encodeURIComponent(String(verificationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserControllerApi - functional programming interface
 */
export const UserControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * To create User
         * @param {CreateUserRequest} createUserRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createUser(createUserRequest: CreateUserRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createUser(createUserRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserControllerApi.createUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * To get user info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserInfo(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserInfo(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserControllerApi.getUserInfo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * To request user verification
         * @param {VerificationRequest} verificationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestNewVerification(verificationRequest: VerificationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestNewVerification(verificationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserControllerApi.requestNewVerification']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * To request password reset
         * @param {RequestResetPasswordDto} requestResetPasswordDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestPasswordReset(requestResetPasswordDto: RequestResetPasswordDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestPasswordReset(requestResetPasswordDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserControllerApi.requestPasswordReset']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * To reset password
         * @param {string} userId 
         * @param {string} passwordResetId 
         * @param {ResetPasswordDto} resetPasswordDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resetPassword(userId: string, passwordResetId: string, resetPasswordDto: ResetPasswordDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resetPassword(userId, passwordResetId, resetPasswordDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserControllerApi.resetPassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * To update User
         * @param {string} id 
         * @param {UpdateUserRequest} updateUserRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUser(id: string, updateUserRequest: UpdateUserRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUser(id, updateUserRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserControllerApi.updateUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * To verify account
         * @param {string} verificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifyUser(verificationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verifyUser(verificationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserControllerApi.verifyUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UserControllerApi - factory interface
 */
export const UserControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserControllerApiFp(configuration)
    return {
        /**
         * To create User
         * @param {CreateUserRequest} createUserRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUser(createUserRequest: CreateUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserResponseDto> {
            return localVarFp.createUser(createUserRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * To get user info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserInfo(options?: RawAxiosRequestConfig): AxiosPromise<UserResponseDto> {
            return localVarFp.getUserInfo(options).then((request) => request(axios, basePath));
        },
        /**
         * To request user verification
         * @param {VerificationRequest} verificationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestNewVerification(verificationRequest: VerificationRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.requestNewVerification(verificationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * To request password reset
         * @param {RequestResetPasswordDto} requestResetPasswordDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestPasswordReset(requestResetPasswordDto: RequestResetPasswordDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.requestPasswordReset(requestResetPasswordDto, options).then((request) => request(axios, basePath));
        },
        /**
         * To reset password
         * @param {string} userId 
         * @param {string} passwordResetId 
         * @param {ResetPasswordDto} resetPasswordDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPassword(userId: string, passwordResetId: string, resetPasswordDto: ResetPasswordDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.resetPassword(userId, passwordResetId, resetPasswordDto, options).then((request) => request(axios, basePath));
        },
        /**
         * To update User
         * @param {string} id 
         * @param {UpdateUserRequest} updateUserRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUser(id: string, updateUserRequest: UpdateUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserResponseDto> {
            return localVarFp.updateUser(id, updateUserRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * To verify account
         * @param {string} verificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyUser(verificationId: string, options?: RawAxiosRequestConfig): AxiosPromise<UserResponseDto> {
            return localVarFp.verifyUser(verificationId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserControllerApi - object-oriented interface
 */
export class UserControllerApi extends BaseAPI {
    /**
     * To create User
     * @param {CreateUserRequest} createUserRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createUser(createUserRequest: CreateUserRequest, options?: RawAxiosRequestConfig) {
        return UserControllerApiFp(this.configuration).createUser(createUserRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * To get user info
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getUserInfo(options?: RawAxiosRequestConfig) {
        return UserControllerApiFp(this.configuration).getUserInfo(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * To request user verification
     * @param {VerificationRequest} verificationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public requestNewVerification(verificationRequest: VerificationRequest, options?: RawAxiosRequestConfig) {
        return UserControllerApiFp(this.configuration).requestNewVerification(verificationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * To request password reset
     * @param {RequestResetPasswordDto} requestResetPasswordDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public requestPasswordReset(requestResetPasswordDto: RequestResetPasswordDto, options?: RawAxiosRequestConfig) {
        return UserControllerApiFp(this.configuration).requestPasswordReset(requestResetPasswordDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * To reset password
     * @param {string} userId 
     * @param {string} passwordResetId 
     * @param {ResetPasswordDto} resetPasswordDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public resetPassword(userId: string, passwordResetId: string, resetPasswordDto: ResetPasswordDto, options?: RawAxiosRequestConfig) {
        return UserControllerApiFp(this.configuration).resetPassword(userId, passwordResetId, resetPasswordDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * To update User
     * @param {string} id 
     * @param {UpdateUserRequest} updateUserRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateUser(id: string, updateUserRequest: UpdateUserRequest, options?: RawAxiosRequestConfig) {
        return UserControllerApiFp(this.configuration).updateUser(id, updateUserRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * To verify account
     * @param {string} verificationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public verifyUser(verificationId: string, options?: RawAxiosRequestConfig) {
        return UserControllerApiFp(this.configuration).verifyUser(verificationId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * WiseTransfersWebhookApi - axios parameter creator
 */
export const WiseTransfersWebhookApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} xSignatureSHA256 
         * @param {string} body 
         * @param {boolean} [xTestNotification] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleWebhook: async (xSignatureSHA256: string, body: string, xTestNotification?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xSignatureSHA256' is not null or undefined
            assertParamExists('handleWebhook', 'xSignatureSHA256', xSignatureSHA256)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('handleWebhook', 'body', body)
            const localVarPath = `/api/v1/webhooks/wise-transfers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            if (xSignatureSHA256 != null) {
                localVarHeaderParameter['X-Signature-SHA256'] = String(xSignatureSHA256);
            }
            if (xTestNotification != null) {
                localVarHeaderParameter['X-Test-Notification'] = typeof xTestNotification === 'string'
                    ? xTestNotification
                    : JSON.stringify(xTestNotification, replaceWithSerializableTypeIfNeeded);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WiseTransfersWebhookApi - functional programming interface
 */
export const WiseTransfersWebhookApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WiseTransfersWebhookApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} xSignatureSHA256 
         * @param {string} body 
         * @param {boolean} [xTestNotification] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async handleWebhook(xSignatureSHA256: string, body: string, xTestNotification?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.handleWebhook(xSignatureSHA256, body, xTestNotification, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WiseTransfersWebhookApi.handleWebhook']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WiseTransfersWebhookApi - factory interface
 */
export const WiseTransfersWebhookApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WiseTransfersWebhookApiFp(configuration)
    return {
        /**
         * 
         * @param {string} xSignatureSHA256 
         * @param {string} body 
         * @param {boolean} [xTestNotification] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleWebhook(xSignatureSHA256: string, body: string, xTestNotification?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.handleWebhook(xSignatureSHA256, body, xTestNotification, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WiseTransfersWebhookApi - object-oriented interface
 */
export class WiseTransfersWebhookApi extends BaseAPI {
    /**
     * 
     * @param {string} xSignatureSHA256 
     * @param {string} body 
     * @param {boolean} [xTestNotification] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public handleWebhook(xSignatureSHA256: string, body: string, xTestNotification?: boolean, options?: RawAxiosRequestConfig) {
        return WiseTransfersWebhookApiFp(this.configuration).handleWebhook(xSignatureSHA256, body, xTestNotification, options).then((request) => request(this.axios, this.basePath));
    }
}



